import React, { useRef, useEffect, useState, useMemo, useCallback } from "react";
import {
  Box,
  Chip,
  Collapse,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Dropzone, { ExtendedFile } from "../../common/Dropzone";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
  useCodetablesSlice,
  getCodeTableValuesByTableName,
  CodeTable,
  fetchAllCodeTablesValues,
} from "../../../redux/slice/codetableSlice";
import { Controller, useForm } from "react-hook-form";
import {
  AddCircleOutlineOutlined,
  CloseOutlined,
  DeleteOutlineOutlined,
  ExitToApp,
  ExpandLess,
  ExpandMore,
  ModeOutlined,
  SaveOutlined,
  ArrowBack,
  AssignmentTurnedInOutlined,
  DescriptionOutlined,
  HealthAndSafetyOutlined,
  AttachFileOutlined,
  ContentPasteOutlined,
  HelpOutlineOutlined,
  StickyNote2Outlined,
  QuizOutlined,
  PersonOutlineOutlined
} from "@mui/icons-material";
import CustomRadioButton from "../../common/CustomRadioButton";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import Button from "../../common/Button";
import PageBackButton from "../../common/PageBackButton";
import CustomNametField from "../../common/CustomNametField";
import CustomDatePicker from "../../common/CustomDatePicker";
import CustomTextField from "../../common/CustomTextField";
import CustomTable from "../../common/CustomTable";
import IVRFormWoundInfoPopup from "./IVRFormWoundInfoPopup";
import CustomAlert from "../../common/CustomAlert";
import CustomCheckbox from "../../common/CustomCheckBox";
import { useModalStyles } from "../../common/useModalStyles";
import { SectionHeader } from "../../ui/ContentSection";
import {
  SingleAlertInfo,
  fetchAllPayers,
  setSingleAlertObj,
  showHideLoadingDialog,
  useCommonReducer,
} from "../../../redux/slice/commonSlice";
import {
  fetchProductItemByProductItemId,
  fetchProductItemBySKU,
  fetchProductItemsByProductId,
  resetProductItems
} from "../../../redux/slice/product/productListSlice";
import StickTopStepper from "../../common/StickTopStepper";
import LegacyToolBar from "../../common/LegacyToolBar";
import {
  getPatient,
  getPatientListByPracticeId,
  getSurgicalTemplateByTemplateId,
  resetProviderTemplate,
  saveWoundInfo,
  SaveWoundInfoRequest,
  SurgicalTemplateJSON,
  updatePatientObjectReducer,
  usePatientReducer,
} from "../../../redux/slice/patient/patientSlice";
import { formatDate, formatWoundName, fullName } from "../../../utils/Utility";
import { INVALID_MBI_MESSAGE, isValidMedicareMbi } from "../../../utils/medicareMbi";
import { fetchPracticeProductsDataUsingDateOfServiceAndProvider, FetchPracticeProductsParams } from "../../../redux/slice/practice/practiceProductSlice";
import {
  fetchActivePracticeProvidersData,
  usePracticeProvidersSlice,
} from "../../../redux/slice/practice/practiceProvidersSlice";
import {
  fetchActivePracticeLocationsData,
  usePracticeLocationsSlice,
} from "../../../redux/slice/practice/practiceLocationSlice";
import {
  fetchDocumentById,
  getPracticesByUserRole,
  usePracticeSlice,
} from "../../../redux/slice/practiceSlice";
import {
  IVRFetchObjectInfo,
  IVRFetchObjectInfoWithInfoTypeData,
  IVRObjectInfo,
  Product,
  ProductListWithItems,
  fetchIVRById,
  resetIVRData,
  saveIVRData,
  submitIVR,
  useCreateIVRSlice,
} from "../../../redux/slice/ivr/createIVRSlice";
import moment from "moment";
import {
  IVRDocumentInfo,
  removeIVRDocument,
  uploadIVRDocument,
} from "../../../redux/slice/ivr/ivrDocumentSlice";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import { fetchPracticeByIdData } from "../../../redux/slice/practice/practiceEditSlice";
import { PracticeInfo } from "../../../redux/slice/practice/practiceRegistrationSlice";
import { fetchAllWoundCodes, getWoundCodeValuesByWoundCodeType, useWoundCodesSlice } from "../../../redux/slice/ivr/woundCodeSlice";
import CustomIconButton from "../../common/CustomIconButton";
import Cookies from "js-cookie";
import { removeDataFromCookies } from "../../../utils/StorageUtils";
import { fetchSecurityTokens } from "../../../redux/slice/userSlice";
import { CAN_ACCESS_APPLICATION, PATIENT_IVR_INFO_TYPES, PRACTICE_TYPE, PRODUCT_CATEGORY, providerRoleId } from "../../../constants/applicationConstants";
import SigantureSubmitPopup from "../orders/SignatureSubmitPopup";
import { tokens } from "../../../theme";
import CustomHelpMessage from "../../common/CustomHelpMessage";
import CustomNumberField from "../../common/CustomNumberField";
import { getProductItemkitItem, getProductQuestions, getSafeguardQuestions, resetCreateProductSlice, resetProductQuestions, resetSafeguardQuestions, updateElementInProductSlice, useProductReducer } from "../../../redux/slice/product/createProductSlice";
import QuestionComponent from "./QuestionComponent";
import { useNavigation } from "../../../hooks/useNavigation";
import { Option } from "../../../redux/slice/agency/AgencySlice";
import ProductItemSelectPopup from "./ProductItemSelectPopup";
import IVRFormIncisionInfoPopup from "./IVRFormIncisionInfoPopup";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsValueFoundInToken } from "../../../redux/slice/authSlice";

export interface WoundInfo {
  checkboxes?: JSX.Element;
  woundType: string;
  procedureLocation?: string;
  noOfApplications: string;
  cpt: string;
  cptIds: number[];
  eCode: string;
  eCodeIds: number[];
  iCode: string;
  iCodeIds: number[];
  lCode: string;
  lCodeIds: number[];
  icd10: string;
  icdIds: number[];
  otherDxCodes: string;
  length: number;
  width: number;
  depth: number;
  totalSize: number | string;
  displayTotalSize?: any;
  displayWoundDimensions?: any;
  displayEstimateSurfaceArea?: any;
  displayTotalWoundVolume?: any;
  woundInfoKey?: string;
  incisionMeasurement?: string;
  surgicalIncision?: string;
  exudateDrainage?: string;
  //CS-1193 - Start
  dateOfSurgery?: string;
  //CS-1193 - End
  odor?: string;
  periIncisionErythema?: string;
  periIncisionSkin?: string;
  periIncisionTemperature?: string;
  edema?: string;
  eschar?: string;
  exudate: string,
  drainage: string,
  erythema: string,
  skin: string,
  temperature: string,
  cellulitis: string,
  woundStage?: string,
  debrided: string,
  undermining?: string;
  tunneling?: string;
  pain?: string;
  severity?: string;
  woundKeyDisplayValue?: string
}

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

export interface ProviderData {
  providerName: string;
  npi: string;
  ptan: string;
  taxId: string;
}

export interface IVRInfo {
  typeOfIVR: string;
  patientInfo: {
    patientId: number;
    patientFirstName: string;
    patientMiddleName: string;
    patientLastName: string;
    patientDOB: string;
    gender: string;
    patientStreetAddress: string;
    patientUnitNumber: string;
    patientCity: string;
    patientState: string;
    patientZipcode: string;
    faceSheet: number[];
    patientCode: string;
    isFaceSheetSkipped: boolean;
  };
  insuranceInfo: {
    insuranceName: string;
    insuranceNameNotListed?: boolean;
    primaryCommercialInsuranceName?: string;
    insuranceCategory: string;
    insurancePayerCode: string;
    policy: string;
    isPolicyUnderDifferentName: boolean;
    policyholderFirstName: string;
    policyholderMiddleName: string;
    policyholderLastName: string;
    policyHolderDOB: string;
    insuranceType: string;
    insuranceCards: number[];
    isInsuranceCardsSkipped: boolean;
    isSecondaryInsurance: boolean;
    secondaryInsuranceName: string;
    secondaryInsuranceCategory: string;
    secondaryCommercialInsuranceName?: string;
    secondaryInsuranceNameNotListed?:boolean;
    secondaryInsurancePayerCode: string;
    secondaryPolicy: string;
    isSecondaryPolicyUnderDifferentName: boolean;
    secondarypolicyholderFirstName: string;
    secondarypolicyholderMiddleName: string;
    secondarypolicyholderLastName: string;
    secondaryPolicyHolderDOB: string;
    secondaryInsuranceType: string;
    secondaryInsuranceCards: number[];
    isSecondaryInsuranceCardsSkipped: boolean;
  };
  supportingDocumentation: {
    supportingDocuments: number[];
    isSupportingDocumentsSkipped: boolean;
    imageOfWounds: number[];
    isImageOfWoundsSkipped: boolean;
  };
  patientConsentInfomation: {
    isPatientConsentSigned: string;
    patientSignDate: string;
  };
  treatmentInformation: {
    // currentlyInNursingFacility: boolean;
    // daysAdmittedToFacility: string;
    // currentlyUnderSurgicalGlobalPeriod: boolean;
    // surgicalProcedureDate: string;
    // surgicalProcedureCodes: string;
    homeHealth?:string;
    dateOfService: string | null;
    placesOfService: string;
    product: number;
    practiceProductId: number;
    productSizes: string[];
    products: Product[];
    currentlyCoveredUnderPartAStay: string;
  };
  woundInfo?: {
    woundData: {
      woundType: string;
      cpt: string;
      lCode: string;
      eCode: string;
      iCode: string;
      icd10: string;
      otherDxCodes: string;
      noOfApplications: string;
      totalSize: string;
    }[];
    totalSizeOfAllWounds: string;
    isLoadedFromProviderTemplate?: boolean
  };
  providerInformation: {
    practice: string;
    provider: string;
    practiceLocation: string;
    macId: string;
    providerSignedDate: Date;
    signature: string;
    name: string;
  };
  checkProviderSignAuth: boolean;
  comments: string;
  woundRows?: WoundInfo[];
  productQuestions?: any;
  safeguardQuestions?: any;
}

interface PatientDetailsInfo {
  patientId: string;
  patientCode: string;
  firstName: string;
  middleName: string;
  lastName: string;
  birthDate: string;
  gender: string;
  dateOfSurgery: string;
  providerId: string;
  providerTemplateId: number;
  patientInfo: {
    inactiveDate?: string;
    infoType: string;
    patientinfoId: number | null;
    patientinfoData: {
      documentIds: number[];
      ivrDocumentListDTOs?: {
        size: number;
        documentType: string;
        documentId: number;
        documentName: string
      }[];
      patientStreetAddress?: string;
      patientUnitNumber?: string;
      patientCity?: string;
      patientState?: string;
      patientZip?: string;
      insuranceName?: string;
      policy?: string;
      isPolicyUnderDifferentName?: boolean;
      policyHolderFirstName?: string;
      policyHolderMiddleName?: string;
      policyHolderLastName?: string;
      policyHolderDOB?: string;
      insuranceType?: string;
      secondaryInsuranceName?: string;
      secondaryPolicy?: string;
      isSecondaryPolicyUnderDifferentName?: boolean;
      secondaryPolicyHolderFirstName?: string;
      secondaryPolicyHolderMiddleName?: string;
      secondaryPolicyHolderLastName?: string;
      secondaryPolicyHolderDOB?: string;
      secondaryInsuranceType?: string;
    }
  }[];
}

// const woundInfoTableColums: Column[] = [
//   { id: "checkboxes", label: "Select", minWidth: 20 },
//   { id: "woundKeyDisplayValue", label: "Wound ID", minWidth: 20 },
//   { id: "woundType", label: "Type", minWidth: 80 },
//   { id: "cpt", label: "CPT", minWidth: 50 },
//   { id: "lCode", label: "L Code", minWidth: 50 },
//   { id: "eCode", label: "E Code ", minWidth: 50 },
//   { id: "iCode", label: "I Code", minWidth: 50 },
//   // { id: "icd10", label: "ICD10 Code", minWidth: 80 },
//   { id: "procedureLocation", label: "Location", minWidth: 80 },
//   { id: "otherDxCodes", label: "Dx Code(s) / ICD-10", minWidth: 80 },
//   { id: "noOfApplications", label: "# of App ", minWidth: 80 },
//   { id: "displayWoundDimensions", label: "Wound Dimensions (L, W, D)", minWidth: 140 },
//   { id: "displayEstimateSurfaceArea", label: "Estimate Surface Area (cm²)", minWidth: 120 },
//   { id: "displayTotalWoundVolume", label: "Total Wound Volume (cm³)", minWidth: 120 },
//   { id: "action", label: "Action", minWidth: 20, align: "center" },
// ];

const IVRForm: React.FC = () => {
  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { errors },
    watch,
    trigger,
    clearErrors,
    setError
  } = useForm<IVRInfo>();
  const dispatch = useAppDispatch();
  const { navigate } = useNavigation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {
    tokens: mTokens,
    isDark: isDarkModal,
    primaryBtnSx,
    cancelBtnSx,
    backBtnSx,
    inputFieldSx,
    dropdownWrapSx,
    datepickerWrapSx,
  } = useModalStyles();
  /* ── Modern card / field tokens (mirrors CreateUser.tsx & CreateNewAgreementNew.tsx) ── */
  const cardSx = {
    borderRadius: "16px",
    border: `1px solid ${mTokens.border}`,
    backgroundColor: mTokens.bg,
    backgroundImage: "none",
    overflow: "hidden" as const,
    boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
  };
  const sectionBodySx = { px: { xs: 2, md: 2.8 }, py: 2 };
  const FieldLabel = ({ label, required = false }: { label: string; required?: boolean }) => (
    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: mTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.4 }}>
      {label}{required && <Box component="span" sx={{ color: mTokens.accent }}>*</Box>}
    </Typography>
  );
  const inlineLabelSx = { mr: 3, fontSize: "0.8rem", fontWeight: 600, color: mTokens.textSecondary };
  /* Compact teal-outline action button for a SectionHeader's action slot (mirrors
     outlineActionBtnSx in CreateNewAgreementNew.tsx, sized down for header use). */
  const sectionActionBtnSx = (hasError = false) => ({
    textTransform: "none" as const,
    fontWeight: 700,
    fontSize: "0.78rem",
    borderRadius: "8px",
    py: 0.55,
    px: 1.3,
    minHeight: "32px",
    color: hasError ? mTokens.error : mTokens.accent,
    borderColor: hasError ? `${mTokens.error}8c` : `${mTokens.accent}8c`,
    backgroundColor: hasError
      ? (isDarkModal ? "rgba(239,68,68,0.08)" : "rgba(239,68,68,0.04)")
      : (isDarkModal ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)"),
    "&:hover": {
      color: "#fff",
      borderColor: hasError ? mTokens.error : mTokens.accent,
      backgroundColor: hasError ? mTokens.error : mTokens.accent,
      boxShadow: hasError ? "0 6px 18px rgba(239,68,68,0.28)" : "0 6px 18px rgba(20,184,166,0.28)",
    },
    "& .MuiTypography-root": { color: "inherit", fontWeight: 700 },
    "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
  });
  const controlHeight = "42px";
  const controlHeightSx = {
    minHeight: `${controlHeight} !important`,
    height: `${controlHeight} !important`,
    maxHeight: `${controlHeight} !important`,
    boxSizing: "border-box !important",
    alignItems: "center",
  };
  const mergeControlSx = (base: object) => {
    const nested = (base as Record<string, unknown>)["& .MuiOutlinedInput-root, & .MuiInputBase-root"];
    return {
      ...(nested && typeof nested === "object" ? nested : {}),
      ...controlHeightSx,
    };
  };
  const dropdownFieldWrapSx = (hasError = false) => {
    const base = dropdownWrapSx(hasError);
    return {
      ...base,
      width: "100%",
      "& .MuiAutocomplete-root, & .MuiFormControl-root": { width: "100%", maxWidth: "100%" },
      "& .MuiOutlinedInput-root, & .MuiInputBase-root": mergeControlSx(base),
      "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
        padding: "0 38px 0 12px !important",
        flexWrap: "nowrap !important",
        overflow: "hidden !important",
      },
      "& .MuiAutocomplete-root .MuiInputBase-input, & .MuiAutocomplete-input, & .MuiOutlinedInput-input": {
        paddingTop: "8px !important",
        paddingBottom: "8px !important",
        height: "24px !important",
        lineHeight: "24px !important",
        boxSizing: "border-box",
      },
      "& .MuiAutocomplete-endAdornment": {
        top: "50% !important",
        transform: "translateY(-50%)",
        right: "8px !important",
      },
    };
  };
  const textFieldWrapSx = (hasError = false) => {
    const base = inputFieldSx(hasError);
    return {
      ...base,
      width: "100%",
      "& .MuiFormControl-root, & .MuiTextField-root": { width: "100%" },
      "& .MuiOutlinedInput-root:not(.MuiInputBase-multiline), & .MuiInputBase-root:not(.MuiInputBase-multiline)": mergeControlSx(base),
    };
  };
  const dateFieldWrapSx = (hasError = false) => {
    const base = datepickerWrapSx(hasError);
    return {
      ...base,
      width: "100%",
      "& .MuiFormControl-root, & .MuiTextField-root": { width: "100%" },
      "& .MuiOutlinedInput-root": {
        ...(base["& .MuiOutlinedInput-root"] as object),
        ...controlHeightSx,
      },
    };
  };
  /* ── Wound/Incision table — matches the list-page table look (IVRList.tsx's ivrTableSx) ── */
  const woundTableWrapSx = {
    "& .MuiTableContainer-root": {
      borderRadius: "12px",
      border: `1px solid ${mTokens.border}`,
      backgroundColor: mTokens.bg,
    },
    "& table": {
      
      borderCollapse: "collapse" as const,
      borderSpacing: 0,
    },
    "& .MuiTableCell-root": {
      borderBottom: `1px solid ${mTokens.border}`,
      py: 1.15,
      fontSize: "0.84rem",
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      height: "42px",
    },
    "& .MuiTableHead-root .MuiTypography-root": {
      color: "#00B8D9 !important",
      fontSize: "0.78rem",
      fontWeight: 800,
      letterSpacing: "0.02em",
    },
    "& .MuiTableBody-root .MuiTableRow-root": {
      transition: "background-color 0.18s ease, box-shadow 0.18s ease",
    },
    "& .MuiTableBody-root .MuiTableRow-root:hover": {
      backgroundColor: isDarkModal ? "rgba(20,184,166,0.06)" : "rgba(20,184,166,0.05)",
    },
    "& .MuiTableBody-root .MuiTableCell-root, & .MuiTableBody-root .MuiTypography-root": {
      color: mTokens.textPrimary,
      fontSize: "0.84rem",
    },
    "& .MuiIconButton-root": {
      color: isDarkModal ? "#94a3b8" : "#475569",
      borderRadius: "8px",
      "&:hover": {
        color: mTokens.accent,
        backgroundColor: isDarkModal ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)",
      },
    },
  };
  /* Collapsible sections previously handled by BorderedSection's hasCollapse/defaultExpanded */
  const [patientInfoExpanded, setPatientInfoExpanded] = useState(false);
  const [supportingDocsExpanded, setSupportingDocsExpanded] = useState(false);
  const collapseToggleSx = {
    border: `1px solid ${mTokens.border}`,
    borderRadius: "10px",
    width: 30,
    height: 30,
    color: mTokens.textSecondary,
    "&:hover": { borderColor: mTokens.accent, color: mTokens.accent, backgroundColor: `${mTokens.accent}0d` },
  };
  const { allPayerList } = useCommonReducer();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showWoundInfoPopup, setShowWoundInfoPopup] = useState(false);
  const [currentWoundInfo, setCurrentWoundInfo] = useState(null);
  const { allCodeTablesValuesMap } = useCodetablesSlice();
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [isSecondaryInsurance, setIsSecondaryInsurance] = useState(false);
  const [woundInfoRows, setWoundInfoRows] = useState<WoundInfo[]>([]);
  const [selectedProviderData, setSelectedProviderData] = useState<ProviderData[]>([]);
  const [patientInfoValid, setPatientInfoValid] = useState(false);
  const [productInfoValid, setProductInfoValid] = useState(false);
  const [insuranceInfoValid, setInsuranceInfoValid] = useState(false);
  const [ivRequestValid, setIVRequestValid] = useState(false);
  const [supportingDocumentationValid, setSupportingDocumentationValid] = useState(false);
  // const [patientConsentInfoValid, setPatientConsentInfoValid] = useState(false);
  const [treatmentInfoValid, setTreatmentInfoValid] = useState(false);
  const [safeguardQuestionsValid, setSafeguardQuestionsValid] = useState(false);
  const [woundInfoValid, setWoundInfoValid] = useState(false);
  const { patientList, patientInfoObject, surgicalTemplate } = usePatientReducer();
  const { practiceProvidersInfo } = usePracticeProvidersSlice();
  const { practiceLocationsInfo } = usePracticeLocationsSlice();
  const [isPatientInfoDisabled, setIsPatientInfoDisabled] = useState(false);
  const faceSheetDocumentIdsRef = useRef<number[]>([]);
  const insuranceCardsDocumentIdsRef = useRef<number[]>([]);
  const secondaryInsuranceCardsDocumentIdsRef = useRef<number[]>([]);
  const supportingDocsDocumentIdsRef = useRef<number[]>([]);
  const imageOfWoundsDocumentIdsRef = useRef<number[]>([]);
  const [isPatientEdited, setIsPatientEdited] = useState(false);
  // const [isPatientInfoEdited, setIsPatientInfoEdited] = useState(false);
  const [isFaceSheetEdited, setIsFaceSheetEdited] = useState(false);
  const [isPrimaryInsuranceInfoEdited, setIsPrimaryInsuranceInfoEdited] = useState(false);
  const [isSecondaryInsuranceInfoEdited, setIsSecondaryInsuranceInfoEdited] = useState(false);
  const [isSupportingDocumentsEdited, setIsSupportingDocumentsEdited] = useState(false);
  const [isImageOfWoundsEdited, setIsImageOfWoundsEdited] = useState(false);
  const [isWoundInfoEdited, setIsWoundInfoEdited] = useState(false);
  const [patientCompleteData, setPatientCompleteData] = useState<PatientDetailsInfo>();
  const [submitAction, setSubmitAction] = useState<string | null>(null);
  const { IVRFetchStatus, IVRObject } = useCreateIVRSlice();
  const { patientFetchStatus } = usePatientReducer();
  const [ivrId, setIvrId] = useState<number | undefined>(undefined);
  const [patientSelected, setPatientSelected] = useState(false);
  const [duplicateIvr, setDuplicateIvr] = useState(false);
  const [isPolicyUnderDifferentNameCheck, setIsPolicyUnderDifferentNameCheck] = useState(false);
  const [isPolicyUnderDifferentNameCheckSecondary, setIsPolicyUnderDifferentNameCheckSecondary] = useState(false);
  const location = useLocation();
  const [practiceID, setPracticeID] = useState("");
  const [isUnderSurgicalGlobalPeriod, setIsUnderSurgicalGlobalPeriod] = useState(false);
  const [disableAllFields, setDisableAllFields] = useState(false);
  const [disableProductField, setDisableProductField] = useState(true);
  const [ivrNumber, setIvrNumber] = useState("");
  const [patientInfoIdAddress, setPatientInfoIdAddress] = useState<number | null>(null);
  const [patientInfoIdFaceSheet, setPatientInfoIdFaceSheet] = useState<number | null>(null);
  const [patientInfoIdPrimaryInsurance, setPatientInfoIdPrimaryInsurance] = useState<number | null>(null);
  const [patientInfoIdSecondaryInsurance, setPatientInfoIdSecondaryInsurance] = useState<number | null>(null);
  const [patientInfoIdSupportingDocs, setPatientInfoIdSupportingDocs] = useState<number | null>(null);
  const [patientInfoIdWoundImages, setPatientInfoIdWoundImages] = useState<number | null>(null);
  const [patientWoundInfo, setPatientWoundInfo] = useState<number | null>(null);
  const [patientEmail, setPatientEmail] = useState<number | null>(null);
  // const [isPatientCurrentlyInNursingFacility, setIsPatientCurrentlyInNursingFacility] = useState(false);
  const [productListWithItems, setProductListWithItems] = useState<ProductListWithItems[] | null>(null);
  const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);
  const [isPracticeIndividual, setIsPracticeIndividual] = useState(false);
  const [optionPopupShow, setOptionPopupShow] = React.useState<{ message: string; show: boolean }>({ message: "", show: false });
  const [loadingProdcuts, setLoadingProdcuts] = useState<boolean>(false);
  const [showPatientSignDate, setShowPatientSignDate] = useState<boolean>(false);
  const [practiceObject, setPracticeObject] = useState<PracticeInfo>();
  const { allWoundCodesValuesMap, woundCodeFetchStatus } = useWoundCodesSlice();
  const [resetComplete, setResetComplete] = useState(false);
  const [patientData, setPatientData] = useState<{ from: string, patientId: number } | null>(null);
  const [selectedWoundList, setSelectedWoundList] = useState<string[]>([]);
  const [selectedProductCategory, setSelectedProductCategory] = useState("");
  const [showSignatureSubmitPopup, setShowSignatureSubmitPopup] = useState<boolean>(false);
  const [maxWoundRowIndex, setMaxWoundRowIndex] = useState(0);
  const [viewOnly, setIsViewOnly] = useState(false);
  const [patientEmailAddress, setPatientEmailAddress] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const [patientWoundTotalSize, setPatientWoundTotalSize] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [maxWoundIdFromMount, setMaxWoundIdFromMount] = useState<number | null>(null);
  const { productQuestions, safeguardQuestions } = useProductReducer();
  const [checkedWoundData, setCheckedWoundData] = useState<any[]>([]);
  const [showProductItemSelectPopup, setShowProductItemSelectPopup] = useState<boolean>(false);
  const [productKitOptions, setProductKitOptions] = useState<any[]>([]);
  const [kitItemData, setKitItemData] = useState<any[]>([]);
  const [mutiSelectProductItems, setMutiSelectProductItems] = useState(false);
  const [isAddIncisionButtonDisabled, setIsAddIncisionButtonDisabled] = useState(false);
  const [providerTemplateId, setProviderTemplateId] = useState<number | null>(null);
  const ivrIdRef = useRef<number | undefined>(undefined); //CS-1343
  const ivrNumberRef = useRef<string>(""); //CS-1343

  const setFormValues = (data: Record<string, any>) => {
    Object.entries(data).forEach(([key, value]) => {
      setValue(key as keyof IVRInfo, value);
    });
  };

  const [uploadedWoundImageFilesMetaData, setUploadedWoundImageFilesMetaData] = useState<ExtendedFile[]>([]);
  const [uploadedFacesheetFilesMetaData, setUploadedFacesheetFilesMetaData] = useState<ExtendedFile[]>([]);
  const [uploadedPrimaryInsuranceFilesMetaData, setUploadedPrimaryInsuranceFilesMetaData] = useState<ExtendedFile[]>([]);
  const [uploadedSecondaryInsuranceFilesMetaData, setUploadedSecondaryInsuranceFilesMetaData] = useState<ExtendedFile[]>([]);
  const [uploadedSupportingDocumentFilesMetaData, setUploadedSupportingDocumentFilesMetaData] = useState<ExtendedFile[]>([]);
  const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: '', show: false });
  const [supportingDocsDeleted, setSupportingDocsDeleted] = useState<boolean>(false);
  const [imagesOfWoundsDeleted, setImagesOfWoundsDeleted] = useState<boolean>(false);
  const [insuranceNameNotListed, setInsuranceNameNotListed] = useState(false);
  const [secondaryInsuranceNameNotListed, setSecondaryInsuranceNameNotListed] = useState(false);
  const [errorOccured,setErrorOccured]=useState<boolean>(false);
  const [showIncisionInfoPopup, setShowIncisionInfoPopup] = useState(false);
  const [autoSelectSafeguard, setAutoSelectSafeguard] = useState(false);
  const [hasHardStop, setHasHardStop] = useState(false);
  //CS-1595
  const hasSubscribedAccessToMedicalAudit = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.MEDICAL_NOTE_AUDIT)(state));
      


  /* Codes (CPT/L/E/I) and Measurements (dimensions/area/volume) are each
     consolidated into a single compact multi-line cell — see `codes`/
     `measurements` synthesized in the `rows` prop below — so the table reads
     in ~8 columns instead of 14 and no longer needs a horizontal scrollbar
     on a typical desktop width, without dropping any of the underlying data. */
  const baseWoundColumns: Column[] = [
    { id: "checkboxes", label: "Select", minWidth: 20 },
    { id: "woundKeyDisplayValue", label: "ID", minWidth: 20 },
    { id: "woundType", label: "Type", minWidth: 80 },
    { id: "codes", label: "Codes (CPT/L Code/E Code/I Code)", minWidth: 90 },
    { id: "procedureLocation", label: "Location", minWidth: 80 },
    { id: "otherDxCodes", label: "Dx Code(s) / ICD-10", minWidth: 80 },
    { id: "exudate", label: "Exudate", minWidth: 80 },
    { id: "measurements", label: "Measurements (L, W, D / Area / Volume)", minWidth: 160 },
    { id: "action", label: "Action", minWidth: 20, align: "center" },
  ];

// const shouldShowExudate = useMemo(() => {
//     return woundInfoRows.some(row => row.woundType === "Surgical Incision");
// }, [woundInfoRows]);

const woundInfoTableColumns: Column[] = useMemo(() => {
    const filteredColumns = baseWoundColumns.filter(
        column => !((column.id === "codes" || column.id === "exudate") && practiceObject?.specialization === PRACTICE_TYPE.SURGICAL)
    );
    // const insertIndex = filteredColumns.findIndex(col => col.id === "displayTotalSize");
    // if (shouldShowExudate && insertIndex !== -1) {
    //     const exudateColumn = { id: "exudate", label: "Exudate", minWidth: 80 };
    //     return [
    //         ...filteredColumns.slice(0, insertIndex),
    //         exudateColumn,
    //         ...filteredColumns.slice(insertIndex)
    //     ];
    // }
    return filteredColumns;
}, [practiceObject]);

  const woundInfoTableRows = useMemo(() => {
    return woundInfoRows.map((row: any) => {
      const codeParts = [
        row.cpt && `CPT: ${row.cpt}`,
        row.lCode && `L Code: ${row.lCode}`,
        row.eCode && `E Code: ${row.eCode}`,
        row.iCode && `I Code: ${row.iCode}`,
      ].filter(Boolean);
      const measurementParts = [
        row.displayWoundDimensions && `Dimensions: ${row.displayWoundDimensions}`,
        row.displayEstimateSurfaceArea && `Area: ${row.displayEstimateSurfaceArea}`,
        row.displayTotalWoundVolume && `Volume: ${row.displayTotalWoundVolume}`,
      ].filter(Boolean);
      return {
        ...row,
        codes: codeParts.length > 0 ? codeParts.join(" • ") : "-",
        measurements: measurementParts.length > 0 ? measurementParts.join(" • ") : "-",
      };
    });
  }, [woundInfoRows]);

  //CS-1343 - Update the refs whenever the state changes
  useEffect(() => {
    ivrIdRef.current = ivrId;
  }, [ivrId]);

  useEffect(() => {
    ivrNumberRef.current = ivrNumber;
  }, [ivrNumber]);

  useEffect(() => {
    const isDrafted = location?.state?.ivrStatus === "DRAFTED";

    if(isDrafted){
      if (!patientInfoObject?.patientInfo) return;
    } else {
      if (!IVRObject?.patient?.patientInfo) return;
    }

    const sourcePatientInfo = isDrafted
        ? patientInfoObject.patientInfo
        : IVRObject?.patient.patientInfo;

        // const sourcePatientInfo = patientInfoObject.patientInfo

    const infoTypeMapping = {
      IMAGEOF_WOUNDS: setUploadedWoundImageFilesMetaData,
      FACESHEET: setUploadedFacesheetFilesMetaData,
      PRIMARY_INSURANCE: setUploadedPrimaryInsuranceFilesMetaData,
      SUPPORTING_DOCUMENT: setUploadedSupportingDocumentFilesMetaData,
      SECONDARY_INSURANCE: setUploadedSecondaryInsuranceFilesMetaData,
    };

    let filteredEntries = sourcePatientInfo

    const hasSecondaryInsurance = sourcePatientInfo?.some(
      (entry) => entry.infoType === "SECONDARY_INSURANCE"
    );
  
    if (hasSecondaryInsurance) {
      setIsSecondaryInsurance(true);
    }

    if(isDrafted){
    filteredEntries = sourcePatientInfo?.filter(entry => {
      const docs = entry?.patientinfoData?.ivrDocumentListDTOs ?? [];
      return docs.some((doc: any) => doc.isActive === true);
    });
    }

    Object.entries(infoTypeMapping).forEach(([infoType, setter]) => {
      const data = (filteredEntries ?? []).find(
        (info) => info.infoType === infoType
      );

      if (data?.patientinfoData?.ivrDocumentListDTOs) {
        const documentsMetaData = data.patientinfoData.ivrDocumentListDTOs.map(
          (doc: { documentId: number, documentName: string, documentType: string, size: number, auditTimestamp: string }) => ({
            documentId: doc.documentId.toString(),
            name: doc.documentName,
            type: doc.documentType || "Unknown",
            size: doc.size,
            timestamp: doc.auditTimestamp,
            lastModified: 0,
            webkitRelativePath: "",
            arrayBuffer: async () => new ArrayBuffer(0),
            bytes: async () => new Uint8Array(0),
            slice: () => new Blob(),
            stream: () => new ReadableStream(),
            text: async () => "",
          })
        );

        setter(documentsMetaData);
      }
    });
  }, [IVRObject, patientInfoObject]);

  useEffect(() => {
    if (!patientCompleteData?.patientInfo) return;

    if(patientSelected && !viewOnly){

      // Mapping infoTypes to the appropriate setter functions
      const infoTypeMapping = {
        IMAGEOF_WOUNDS: setUploadedWoundImageFilesMetaData,
        FACESHEET: setUploadedFacesheetFilesMetaData,
        PRIMARY_INSURANCE: setUploadedPrimaryInsuranceFilesMetaData,
        SUPPORTING_DOCUMENT: setUploadedSupportingDocumentFilesMetaData,
        SECONDARY_INSURANCE: setUploadedSecondaryInsuranceFilesMetaData,
      };

      // Get patientInfo from the patientCompleteData
      const patientCompleteInfo = patientCompleteData?.patientInfo;

      const filteredEntries = patientCompleteInfo?.filter(entry => {
        const docs = entry?.patientinfoData?.ivrDocumentListDTOs ?? [];
        return docs.some((doc: any) => doc.isActive === true);
      });


      Object.entries(infoTypeMapping).forEach(([infoType, setter]) => {

        const data = filteredEntries.find(info => info.infoType === infoType);

        if (data?.patientinfoData.ivrDocumentListDTOs) {

          const documentsMetaData = data.patientinfoData.ivrDocumentListDTOs.map(
            ({ documentId, documentName, documentType, size }) => ({

              documentId: documentId ? documentId.toString() : "",
              name: documentName ? documentName : "",
              type: documentType || "Unknown",
              size: size ? size : 0,
              timestamp: '',
              lastModified: 0,
              webkitRelativePath: "",
              arrayBuffer: async () => new ArrayBuffer(0),
              bytes: async () => new Uint8Array(0),
              slice: () => new Blob(),
              stream: () => new ReadableStream(),
              text: async () => "",
            })
          );

          setter(documentsMetaData);

        } else {

          setter([]);
        }
      });
      setPatientSelected(false);
    }

    if (practiceObject?.specialization === PRACTICE_TYPE.SURGICAL && patientCompleteData) {
      // setValue("treatmentInformation.dateOfService", patientCompleteData?.dateOfSurgery || "")
      setValue("providerInformation.provider", patientCompleteData?.providerId || "")
      changeProvider();
      setProviderTemplateId(patientCompleteData?.providerTemplateId || null)
      if (patientCompleteData.providerTemplateId != null) {
        dispatch(getSurgicalTemplateByTemplateId(patientCompleteData.providerTemplateId));
      };
      if(!getValues('treatmentInformation.placesOfService')) {
          setValue("treatmentInformation.placesOfService", "Home (12)")
      };
    };
  }, [patientCompleteData]);

  // //CS-1441 START
  // useEffect(() => {
  //   if (practiceID) {
  //     if (
  //       practiceObject?.practiceRequestInfo?.interestedProductCategory &&
  //       Array.isArray(practiceObject?.practiceRequestInfo?.interestedProductCategory) &&
  //       practiceObject?.practiceRequestInfo?.interestedProductCategory.length === 1 &&
  //       practiceObject?.practiceRequestInfo?.interestedProductCategory[0] === 'Collagen'
  //     ) {
  //       setValue('treatmentInformation.dateOfService', patientCompleteData?.dateOfSurgery || ""); 
  //       setValue('treatmentInformation.placesOfService', 'Home (12)'); 
  //     }
  //   }
  // }, [patientCompleteData]);
  // //CS-1441 END

  useEffect(() => {
  const fetchData = async () => {
    if (surgicalTemplate && surgicalTemplate.templateJson?.incisionArray.length > 0) {
      const incisionArray = surgicalTemplate.templateJson.incisionArray;

      const response = await dispatch(fetchProductItemBySKU(incisionArray[0].primaryDressing));
      if (productListWithItems !== null) {
        const matchingItem = productListWithItems.find(item =>
          item.productId === response.payload.productId
        );
        if (matchingItem) {
          setSelectedProductCategory(matchingItem.productCategory);
          setValue("treatmentInformation.practiceProductId", matchingItem.practiceProductId);
          
          if(!location?.state?.ivrId) {
            setAutoSelectSafeguard(true);
            const prodQResponse = await dispatch(getProductQuestions(matchingItem.productId));
            const safeQResponse = await dispatch(getSafeguardQuestions(matchingItem.productId));
          };

          const matchingSizes: any[] = [];
          incisionArray.forEach(async (incision: SurgicalTemplateJSON) => {

            const primaryDressingSKU = incision.primaryDressing;
            const secondaryDressingSKU= incision.secondaryDressing;
            const ancillaryDressingSKU = incision.ancillaryDressing;


            const primaryDressingSize = matchingItem.sizes.find(size =>
              size.sku === primaryDressingSKU
            );
            if (primaryDressingSize) {
              matchingSizes.push({
                type: 'primary',
                productItemId: primaryDressingSize.productItemId,
                size: primaryDressingSize.size,
                sku: primaryDressingSize.sku,
                units: primaryDressingSize.units,
                description: primaryDressingSize.productItemDescription,
                hcpcsCode: primaryDressingSize.hcpcsCode
              });
            }

            // Find secondary dressing size (if it exists)
            if (secondaryDressingSKU) {
              const secondaryDressingSize = matchingItem.sizes.find(size =>
                size.sku === secondaryDressingSKU
              );
              if (secondaryDressingSize) {
                matchingSizes.push({
                  type: 'secondary',
                  productItemId: secondaryDressingSize.productItemId,
                  size: secondaryDressingSize.size,
                  sku: secondaryDressingSize.sku,
                  units: secondaryDressingSize.units,
                  description: secondaryDressingSize.productItemDescription,
                  hcpcsCode: secondaryDressingSize.hcpcsCode
                });
              }
            }
            if (ancillaryDressingSKU) {
              const ancillaryDressingSize = matchingItem.sizes.find(size =>
                size.sku === ancillaryDressingSKU
              );
              if (ancillaryDressingSize) {
                matchingSizes.push({
                  type: 'Ancillary',
                  productItemId: ancillaryDressingSize.productItemId,
                  size: ancillaryDressingSize.size,
                  sku: ancillaryDressingSize.sku,
                  units: ancillaryDressingSize.units,
                  description: ancillaryDressingSize.productItemDescription,
                  hcpcsCode: ancillaryDressingSize.hcpcsCode
                });
              }
            }
          });
          setKitItemData(matchingSizes);

          // Create formatted size array
          const formattedProductDetails = matchingSizes.map(item => {
            return `${item.hcpcsCode || 'N/A'} - ${item.size} - ${item.description || 'N/A'}`;
          });

          const newProduct = {
            productId: matchingItem.productId,
            macId: matchingItem.macId,
            practiceProductId: matchingItem.practiceProductId,
            providerId: matchingItem.providerId,
            productSizes: formattedProductDetails,
            productName: matchingItem.label,
            productCategory: matchingItem.productCategory,
            isKit: matchingItem.isKit,
            productKitItemId: undefined
          };

          setSelectedProducts([newProduct]);
          setValue("treatmentInformation.products", [newProduct]);
        } else {
          console.log('No matching item found');
        }
      }
    }
  };
  
  fetchData();
}, [surgicalTemplate, productListWithItems]);

  useEffect(() => {
    let formData: any = Cookies.get("formData");
    // If formData exists in the cookie, try parsing it
    if (formData) {
      try {
        const jsonData = JSON.parse(formData); // Try parsing the cookie content
        setFormValues(jsonData);

        // Set the form values for patientInfo
        if (jsonData?.patientInfo) {
          Object.entries(jsonData.patientInfo).forEach(([key, value]) => {
            const formKey = `patientInfo.${key}`;
            setValue(formKey as keyof IVRInfo, value as string);
          });
        }

        // Set the form values for insuranceInfo
        if (jsonData?.insuranceInfo) {
          Object.entries(jsonData.insuranceInfo).forEach(([key, value]) => {
            const formKey = `insuranceInfo.${key}`;
            setValue(formKey as keyof IVRInfo, value as string);
          });
        }
      } catch (error) {
        console.error("Error parsing formData:", error);
      }
    }
    checkSectionValidity();
    hideDataWithSticky();
  }, []);

  const hideDataWithSticky = () => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setIsSticky(offset > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }

  // CS-1460 - Remove the "IVR auto save" functionality
  // Autosave IVR - START 
  // const requiredFieldsFilled = useCallback(() => {
  //   const values = getValues();
  //   const hasPatientInfo = !!values.patientInfo.patientFirstName && !!values.patientInfo.patientLastName;
  //   const hasValidProducts = Array.isArray(values.treatmentInformation.products) && values.treatmentInformation.products.length > 0 && values.treatmentInformation.products.every(product => Array.isArray(product.productSizes) && product.productSizes.length > 0);

  //   return hasPatientInfo && hasValidProducts;
  // }, [getValues("treatmentInformation.products"), getValues("patientInfo.patientFirstName"), getValues("patientInfo.patientLastName")]);

  // useEffect(() => {
  //   const autosaveInterval = Number(process.env.REACT_APP_IVR_AUTOSAVE_INTERVAL) || 10000;
  //   const interval = setInterval(() => {
  //     if (requiredFieldsFilled() && !viewOnly) {
  //       saveIVRdataInBackground();
  //     }
  //   }, autosaveInterval);

  //   return () => clearInterval(interval);
  // }, [requiredFieldsFilled, ivrNumber, ivrId, woundInfoRows, isPatientEdited, isFaceSheetEdited, isPrimaryInsuranceInfoEdited, isSecondaryInsuranceInfoEdited, isSupportingDocumentsEdited, isImageOfWoundsEdited, patientInfoIdAddress, patientInfoIdFaceSheet, patientInfoIdPrimaryInsurance, patientInfoIdSecondaryInsurance, patientInfoIdSupportingDocs, patientInfoIdWoundImages]);

  // const saveIVRdataInBackground = async () => {
  //   const updatedObject = mapIVRInfoToIVRObjectInfo(getValues());
  //   const response = await dispatch(saveIVRData(updatedObject));
  //   if (response.payload && response.payload.message === "SUCCESS") {
  //     let successObj: SingleAlertInfo = {
  //       message: "Your changes have been auto-saved.",
  //       alertType: "success",
  //     };
  //     dispatch(setSingleAlertObj(successObj));
  //     setIvrNumber(response.payload.data.ivrNumber);
  //     setIvrId(response.payload.data.ivrId);

  //     setValue("patientInfo.patientId", response.payload.data.patient.patientId);
  //     const patientDetailsInfo = transformIVRFetchObjectInfo(response.payload.data);
  //     addPatientInfoIds(response.payload.data);
  //     setPatientCompleteData(patientDetailsInfo);
  //     setIsPatientEdited(false);
  //     // setIsPatientInfoEdited(false);
  //     setIsFaceSheetEdited(false);
  //     setIsImageOfWoundsEdited(false);
  //     setIsPrimaryInsuranceInfoEdited(false);
  //     setIsSecondaryInsuranceInfoEdited(false);
  //     setIsSupportingDocumentsEdited(false);
  //     setIsWoundInfoEdited(false);
  //   } else {
  //     return handleErrorResponse(response, "An error occurred while saving the IVR.");
  //   }
  // }
  // Autosave IVR - END

  //Unmount
  useEffect(
    () => () => {
      dispatch(resetProductItems());
      dispatch(resetIVRData());
      setDisableAllFields(false);
      removeDataFromCookies("formData");
      dispatch(updatePatientObjectReducer(null));
      dispatch(resetCreateProductSlice());
      dispatch(resetProviderTemplate());
      clearQuestions();
    },
    []
  );

  //Mount
  useEffect(() => {
    const fetchData = async () => {
      await fetchPractice();
      const ivrId = location?.state?.ivrId;
      const isOnViewOnly = location?.state?.viewOnly;
      const isDuplicateIVR = location?.state?.duplicateIVR;
      const patientDetails = location?.state?.patientData;
      const productCategory = location?.state?.productCategory;

      setIsViewOnly(!!isOnViewOnly);
      if (productCategory) {
        setSelectedProductCategory(productCategory);
      }
      setPatientData(patientDetails);
      if (ivrId) {
        fetchIVRData(ivrId.toString()).then(async (res) => {
          if (res.payload && res.payload.code === "V3OK" && res.payload.message === "SUCCESS") {
            setDisableAllFields(isOnViewOnly);
            if (res.payload.data) {
              if (!isDuplicateIVR) {
                setIvrId(res.payload.data?.ivrId);
                setIvrNumber(res.payload.data?.ivrNumber);
              }
              const patientDetailsInfo = transformIVRFetchObjectInfo(res.payload.data);
              setPatientCompleteData(patientDetailsInfo);
              if (isDuplicateIVR) {
                setDuplicateIvr(true);
              }
            }
            const transformedData = await transformData(res.payload.data);
            reset(transformedData);

            if (isDuplicateIVR) {
              setValue("treatmentInformation.dateOfService", "");
              //CS-1597
              // setValue("treatmentInformation.products", []);
            }

            if (!location?.state?.copiedIvr) {
              checkSectionValidity();
            }
            setResetComplete(true);
          } else {
            reset();
            setResetComplete(true);
          }
        });
      }else{
        setValue("typeOfIVR", "newApplication");
        checkSectionValidity();
      }
    };

    fetchData();
    // dispatch(fetchAllWoundCodes());
    dispatch(fetchAllPayers());
    return () => {
      setFirstLoad(true);
    };
  }, []);

  useEffect(() => {
    if (resetComplete) {
      const copiedIvr = location?.state?.copiedIvr;
      if (copiedIvr) {
        setValue("typeOfIVR", "");
        setValue("treatmentInformation.dateOfService", "");
		//CS-1597
        // Keep products when copying - don't clear them
        // setValue("treatmentInformation.products", []);
        // setValue("treatmentInformation.practiceProductId", 0);
        // setValue("treatmentInformation.productSizes", []);
        setValue("providerInformation.signature", "");
        setValue("providerInformation.name", "");
        setValue("checkProviderSignAuth", false);
        setIvrNumber("");
        setIvrId(undefined);
		//CS-1597
        // Keep selectedProducts when copying - don't clear them
        // setSelectedProducts([]);
        // Validate after a short delay to ensure products are fully set
        setTimeout(() => checkSectionValidity(), 0);
      }
    }
  }, [isPracticeIndividual, resetComplete]);

  const addPatientInfoIds = async (data: IVRFetchObjectInfo) => {
    const patientInfo = data.patient.patientInfo.reduce((acc: any, info: any) => {

      switch (info.infoType) {
        case "ADDRESS":
          setPatientInfoIdAddress(info.patientinfoId);
          break;
        case "FACESHEET":
          setPatientInfoIdFaceSheet(info.patientinfoId);
          break;
        case "PRIMARY_INSURANCE":
          setPatientInfoIdPrimaryInsurance(info.patientinfoId);
          break;
        case "SECONDARY_INSURANCE":
          setPatientInfoIdSecondaryInsurance(info.patientinfoId);
          break;
        case "SUPPORTING_DOCUMENT":
          setPatientInfoIdSupportingDocs(info.patientinfoId);
          break;
        case "IMAGEOF_WOUNDS":
          setPatientInfoIdWoundImages(info.patientinfoId);
          break;
        case "WOUND_INFO":
          setPatientWoundInfo(info.patientinfoId);
          break;
        case "EMAIL":
          setPatientEmail(info.patientinfoId);
          break;
        default:
          break;
      }

      return acc;
    }, []);
  };
  const handleClick = () => {
    const newValue = !insuranceNameNotListed;
    setInsuranceNameNotListed(newValue);

};
const handleSecondaryInsuranceClick = () => {
    const newValue = !secondaryInsuranceNameNotListed;
    setSecondaryInsuranceNameNotListed(newValue);

};
  const fetchPractice = async () => {
    if (location?.state?.practiceId) {
      dispatch(fetchPracticeByIdData(location?.state?.practiceId)).then((res) => {
        if (res.payload && res.payload.code === "V3OK" && res.payload.message === "SUCCESS") {
          setPracticeObject(res.payload.data);
          if (res.payload.data.billingType === "INDIVIDUAL") {
            setIsPracticeIndividual(true)
          } else {
            setIsPracticeIndividual(false)
          }
        }
      })
      setPracticeID(location.state.practiceId);
    } else {
      dispatch((getPracticesByUserRole(false))).then((res) => {
        if (res.payload != undefined && res.payload?.length > 0) {
          if (res.payload.length === 1 && res.payload[0].billingType === "INDIVIDUAL") {
            setIsPracticeIndividual(true)
          } else {
            setIsPracticeIndividual(false)
          }
          setPracticeID(res.payload[0].practiceId);
          setPracticeObject(res.payload[0]);
        }
      })
    }
  }

  const fetchIVRData = async (ivrId: string) => {
    const response = await dispatch(fetchIVRById({ivrId: ivrId, isSaveAuditLog: false}));
    return response;
  }

  const checkSectionValidity = () => {
    checkIVRequestValidity(getValues());
    checkProductInfoValidity(getValues());
    checkPatientInfoValidity(getValues());
    checkInsuranceInfoValidity(getValues());
    checkSupportingDocumentationValidity(getValues());
    checkSafeguardQuestionsValidity(getValues());
    // checkTreatmentInfoValidity(getValues());
    // checkPatientConsentInfoValidity(getValues());
  }

  const transformIVRFetchObjectInfo = (
    data: IVRFetchObjectInfoWithInfoTypeData
  ): PatientDetailsInfo => {
    return {
      patientId: data.patient.patientId.toString(),
      patientCode: data.patient.patientCode,
      firstName: data.patient.firstName,
      middleName: data.patient.middleName,
      lastName: data.patient.lastName,
      birthDate: data.patient.birthDate,
      gender: data.patient.gender,
      dateOfSurgery: data.patient.dateOfSurgery,
      providerId: data.patient.providerId,
      providerTemplateId: data.patient.providerTemplateId,
      patientInfo: data.patient.patientInfo.map((info) => ({
        infoType: info.infoType,
        patientinfoId: info.patientinfoId,
        patientinfoData: {
          documentIds: info.patientinfoData?.documentIds,
          ivrDocumentListDTOs: info.patientinfoData?.ivrDocumentListDTOs?.map((ivr) => ({
            documentId: ivr.documentId,
            documentName: ivr.documentName,
            documentType: ivr.documentType,
            size: ivr.size,
          })) || []
        },
        infoTypeData: {
          patientStreetAddress: info.infoTypeData?.patientStreetAddress,
          patientUnitNumber: info.infoTypeData?.patientUnitNumber,
          patientCity: info.infoTypeData?.patientCity,
          patientState: info.infoTypeData?.patientState,
          patientZip: info.infoTypeData?.patientZip,
          insuranceName: info.infoTypeData?.insuranceName,
          policy: info.infoTypeData?.policy,
          isPolicyUnderDifferentName:
            typeof info.infoTypeData?.isPolicyUnderDifferentName === "string"
              ? info.infoTypeData?.isPolicyUnderDifferentName === "true"
              : info.infoTypeData?.isPolicyUnderDifferentName,
          policyHolderFirstName: info.infoTypeData?.policyHolderFirstName,
          policyHolderMiddleName: info.infoTypeData?.policyHolderMiddleName,
          policyHolderLastName: info.infoTypeData?.policyHolderLastName,
          policyHolderDOB: info.infoTypeData?.policyHolderDOB,
          insuranceType: info.infoTypeData?.insuranceType
            ? info.infoTypeData.insuranceType.join(", ")
            : undefined,
          documentIds: info.infoTypeData?.ivrDocumentListDTOs?.map(
            (doc) => doc.documentId
          ),
        },
      })),
    };
  };

  // Fetch and process documents and set initial files
  /* istanbul ignore next */
  const processDocuments = async (documentList: any, setterFunction: any) => {
    if (documentList.length > 0) {
      try {
        const processedDocumentList = await fetchAndProcessDocuments(
          documentList,
          dispatch
        );
        setterFunction(processedDocumentList);
      } catch (error) {
        console.error("Error fetching and processing documents:", error);
      }
    }
  };

  const woundCheckboxComponent = (row: WoundInfo | null, woundKey: string): JSX.Element => {
    return (
      <div key={woundKey}>
        <CustomCheckbox
          control={control}
          // color="primary" 
          checked={selectedWoundList?.includes(woundKey)}
          onChange={(e) => handleCheckbox(e, woundKey)}
          isDisabled={viewOnly}
        />
      </div>
    );
  };

  const getMaxWoundInfoKey = (rows: WoundInfo[]): number => {
    const maxKey = rows.reduce((max, row) => {
      if (row.woundInfoKey) {
        const parts = row.woundInfoKey.split('_');
        const num = parseInt(parts[parts.length - 1], 10);
        if (!isNaN(num) && num > max) {
          return num;
        }
      }
      return max;
    }, 0);
    return maxKey;
  };


  const getWoundVolume = (wound: { length?: number | string; width?: number | string; depth?: number | string }) => {
    const length = Number(wound.length);
    const width = Number(wound.width);
    const depth = Number(wound.depth);
    if (isNaN(length) || isNaN(width) || isNaN(depth)) {
      return NaN;
    }
    return length * width * depth;
  };

  const calculatePatientWoundTotalSize = (woundInfo: WoundInfo[]) => {
    let totalValid = 0;
    woundInfo?.forEach((current) => {
      const volume = getWoundVolume(current);
      if (!isNaN(volume)) {
        totalValid += Math.round(volume * 100); //CS-1654
      }
    });
    totalValid = totalValid / 100; //CS-1654
    return totalValid;
  };

  const saveWoundInfoRows = (woundInfoData: WoundInfo[], action?: string) => {
    const formattedWoundData = woundInfoData?.map(wound => {
       const {
         checkboxes,
         displayTotalSize,
         displayWoundDimensions,
         displayEstimateSurfaceArea,
         displayTotalWoundVolume,
         ...restWoundData
       } = wound;
       return restWoundData;
    });
    const woundInfo = {
      woundData: formattedWoundData,
      totalSizeOfAllWounds: calculatePatientWoundTotalSize(woundInfoData),
      maxWoundId: action === "DELETE" ? maxWoundRowIndex : maxWoundRowIndex + 1
    };

    if (patientData?.patientId) {
      const woundRequest: SaveWoundInfoRequest = {
        patientId: patientData.patientId,
        woundInfo: {
          infoType: PATIENT_IVR_INFO_TYPES.WOUND_INFO,
          isEdited: false,
          patientinfoId: patientWoundInfo,
          infoTypeData: {
            woundInfo: woundInfo
          }
        }
      }
      dispatch(saveWoundInfo(woundRequest));
    }
  };


  const handleCheckbox = (e: React.ChangeEvent<HTMLInputElement>, woundKey: string) => {
    const { checked } = e.target;
    setSelectedWoundList((prevValues) => {
      if (checked) {
        if (!prevValues.includes(woundKey)) {
          clearCachedAnswersForWound(woundKey);
          const updatedList = [...prevValues, woundKey];
          return updatedList;
        }
      } else {
        removeWoundQuestion(woundKey);
        const updatedList = prevValues.filter((item) => item !== woundKey);
        return updatedList;
      }
      return prevValues;
    });
  };

  const setProcessedWoundData = (woundDataList: WoundInfo[]) => {
    const processedWoundData = woundDataList?.map((woundData: WoundInfo, i: number) => {
      const totalSize = parseFloat(woundData.totalSize as unknown as string);
      const totalSizeFormatted = isNaN(totalSize) ? '0.00' : totalSize.toFixed(2);
      const cptFormatted = Array.isArray(woundData.cpt) ? woundData.cpt.join(', ') : woundData.cpt;
      const lengthValue = parseFloat(woundData.length as unknown as string);
      const widthValue = parseFloat(woundData.width as unknown as string);
      const depthValue = parseFloat(woundData.depth as unknown as string);
      const estimateSurfaceArea = (!isNaN(lengthValue) && !isNaN(widthValue))
        ? (lengthValue * widthValue).toFixed(2)
        : '0.00';
      const totalWoundVolume = (!isNaN(lengthValue) && !isNaN(widthValue) && !isNaN(depthValue))
        ? (lengthValue * widthValue * depthValue).toFixed(2)
        : '0.00';
      const woundInfoKey = woundData.woundInfoKey ? woundData.woundInfoKey : generateUniqueId(maxWoundRowIndex > 0 ? maxWoundRowIndex + 1 : i + 1);
      return {
        checkboxes: woundCheckboxComponent(woundData, woundData.woundInfoKey ? woundData.woundInfoKey : generateUniqueId(maxWoundRowIndex > 0 ? maxWoundRowIndex + 1 : i + 1)),
        woundType: woundData.woundType,
        procedureLocation: woundData.procedureLocation,
        cpt: cptFormatted,
        cptIds: woundData.cptIds,
        lCode: woundData.lCode || '',
        lCodeIds: woundData.lCodeIds,
        icd10: woundData.icd10,
        icdIds: woundData.icdIds,
        eCode: woundData.eCode || '',
        eCodeIds: woundData.eCodeIds,
        iCode: woundData.iCode || '',
        iCodeIds: woundData.iCodeIds,
        otherDxCodes: woundData.otherDxCodes,
        noOfApplications: woundData.noOfApplications,
        length: woundData.length,
        width: woundData.width,
        depth: woundData.depth,
        totalSize: totalSizeFormatted,
        displayWoundDimensions: `${woundData.length}cm X ${woundData.width}cm X ${woundData.depth}cm`,
        displayEstimateSurfaceArea: `${estimateSurfaceArea}cm²`,
        displayTotalWoundVolume: `${totalWoundVolume}cm³`,
        woundInfoKey: woundInfoKey,
        incisionMeasurement: woundData.incisionMeasurement,
        surgicalIncision: woundData.surgicalIncision,
        exudateDrainage: woundData.exudateDrainage,
        odor: woundData.odor,
        periIncisionErythema: woundData.periIncisionErythema,
        periIncisionSkin: woundData.periIncisionSkin,
        periIncisionTemperature: woundData.periIncisionTemperature,
        //CS-1193 -Start
        dateOfSurgery: woundData.dateOfSurgery,
        //CS-1193 -End
        edema: woundData.edema,
        eschar: woundData.eschar,
        exudate: woundData.exudate,
        drainage: woundData.drainage,
        erythema: woundData.erythema,
        skin: woundData.skin,
        temperature: woundData.temperature,
        cellulitis:   woundData.cellulitis,
        debrided: woundData.debrided,

        undermining: woundData.undermining,
        tunneling: woundData.tunneling,
        pain: woundData.pain,
        severity: woundData.severity,
        woundKeyDisplayValue: formatWoundName(woundData.woundType, woundInfoKey)
                   
      };
    }) || [];
    return processedWoundData;
  };

  // Format productSizes array
  function formatProductSizes(productSizes: any[]) {
    return productSizes.map(item => {
      const parts = item.split(' - ');

      const productItemHcpcsCode = parts[0];
      const size = parts[1] ? parts[1].replace(/"/g, '') : '';
      const productItemDescription = parts[2] || '';

      return {
        size: size,
        description: productItemDescription,
        hcpcsCode: productItemHcpcsCode
      };
    });
  }

  //Transform the fetched object type to form object type
  async function transformData(data: any): Promise<IVRInfo> {
    const patientInfo = data.patient.patientInfo.reduce(
      (acc: any, info: any) => {
        if (info.infoType === PATIENT_IVR_INFO_TYPES.ADDRESS) {
          acc.patientStreetAddress = info?.patientinfoData.patientStreetAddress;
          acc.patientUnitNumber = info?.patientinfoData.patientUnitNumber;
          acc.patientCity = info?.patientinfoData.patientCity;
          acc.patientState = info?.patientinfoData.patientState;
          acc.patientZipcode = info?.patientinfoData.patientZip;
          setPatientInfoIdAddress(info.patientinfoId)
        } else if (info.infoType === PATIENT_IVR_INFO_TYPES.FACE_SHEET) {
          if (info?.patientinfoData?.ivrDocumentListDTOs) {
            acc.faceSheet.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
            faceSheetDocumentIdsRef.current.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
          }
          setPatientInfoIdFaceSheet(info.patientinfoId)
          if (info?.patientinfoData?.isSkipped) {
            acc.isFaceSheetSkipped = true
          }
        }
        return acc;
      },
      {
        patientStreetAddress: "",
        patientUnitNumber: "",
        patientCity: "",
        patientState: "",
        patientZipcode: "",
        faceSheet: [],
      }
    );

    const insuranceInfo = data.patient.patientInfo.reduce(
      (acc: any, info: any) => {
        if (info.infoType === PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE) {
          if (info?.patientinfoData.isPolicyUnderDifferentName === "yes") {
            setIsPolicyUnderDifferentNameCheck(true);
          }
          
          acc.insuranceName = info?.patientinfoData?.insuranceCategory === "Commercial" && info?.patientinfoData?.primaryCommercialInsuranceName ? "Other" : info?.patientinfoData?.insuranceName;
          acc.insuranceCategory= info?.patientinfoData?.insuranceCategory;
          acc.primaryCommercialInsuranceName= info?.patientinfoData?.primaryCommercialInsuranceName;
          acc.insurancePayerCode=info?.patientinfoData?.insuranceCategory === "Commercial" && info?.patientinfoData?.primaryCommercialInsuranceName ?"0": info?.patientinfoData?.insurancePayerCode;
          acc.policy = info?.patientinfoData.policy;
          acc.isPolicyUnderDifferentName =
            info?.patientinfoData.isPolicyUnderDifferentName;
          acc.policyholderFirstName =
            info?.patientinfoData.policyHolderFirstName;
          acc.policyholderMiddleName =
            info?.patientinfoData.policyHolderMiddleName;
          acc.policyholderLastName = info?.patientinfoData.policyHolderLastName;
          acc.policyHolderDOB = info?.patientinfoData.policyHolderDOB;
          acc.insuranceType = info?.patientinfoData.insuranceType;
          if (info?.patientinfoData?.ivrDocumentListDTOs) {
            acc.insuranceCards.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
            insuranceCardsDocumentIdsRef.current.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
          }
          if (info?.patientinfoData?.isSkipped) {
            acc.isInsuranceCardsSkipped = true
          }
          setPatientInfoIdPrimaryInsurance(info.patientinfoId)
        } else if (
          info.infoType === PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE &&
          info?.patientinfoData.insuranceName !== undefined &&
          info?.patientinfoData.insuranceName !== ""
        ) {
          acc.secondaryInsurance = true;
          if (info?.patientinfoData.isPolicyUnderDifferentName === "yes") {
            setIsPolicyUnderDifferentNameCheckSecondary(true);
          }
          acc.secondaryInsuranceName = info?.patientinfoData.insuranceName;
          acc.secondaryInsuranceCategory= info?.patientinfoData?.insuranceCategory;
          acc.secondaryInsurancePayerCode=info?.patientinfoData?.insuranceCategory === "Commercial" && info?.patientinfoData?.secondaryCommercialInsuranceName ?"0": info?.patientinfoData?.insurancePayerCode;
          acc.secondaryPolicy = info?.patientinfoData.policy;
          acc.isSecondaryPolicyUnderDifferentName =
            info?.patientinfoData.isPolicyUnderDifferentName;
          acc.secondarypolicyholderFirstName =
            info?.patientinfoData.policyHolderFirstName;
          acc.secondarypolicyholderMiddleName =
            info?.patientinfoData.policyHolderMiddleName;
          acc.secondarypolicyholderLastName =
            info?.patientinfoData.policyHolderLastName;
          acc.secondaryPolicyHolderDOB = info?.patientinfoData.policyHolderDOB;
          acc.secondaryInsuranceType = info?.patientinfoData.insuranceType;
          if (info?.patientinfoData?.ivrDocumentListDTOs) {
            acc.secondaryInsuranceCards.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
            setIsSecondaryInsurance(true);
            secondaryInsuranceCardsDocumentIdsRef.current.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
          }
          if (info?.patientinfoData?.isSkipped) {
            acc.isSecondaryInsuranceCardsSkipped = true
          }
          setPatientInfoIdSecondaryInsurance(info.patientinfoId)
        }
        return acc;
      },
      {
        insuranceName: "",
        policy: "",
        isPolicyUnderDifferentName: false,
        policyholderFirstName: "",
        policyholderMiddleName: "",
        policyholderLastName: "",
        policyHolderDOB: "",
        insuranceType: "",
        insuranceCards: [],
        isSecondaryInsurance: false,
        secondaryInsuranceName: "",
        secondaryPolicy: "",
        isSecondaryPolicyUnderDifferentName: false,
        secondarypolicyholderFirstName: "",
        secondarypolicyholderMiddleName: "",
        secondarypolicyholderLastName: "",
        secondaryPolicyHolderDOB: "",
        secondaryInsuranceType: "",
        secondaryInsuranceCards: [],
      }
    );

    const supportingDocumentation = data.patient.patientInfo.reduce(
      (acc: any, info: any) => {
        if (info.infoType === PATIENT_IVR_INFO_TYPES.MEDICAL_NOTES) {
          if (info?.patientinfoData?.ivrDocumentListDTOs) {
            acc.supportingDocuments.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
            supportingDocsDocumentIdsRef.current.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
          }
          if (info?.patientinfoData?.isSkipped) {
            acc.isSupportingDocumentsSkipped = true
          }
          setPatientInfoIdSupportingDocs(info.patientinfoId)
        } else if (info.infoType === PATIENT_IVR_INFO_TYPES.IMAGE_OF_WOUNDS) {
          if (info?.patientinfoData?.ivrDocumentListDTOs) {
            acc.imageOfWounds.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
            imageOfWoundsDocumentIdsRef.current.push(
              ...info?.patientinfoData.ivrDocumentListDTOs.map(
                (doc: any) => doc.documentId
              )
            );
          }
          if (info?.patientinfoData?.isSkipped) {
            acc.isImageOfWoundsSkipped = true
          }
          setPatientInfoIdWoundImages(info.patientinfoId)
        }
        return acc;
      },
      {
        supportingDocuments: [],
        imageOfWounds: [],
      }
    );

    const woundDataList = data?.ivrInfo?.woundInfo?.woundData;
        const savedWoundInfoKeys: string[] = [];
    woundDataList?.forEach((wound: { woundInfoKey: any; }) => {
      savedWoundInfoKeys.push(wound.woundInfoKey)
    });
    setSelectedWoundList(savedWoundInfoKeys);
    setIsAddIncisionButtonDisabled(data?.ivrInfo?.woundInfo?.isLoadedFromProviderTemplate)

    const isOnViewOnly = location?.state?.viewOnly;
    const isDuplicateIVR = location?.state?.duplicateIVR;
    if (isOnViewOnly) {
      let processedWoundData = setProcessedWoundData(woundDataList);
      setWoundInfoRows(processedWoundData || []);
    }

    if (data.ivrInfo.treatmentInfo.productId) {
      const onlyActiveRecords = true;
      dispatch(fetchProductItemsByProductId({ productId: data.ivrInfo.treatmentInfo.productId, onlyActiveRecords }));
    }

    const providerData = data.ivrInfo.providerInfo.provider;
    setSelectedProviderData([providerData]);
    
    // if (data.ivrInfo.treatmentInfo.currentlyUnderSurgicalGlobalPeriod === "true") {
    //   setIsUnderSurgicalGlobalPeriod(true);
    // }

    // if (data.ivrInfo.treatmentInfo.currentlyInNursingFacility === "true") {
    //   setIsPatientCurrentlyInNursingFacility(true)
    // }

    //Load products list
    if (!location?.state?.duplicateIVR) {
      setDisableProductField(false);
    }

    // handleFetchPracticeProducts(data?.dateOfService, data.practiceId, data.providerId);
    setSelectedProducts(data.ivrInfo.treatmentInfo.products);

    if (data.ivrInfo?.patientConsentInfo?.isPatientConsentSigned === "yes") {
      setShowPatientSignDate(true);
    }

    if (data.productCategory) {
      setSelectedProductCategory(data.productCategory)
    }

    if (data.ivrInfo.treatmentInfo.products[0]?.isKit === false) {
      const formattedData = formatProductSizes(data.ivrInfo.treatmentInfo.products[0]?.productSizes);
      setKitItemData(formattedData)
    }

    if (data.ivrInfo.treatmentInfo.products[0]?.productKitItemId) {
      const response = await dispatch(getProductItemkitItem({ productItemId: data.ivrInfo.treatmentInfo.products[0].productKitItemId, skipLoader: false }))
      setKitItemData(response.payload.data);
    }

    return {
      typeOfIVR: data.benefitVerificationType,
      patientInfo: {
        patientId: data.patient.patientId,
        patientFirstName: data.patient.firstName,
        patientMiddleName: data.patient.middleName,
        patientLastName: data.patient.lastName,
        patientDOB: data.patient.birthDate,
        gender: data.patient.gender,
        ...patientInfo,
      },
      insuranceInfo: {
        ...insuranceInfo,
      },
      supportingDocumentation: {
        ...supportingDocumentation,
      },
      patientConsentInfomation: {
        isPatientConsentSigned: data.ivrInfo.patientConsentInfo?.isPatientConsentSigned,
        patientSignDate: data.ivrInfo.patientConsentInfo?.patientSignDate,
      },
      treatmentInformation: {
        // currentlyInNursingFacility:
        //   data.ivrInfo.treatmentInfo.currentlyInNursingFacility,
        // daysAdmittedToFacility: data.ivrInfo.treatmentInfo.daysAdmittedToFacility,
        // currentlyUnderSurgicalGlobalPeriod:
        //   data.ivrInfo.treatmentInfo.currentlyUnderSurgicalGlobalPeriod,
        // surgicalProcedureDate: data.ivrInfo.treatmentInfo.surgicalProcedureDate,
        // surgicalProcedureCodes:
        //   data.ivrInfo.treatmentInfo.surgicalProcedureCodes,
        homeHealth: data.ivrInfo.treatmentInfo.homeHealth,
        dateOfService: data.dateOfService,
        placesOfService: data.ivrInfo.treatmentInfo.placesOfService[0],
        product: data.ivrInfo.treatmentInfo.productId,
        practiceProductId: data.ivrInfo.treatmentInfo.products[0].practiceProductId,
        productSizes: data.ivrInfo.treatmentInfo.productSizes,
        products: data.ivrInfo.treatmentInfo.products,
        currentlyCoveredUnderPartAStay: data.ivrInfo.treatmentInfo.currentlyCoveredUnderPartAStay
      },
      providerInformation: {
        practice: data.practiceId,
        provider: data.providerId,
        practiceLocation: data.locationId,
        macId: data.macId,
        providerSignedDate: new Date(data.ivrInfo.providerInfo.date),
        signature: data.ivrInfo.providerInfo.signature,
        name: location?.state?.copiedIvr ? "" : data.ivrInfo.providerInfo.name,
      },
      checkProviderSignAuth: data.ivrInfo.providerInfo.signature ? true : false,
      comments: data.ivrInfo?.additionalNotes?.content,
      productQuestions: !isDuplicateIVR ? data.ivrInfo.treatmentInfo.productQuestions : null,
      safeguardQuestions: !isDuplicateIVR ? data.ivrInfo.treatmentInfo.safeguardQuestions : null,
    };
  }
  const secondaryPayersOptions = useMemo(() => {
    let options: Option[] = [];
    const secondaryInsurancecategory = watch('insuranceInfo.secondaryInsuranceCategory')
    if(secondaryInsurancecategory !== "Commercial"){
        allPayerList?.filter((payers: any) => payers.category === secondaryInsurancecategory).map((payers: any) => {
            options.push({
                value: payers.payerCode,
                label: payers.payerName,
            });
        });
        if(options.length === 1){
          setValue('insuranceInfo.secondaryInsurancePayerCode', options[0].value);
          setValue('insuranceInfo.secondaryInsuranceName', options[0].label);
      }
    }else{
        allPayerList
          ?.filter((payers: any) => payers.category === secondaryInsurancecategory)
          .forEach((payers: any) => {
            options.push({
              value: payers.payerCode,
              label: payers.payerName,
            });
        options.push({ value: "0", label: "Other" });
      });
    }
    return options;
}, [allPayerList, watch('insuranceInfo.secondaryInsuranceCategory')]);
      const primaryPayersOptions = useMemo(() => {
          let options: Option[] = [];
          const primaryInsuranceCategory = watch('insuranceInfo.insuranceCategory')
          if(primaryInsuranceCategory !== "Commercial"){
          allPayerList?.filter((payers: any) => payers.category === primaryInsuranceCategory).map((payers: any) => {
              options.push({
                  value: payers.payerCode,
                  label: payers.payerName,
              });
          });
          if(options.length === 1){
            setValue('insuranceInfo.insurancePayerCode', options[0].value);
            setValue('insuranceInfo.insuranceName', options[0].label);
        }
      }else{
          allPayerList
            ?.filter((payers: any) => payers.category === primaryInsuranceCategory)
            .forEach((payers: any) => {
              options.push({
                value: payers.payerCode,
                label: payers.payerName,
              });
            });
          options.push({ value: "0", label: "Other" });

      }
          return options;
      }, [allPayerList, watch('insuranceInfo.insuranceCategory')]);


      useEffect (() => {
        console.log(woundInfoRows)
      }, [woundInfoRows])

  const insuranceCategory = useMemo(() => {
    let insuranceCategory: CodeTable[] = [];
    if (allCodeTablesValuesMap) {
        insuranceCategory = getCodeTableValuesByTableName(allCodeTablesValuesMap, "InsuranceCategory");
    }
    if (!insuranceCategory || insuranceCategory.length === 0) {
      dispatch(fetchAllCodeTablesValues());
    }
    let options: { label: string, value: any }[] = [];
    insuranceCategory?.map((option) => {
      options.push({ label: option.displayValue, value: option.keyName });

    });
    return options;
  }, [allCodeTablesValuesMap]);
  const placesOfService = useMemo(() => {
    let placeOfService: CodeTable[] = [];
    if (allCodeTablesValuesMap) {
      placeOfService = getCodeTableValuesByTableName(allCodeTablesValuesMap, "PlaceOfService");
    }
    if (!placeOfService || placeOfService.length === 0) {
      dispatch(fetchAllCodeTablesValues());
    }
    let options: { label: string, value: any }[] = [];
    placeOfService?.map((option) => {
      options.push({ label: option.displayValue, value: option.keyName });

    });
    return options;
  }, [allCodeTablesValuesMap]);


  const practiceProvidersOptions = useMemo(() => {
    let options: { label: string; value: number }[] = [];
    practiceProvidersInfo?.map((option: any) => {
      options.push({
        label: `${option.title ? option.title : ""} ${option.firstName ? option.firstName : ""} ${option.middleName ? option.middleName + " " : ""
          }${option.lastName ? option.lastName : ""}`,
        value: option.providerId,
      });
    });
    return options;
    return [];
  }, [practiceProvidersInfo]);

  const practiceLocationsOptions = useMemo(() => {
    let options: { label: string; value: number }[] = [];
    practiceLocationsInfo?.map((option: any) => {
      const locationParts = [option.streetAddress, option.unitNumber, option.city, option.state, option.zipCode];
      const filteredLocationParts = locationParts.filter(part => part !== undefined && part !== null && part.trim() !== "");
      const locationName = filteredLocationParts?.join(", ")
      options.push({
        // label: `${option.streetAddress} ${option.unitNumber} ${option.city} ${option.state} ${option.zipCode}`,
        label: locationName,
        value: option.locationId,
      });
    });
    return options;
    return [];
  }, [practiceLocationsInfo]);

  const billingLocation = practiceLocationsInfo?.find(
    (location) => location.locationType === "BILLING"
  );

  useEffect(() => {
    if (billingLocation) {
      setValue("providerInformation.practiceLocation", billingLocation.locationId.toString());
      checkProductInfoValidity(getValues());
    }
  }, [billingLocation, getValues, setValue]);

  const patientsOptions = React.useMemo(() => {
    let options: { label: string; value: string; patientCode: string }[] = [];
    patientList?.map((option: any) => {
      options.push({
        label: fullName(
          "",
          option.firstName,
          option.middleName,
          option.lastName
        ) + " - " + option.birthDate,
        value: option.patientId,
        patientCode: option.patientCode,
      });
    });
    return options;
  }, [patientList]);

  useEffect(() => {
    if (practiceID) {
      dispatch(fetchActivePracticeProvidersData({ productId: practiceID, onlyActiveRecords: true }));
      dispatch(fetchActivePracticeLocationsData(practiceID));
      fetchPatientsList();
      setValue("providerInformation.practice", practiceID);
    }
  }, [practiceID]);

  const fetchPatientsList = async () => {
    await dispatch(getPatientListByPracticeId({ practiceId: practiceID }));
  };

  useEffect(() => {
    const calculatePatientTotalSize = () => {
      let totalValid = 0;
      const woundData = woundInfoRows.map((current) => {
        const volume = getWoundVolume(current);
        if (!isNaN(volume)) {
          totalValid += Math.round(volume * 100); //CS-1654
        }

        return {
          woundType: current.woundType,
          noOfApplications: current.noOfApplications,
          cpt: current.cpt,
          eCode: current.eCode,
          iCode: current.iCode,
          lCode: current.lCode,
          icd10: current.icd10,
          otherDxCodes: current.otherDxCodes,
          totalSize: current.totalSize.toString(),
        };
      });
      totalValid = totalValid / 100; //CS-1654
      setPatientWoundTotalSize(totalValid);
      setValue("woundInfo.woundData", woundData);
    }

    if (woundInfoRows) {
      // const maxNumber = getMaxWoundInfoKey(woundInfoRows);
      // setMaxWoundRowIndex(maxNumber);
      calculatePatientTotalSize();
    }
  }, [woundInfoRows]);

  const generateUniqueId = (index: number): string => {
    return `${`WOUND`}_${index}`;
  };
  useEffect(() => {
    let processedWoundData = setProcessedWoundData(woundInfoRows);
    if (JSON.stringify(processedWoundData) !== JSON.stringify(woundInfoRows)) {
      setWoundInfoRows(processedWoundData);
    }

    const woundData = woundInfoRows?.map((row) => ({
      woundType: row.woundType,
      procedureLocation: row.procedureLocation,
      cpt: row.cpt,
      cptIds: row.cptIds,
      lCode: row.lCode,
      lCodeIds: row.lCodeIds,
      eCode: row.eCode,
      eCodeIds: row.eCodeIds,
      iCode: row.iCode,
      iCodeIds: row.iCodeIds,
      icd10: row.icd10,
      icdIds: row.icdIds,
      otherDxCodes: row.woundType === "Surgical Incision" ? row.icd10 :row.otherDxCodes,
      noOfApplications: row.noOfApplications,
      length: row.length,
      width: row.width,
      depth: row.depth,
      totalSize: row.totalSize.toString(),
      woundInfoKey: row.woundInfoKey,
      incisionMeasurement: row.incisionMeasurement,
      surgicalIncision: row.surgicalIncision,
      exudateDrainage: row.exudateDrainage,
      odor: row.odor,
      periIncisionErythema: row.periIncisionErythema,
      periIncisionSkin: row.periIncisionSkin,
      periIncisionTemperature: row.periIncisionTemperature,
      //CS-1193 - Start
      dateOfSurgery:  row.dateOfSurgery ? moment(row.dateOfSurgery?.toString())?.format("MM/DD/YYYY") : "",
      //CS-1193 -End
      edema: row.edema,
      eschar: row.eschar,
      undermining: row.undermining,
      tunneling: row.tunneling,
      pain: row.pain,
      severity: row.severity
    }));
    const woundInfo = {
      woundData: woundData,
      totalSizeOfAllWounds: patientWoundTotalSize,
    };

    const checkedWoundInfo: any[] = [];
    selectedWoundList?.forEach(woundKey => {
      const foundWound = woundInfo?.woundData?.find(wound => wound.woundInfoKey === woundKey);
      if (foundWound) {
        checkedWoundInfo.push(foundWound);
      }
    });
    setCheckedWoundData(checkedWoundInfo);

  }, [selectedWoundList, woundInfoRows, patientWoundTotalSize]);

  useEffect(() => {
    if (maxWoundIdFromMount) {
      setMaxWoundRowIndex(maxWoundIdFromMount);
      setMaxWoundIdFromMount(null);
    } else if (!isDeleting && woundInfoRows && woundInfoRows.length > 0) {
      const maxNumber = getMaxWoundInfoKey(woundInfoRows);
      setMaxWoundRowIndex(maxNumber);
    }

    if (isDeleting) {
      saveWoundInfoRows(woundInfoRows, "DELETE");
      setIsDeleting(false);
    }
  }, [woundInfoRows]);

  useEffect(() => {
    const calculateTotalSize = () => {
      let totalValid = 0;
      let foundValidNumber = false;

      // const checkedWoundInfo: any[] = [];
      // selectedWoundList?.forEach(woundKey => {
      //   const foundWound = woundInfoRows?.find(wound => wound.woundInfoKey === woundKey);
      //   if (foundWound) {
      //     checkedWoundInfo.push(foundWound);
      //   }
      // });
      checkedWoundData.forEach((current) => {
        const volume = getWoundVolume(current);
        if (!isNaN(volume)) {
          totalValid += Math.round(volume * 100); //CS-1654
          foundValidNumber = true;
        }

        return {
          woundType: current.woundType,
          noOfApplications: current.noOfApplications,
          cpt: current.cpt,
          eCode: current.eCode,
          iCode: current.iCode,
          lCode: current.lCode,
          icd10: current.icd10,
          otherDxCodes: current.otherDxCodes,
          totalSize: current.totalSize.toString(),
        };
      });
      totalValid = totalValid / 100; //CS-1654

      if (foundValidNumber) {
        setValue("woundInfo.totalSizeOfAllWounds", totalValid.toString());
      } else {
        setValue("woundInfo.totalSizeOfAllWounds", "");
      }
      trigger("woundInfo.totalSizeOfAllWounds");
      trigger("woundInfo.woundData");
    };
    calculateTotalSize();
  }, [selectedWoundList, woundInfoRows, checkedWoundData])

  const typeOfIVROptions = [
    { value: "newApplication", label: "New Application" },
    { value: "additionalApplication", label: "Additional Application" },
    { value: "reVerification", label: "Re-Verification" },
    { value: "newInsurance", label: "New Insurance" },
  ];

  const patientGenderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  const policyOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const consentOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "n/a", label: "N/A" },
  ];

  const patientInNursingFacilityOrHomeOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  // const patientUnderSurgicalOrGlobalPeriodOptions = [
  //   { value: true, label: "Yes" },
  //   { value: false, label: "No" },
  // ];

  const changeProvider = () => {
    const providerId = getValues("providerInformation.provider");
    const selectedProvider =
      practiceProvidersInfo &&
      practiceProvidersInfo.find(
        (provider) => provider.providerId === parseInt(providerId)
      );
    if (selectedProvider != undefined) {
      const data = [
        {
          providerName: fullName(
            selectedProvider?.title ? selectedProvider?.title : null,
            selectedProvider?.firstName,
            selectedProvider?.middleName,
            selectedProvider?.lastName
          ),
          npi: selectedProvider?.npi,
          ptan: selectedProvider?.ptan,
          taxId: selectedProvider?.taxId,
        },
      ];
      setSelectedProviderData(data);
    } else {
      setSelectedProviderData([]);
      setDisableProductField(true);
      
      setValue("treatmentInformation.dateOfService", "");
      setValue("treatmentInformation.products", []);
      setValue("treatmentInformation.practiceProductId", 0);
      setValue("treatmentInformation.productSizes", []);
      setSelectedProducts([]);
      checkSectionValidity();

    }
  };

  const clearQuestions = () =>{
    setValue('productQuestions', null);
    setValue('safeguardQuestions', null);
    dispatch(resetProductQuestions());
    dispatch(resetSafeguardQuestions());
  }

  const handleProviderChange = () => {
    changeProvider();
    clearQuestions();
  };

  const handleAddWoundInfo = (woundInfoData: WoundInfo) => {
    const lengthValue = parseFloat(woundInfoData.length as unknown as string);
    const widthValue = parseFloat(woundInfoData.width as unknown as string);
    const depthValue = parseFloat(woundInfoData.depth as unknown as string);
    const estimateSurfaceArea = (!isNaN(lengthValue) && !isNaN(widthValue))
      ? (lengthValue * widthValue).toFixed(2)
      : '0.00';
    const totalWoundVolume = (!isNaN(lengthValue) && !isNaN(widthValue) && !isNaN(depthValue))
      ? (lengthValue * widthValue * depthValue).toFixed(2)
      : '0.00';
    const displayWoundDimensions = `${woundInfoData.length}cm X ${woundInfoData.width}cm X ${woundInfoData.depth}cm`;
    const displayEstimateSurfaceArea = `${estimateSurfaceArea}cm²`;
    const displayTotalWoundVolume = `${totalWoundVolume}cm³`;

    const updatedWoundInfoData = {
      ...woundInfoData,
      displayWoundDimensions,
      displayEstimateSurfaceArea,
      displayTotalWoundVolume,
    };
    let updatedWoundInfoData2 = { ...updatedWoundInfoData };
      if(woundInfoData){
      const cptFormatted = Array.isArray(updatedWoundInfoData2.cpt) ? updatedWoundInfoData2.cpt.join(', ') : updatedWoundInfoData2.cpt;
      const eCodesFormatted = Array.isArray(updatedWoundInfoData2.eCode) ? updatedWoundInfoData2.eCode.join(', ') : updatedWoundInfoData2.eCode;
      const iCodesFormatted = Array.isArray(updatedWoundInfoData2.iCode) ? updatedWoundInfoData2.iCode.join(', ') : updatedWoundInfoData2.iCode;
      const lCodesFormatted = Array.isArray(updatedWoundInfoData2.lCode) ? updatedWoundInfoData2.lCode.join(', ') : updatedWoundInfoData2.lCode;
      const icd10Formatted = Array.isArray(updatedWoundInfoData2.icd10) ? updatedWoundInfoData2.icd10.join(', ') : updatedWoundInfoData2.icd10;

      const woundInfoKey = updatedWoundInfoData2?.woundInfoKey ? updatedWoundInfoData2?.woundInfoKey : generateUniqueId(maxWoundRowIndex + 1);
      updatedWoundInfoData2 = {
        ...updatedWoundInfoData2,
        cptIds: (woundInfoData.cptIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        eCodeIds: (woundInfoData.eCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),   
        iCodeIds: (woundInfoData.iCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        lCodeIds: (woundInfoData.lCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        icdIds: (woundInfoData.icdIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
        cpt: cptFormatted,
        eCode: woundInfoData.eCode ? eCodesFormatted : '',
        iCode: woundInfoData.iCode ? iCodesFormatted : '',
        lCode: woundInfoData.lCode ? lCodesFormatted : '',
        icd10: icd10Formatted,
        otherDxCodes: woundInfoData.woundType === "Surgical Incision" ? icd10Formatted : woundInfoData.otherDxCodes,
        checkboxes: woundCheckboxComponent(null, woundInfoKey),
        woundInfoKey: woundInfoKey,
        woundKeyDisplayValue: formatWoundName(woundInfoData.woundType, woundInfoKey)
      };
      if (currentWoundInfo) {
        const updatedWoundInfo = woundInfoRows.map((item) =>
          item === currentWoundInfo ? updatedWoundInfoData2 : item
        );
        setWoundInfoRows(updatedWoundInfo);
        saveWoundInfoRows(updatedWoundInfo);
      } else {
        const newWoundRows = [...woundInfoRows, updatedWoundInfoData2]
        setWoundInfoRows(newWoundRows);
        saveWoundInfoRows(newWoundRows);
        setSelectedWoundList((prev) => {
          return [...prev, updatedWoundInfoData2?.woundInfoKey ? updatedWoundInfoData2.woundInfoKey : ""]
        });
      }
      setShowWoundInfoPopup(false);
      setCurrentWoundInfo(null);
    }
  };

  useEffect(() => {
    checkWoundInfoValidity({ ...watch() });
  }, [woundInfoRows, watch]);

  //CS-1519
  useEffect(() => {
    checkSafeguardQuestionsValidity({ ...watch() });
  }, [watch("treatmentInformation.homeHealth"), selectedProductCategory, selectedProducts]);

  //CS-1519 START
  useEffect(() => {
    if (productQuestions?.length > 0 || safeguardQuestions?.length > 0) {
      checkSafeguardQuestionsValidity({ ...watch() });
    }
  }, [productQuestions, safeguardQuestions]);

  // Watch for changes in form values and trigger validation
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name && (name.startsWith('productQuestions') || name.startsWith('safeguardQuestions'))) {
        checkSafeguardQuestionsValidity(value);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, productQuestions, safeguardQuestions]);
  //CS-1519 END

  const legacyItems = [
    { icon: <ModeOutlined color="info" />, text: "Edit" },
    { icon: <DeleteOutlineOutlined color="error" />, text: "Delete" },
  ];

  const setWoundInfoDeletePopup = (rowIndex: number, woundInfoKey?: string) => {
    setShowOptionsPopup({
      message: `Wound information will be deleted from the patient profile permanently. Do you wish to proceed?`,
      show: true,
      variant: "warning",
      buttons: [{ name: "Yes", color: 'primary', onClick: () => deleteWoundInfoRow(rowIndex) }, { name: "No", color: 'error', onClick: cancelCommonOptionPopup }]
    });
  }
  const cancelCommonOptionPopup = () => {
    setShowOptionsPopup({ message: "", show: false });
  };

  const woundInfoActionComponent = (
    row: any,
    rowIndex: number
  ): JSX.Element => {
    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          tooltipMessage="Edit"
          tooltipPlacement="top"
          onClick={() => onEditClick(row, rowIndex, "woundInfo")}
          disabled={disableAllFields}
        >
          <ModeOutlined fontSize="small" />
        </CustomIconButton>{" "}
        {!row.productItemId || row.productItemId === 0 ? (
          <CustomIconButton
            color="error"
            size="small"
            variant="outlined"
            tooltipMessage="Delete"
            tooltipPlacement="top"
            onClick={() => {
              setWoundInfoDeletePopup(rowIndex, row?.woundInfoKey)
              // if (isAddIncisionButtonDisabled) {
              //   setShowOptionsPopup({
              //     show: true,
              //     variant: "error",
              //     message: (
              //       <>
              //         <strong>Unable to Delete Incision Details:</strong> Cannot delete incision details from this action because this data is populated from the provider templates. Please update the template details instead.
              //       </>
              //     ),
              //     buttons: [
              //       {
              //         name: "OK",
              //         color: "error",
              //         onClick: () => {
              //           setShowOptionsPopup({ show: false, message: "" });
              //         },
              //       },
              //     ],
              //   });
              // } else {
              //   setWoundInfoDeletePopup(rowIndex, row?.woundInfoKey)
              // }
            }}
            disabled={disableAllFields}
          >
            <DeleteOutlineOutlined fontSize="small" />
          </CustomIconButton>
        ) : null}
      </>
    );
  };

  const onEditClick = useCallback(
    (row: any, rowIndex: number, fieldName: string) => {
      setCurrentWoundInfo(row);
      if (row?.woundType === "Surgical Incision") {
        setShowIncisionInfoPopup(true);
        // if (isAddIncisionButtonDisabled) {
        //   setShowOptionsPopup({
        //     show: true,
        //     variant: "error",
        //     message: (
        //       <>
        //         <strong>Unable to Modify Incision Details:</strong> Cannot modify incision details from this action because this data is populated from the provider templates. Please update the template details instead.
        //       </>
        //     ),
        //     buttons: [
        //       {
        //         name: "OK",
        //         color: "error",
        //         onClick: () => {
        //           setShowOptionsPopup({ show: false, message: "" });
        //         },
        //       },
        //     ],
        //   });
        // } else {
        //   setShowIncisionInfoPopup(true);
        // }
      } else {
        setShowWoundInfoPopup(true);
      }
    },
    [isAddIncisionButtonDisabled]
  );

  const isDeletingRef = useRef(false); // flag to restrict double calling of the function

  const removeWoundQuestion = (woundInfoKey?: string) => {
    const productQuestionWoundList = getValues('productQuestions.WOUNDS');
    if(productQuestionWoundList && woundInfoKey) {
      const filteredEntries  = Object.entries(productQuestionWoundList).filter(([key]) => key != woundInfoKey);
      const formattedProdQList = Object.fromEntries(filteredEntries);
      setValue('productQuestions.WOUNDS', formattedProdQList);
    }
  };

  const clearCachedAnswersForWound = (woundInfoKey?: string) => {
    const productQuestionWoundList = getValues('productQuestions.WOUNDS') || {};
    if(woundInfoKey) {
      productQuestionWoundList[woundInfoKey] = null;
      setValue('productQuestions.WOUNDS', productQuestionWoundList)
    }
  };

  const deleteWoundInfoRow = (rowIndex: number) => {
    if (isDeletingRef.current) return;
    isDeletingRef.current = true;
    setIsDeleting(true);
    onDeleteClick(rowIndex);

    setTimeout(() => {
      isDeletingRef.current = false;
    }, 100);
  };

  const onDeleteClick = (rowIndex: number) => {
    const woundDeleted = woundInfoRows.find((_, index) => index === rowIndex);
    removeWoundQuestion(woundDeleted?.woundInfoKey);
    setWoundInfoRows((currentRows) => {
      const updatedRows = currentRows.filter((_, index) => index !== rowIndex);
      return updatedRows;
    });
    checkWoundInfoValidity({ ...watch() });
    setShowErrorAlert(false);
    cancelCommonOptionPopup();
  };

  const convertBase64 = (file: any) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    });
  };

  const removeDataUriPrefix = (dataUri: string): string => {
    const base64String = dataUri.split(",")[1];
    return base64String || "";
  };

  const handleFaceSheetChange = async (uploadedFiles: ExtendedFile[]) => {
    const newFiles = uploadedFiles.filter((file) => !file.documentId);

    if (newFiles.length > 0) {
      dispatch(showHideLoadingDialog(true));
      try {
        setValue("patientInfo.isFaceSheetSkipped", false, { shouldValidate: true, shouldDirty: true });
        for (const fileData of newFiles) {
          let base64File = String(await convertBase64(fileData));
          const FaceSheetObject: IVRDocumentInfo = {
            ivrId: ivrId,
            documentName: fileData.name,
            content: removeDataUriPrefix(base64File),
            type: "IVR",
            fileType: fileData.type,
          };

          const response = await dispatch(uploadIVRDocument(FaceSheetObject));
          let documentId = response.payload.data.documentId;
          fileData.documentId = documentId;
          faceSheetDocumentIdsRef.current.push(documentId);
        }

        setValue("patientInfo.faceSheet", faceSheetDocumentIdsRef.current);
        checkPatientInfoValidity({ ...watch() });
        trigger("patientInfo.faceSheet");
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        dispatch(showHideLoadingDialog(false));
      }
    }
  };

  const handleDeleteFacesheetDocument = async (documentId: number) => {
    faceSheetDocumentIdsRef.current = faceSheetDocumentIdsRef.current.filter(
      (id: number) => id != documentId
    );
    setValue("patientInfo.faceSheet", faceSheetDocumentIdsRef.current);
    if (faceSheetDocumentIdsRef.current.length === 0) {
      setValue("patientInfo.isFaceSheetSkipped", false, { shouldValidate: true, shouldDirty: true });
    }
    checkPatientInfoValidity({ ...watch() });
  };

  const handleInsuranceCardChange = async (uploadedFiles: ExtendedFile[]) => {
    const newFiles = uploadedFiles.filter((file) => !file.documentId);

    if (newFiles.length > 0) {
      dispatch(showHideLoadingDialog(true));
      try {
        setValue("insuranceInfo.isInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
        for (const fileData of newFiles) {
          let base64File = String(await convertBase64(fileData));
          const FaceSheetObject: IVRDocumentInfo = {
            ivrId: ivrId,
            documentName: fileData.name,
            content: removeDataUriPrefix(base64File),
            type: "IVR",
            fileType: fileData.type,
          };

          const response = await dispatch(uploadIVRDocument(FaceSheetObject));
          let documentId = response.payload.data.documentId;
          fileData.documentId = documentId;
          insuranceCardsDocumentIdsRef.current.push(documentId);
        }

        setValue(
          "insuranceInfo.insuranceCards",
          insuranceCardsDocumentIdsRef.current
        );
        checkInsuranceInfoValidity({ ...watch() });
        trigger("insuranceInfo.insuranceCards");
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        dispatch(showHideLoadingDialog(false));
      }
    }
  };

  const handleDeleteInsuranceDocument = async (documentId: number) => {
    insuranceCardsDocumentIdsRef.current =
      insuranceCardsDocumentIdsRef.current.filter((id) => id != documentId);
    setValue(
      "insuranceInfo.insuranceCards",
      insuranceCardsDocumentIdsRef.current
    );
    if (insuranceCardsDocumentIdsRef.current.length === 0) {
      setValue("insuranceInfo.isInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
    }
    checkInsuranceInfoValidity({ ...watch() });
  };

  const handleSupportingDocsChange = async (uploadedFiles: ExtendedFile[]) => {
    const newFiles = uploadedFiles.filter((file) => !file.documentId);

    if (newFiles.length > 0) {
      dispatch(showHideLoadingDialog(true));
      try {
        setValue("supportingDocumentation.isSupportingDocumentsSkipped", false, { shouldValidate: true, shouldDirty: true });
        for (const fileData of newFiles) {
          let base64File = String(await convertBase64(fileData));
          const FaceSheetObject: IVRDocumentInfo = {
            ivrId: ivrId,
            documentName: fileData.name,
            content: removeDataUriPrefix(base64File),
            type: "IVR",
            fileType: fileData.type,
          };

          const response = await dispatch(uploadIVRDocument(FaceSheetObject));
          let documentId = response.payload.data.documentId;
          fileData.documentId = documentId;
          supportingDocsDocumentIdsRef.current.push(documentId);
        }

        setValue(
          "supportingDocumentation.supportingDocuments",
          supportingDocsDocumentIdsRef.current
        );
        checkSupportingDocumentationValidity({ ...watch() });
        trigger("supportingDocumentation.supportingDocuments");
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        dispatch(showHideLoadingDialog(false));
      }
    }
  };

  const handleDeleteSupportingDocument = async (documentId: number) => {
    supportingDocsDocumentIdsRef.current =
      supportingDocsDocumentIdsRef.current.filter((id: number) => id != documentId);
    setValue(
      "supportingDocumentation.supportingDocuments",
      supportingDocsDocumentIdsRef.current
    );
    if (supportingDocsDocumentIdsRef.current.length === 0) {
      setValue("supportingDocumentation.isSupportingDocumentsSkipped", false, { shouldValidate: true, shouldDirty: true });
    }
    setSupportingDocsDeleted(true);
    checkSupportingDocumentationValidity({ ...watch() });
  };

  const handleImageOfWoundsChange = async (uploadedFiles: ExtendedFile[]) => {
    const newFiles = uploadedFiles.filter((file) => !file.documentId);

    if (newFiles.length > 0) {
      dispatch(showHideLoadingDialog(true));
      try {
        setValue("supportingDocumentation.isImageOfWoundsSkipped", false, { shouldValidate: true, shouldDirty: true });
        for (const fileData of newFiles) {
          let base64File = String(await convertBase64(fileData));
          const FaceSheetObject: IVRDocumentInfo = {
            ivrId: ivrId,
            documentName: fileData.name,
            content: removeDataUriPrefix(base64File),
            type: "IVR",
            fileType: fileData.type,
          };

          const response = await dispatch(uploadIVRDocument(FaceSheetObject));
          let documentId = response.payload.data.documentId;
          fileData.documentId = documentId;
          imageOfWoundsDocumentIdsRef.current.push(documentId);
        }

        setValue(
          "supportingDocumentation.imageOfWounds",
          imageOfWoundsDocumentIdsRef.current
        );
        checkSupportingDocumentationValidity({ ...watch() });
        trigger("supportingDocumentation.imageOfWounds");
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        dispatch(showHideLoadingDialog(false));
      }
    }
  };

  const handleDeleteImageOfWoundsDocument = async (documentId: number) => {
    imageOfWoundsDocumentIdsRef.current =
      imageOfWoundsDocumentIdsRef.current.filter((id: number) => id != documentId);
    setValue(
      "supportingDocumentation.imageOfWounds",
      imageOfWoundsDocumentIdsRef.current
    );
    if (imageOfWoundsDocumentIdsRef.current.length === 0) {
      setValue("supportingDocumentation.isImageOfWoundsSkipped", false, { shouldValidate: true, shouldDirty: true });
    }
    setImagesOfWoundsDeleted(true);
    checkSupportingDocumentationValidity({ ...watch() });
  };

  const handleSecondaryInsuranceCardChange = async (
    uploadedFiles: ExtendedFile[]
  ) => {
    const newFiles = uploadedFiles.filter((file) => !file.documentId);

    if (newFiles.length > 0) {
      dispatch(showHideLoadingDialog(true));
      try {
        setValue("insuranceInfo.isSecondaryInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
        for (const fileData of newFiles) {
          let base64File = String(await convertBase64(fileData));
          const FaceSheetObject: IVRDocumentInfo = {
            ivrId: ivrId,
            documentName: fileData.name,
            content: removeDataUriPrefix(base64File),
            type: "IVR",
            fileType: fileData.type,
          };

          const response = await dispatch(uploadIVRDocument(FaceSheetObject));
          let documentId = response.payload.data.documentId;
          fileData.documentId = documentId;
          secondaryInsuranceCardsDocumentIdsRef.current.push(documentId);
        }

        setValue(
          "insuranceInfo.secondaryInsuranceCards",
          secondaryInsuranceCardsDocumentIdsRef.current
        );
        checkInsuranceInfoValidity({ ...watch() });
        trigger("insuranceInfo.secondaryInsuranceCards");
      } catch (error) {
        console.error("Error uploading files:", error);
      } finally {
        dispatch(showHideLoadingDialog(false));
      }
    }
  };

  const handleDeleteSecondaryInsuranceDocument = async (documentId: number) => {
    secondaryInsuranceCardsDocumentIdsRef.current =
      secondaryInsuranceCardsDocumentIdsRef.current.filter(
        (id) => id != documentId
      );
    setValue(
      "insuranceInfo.secondaryInsuranceCards",
      secondaryInsuranceCardsDocumentIdsRef.current
    );
    if (secondaryInsuranceCardsDocumentIdsRef.current.length === 0) {
      setValue("insuranceInfo.isSecondaryInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
    }
    checkInsuranceInfoValidity({ ...watch() });
  };

  const clickShowWoundInfoPopup = () => {
    setShowWoundInfoPopup(true);
    setShowErrorAlert(false);
  };

  const onCancelClick = async () => {
    if (IVRFetchStatus !== "success" && patientFetchStatus != "success") {
      const faceSheetDocumentIds = getValues("patientInfo.faceSheet");
      const insuranceCardsDocumentIds = getValues(
        "insuranceInfo.insuranceCards"
      );
      const secondaryInsuranceCardsDocumentIds = getValues(
        "insuranceInfo.secondaryInsuranceCards"
      );
      const supportingDocsDocumentIds = getValues(
        "supportingDocumentation.supportingDocuments"
      );
      const imagesOfWOundsDocumentIds = getValues(
        "supportingDocumentation.imageOfWounds"
      );

      // Combine all IDs into a single array
      const allDocumentIds = [
        ...faceSheetDocumentIds,
        ...insuranceCardsDocumentIds,
        ...supportingDocsDocumentIds,
        ...imagesOfWOundsDocumentIds,
      ];

      // removeIVRDocument for each ID
      const removePromises = allDocumentIds.map((id) =>
        dispatch(removeIVRDocument(id.toString()))
      );
      // Wait for all removeIVRDocument dispatches to complete
      // await Promise.all(removePromises);
    }
    // navigate("/ivr_list", { state: { withSearchHistory: true } });
    navigate(-1, { state: { withSearchHistory: true } });
  };

  const checkIVRequestValidity = (data: any) => {
    const { typeOfIVR } = data;
    const isValid = !!typeOfIVR;
    setIVRequestValid(isValid);
  };

  const checkProductInfoValidity = (data: any) => {
    const { treatmentInformation, providerInformation } = data;

    if (treatmentInformation && providerInformation) {
      const { products, dateOfService, placesOfService } = treatmentInformation;
      const { provider, practiceLocation } = providerInformation;

      const isTreatmentValid =
        (products?.some((product: { productCategory: string; }) => product.productCategory === PRODUCT_CATEGORY.CONSERVATIVE) || !!dateOfService) &&
        (Array.isArray(placesOfService)
          ? placesOfService.length > 0
          : !!placesOfService) &&
        Array.isArray(products) &&
        products.length > 0 &&
        products.every(product => Array.isArray(product.productSizes) && product.productSizes.length > 0);

      const isProviderValid =
        !!provider &&
        !!practiceLocation;

      const isValid = isTreatmentValid && isProviderValid;
      setProductInfoValid(isValid);
    } else {
      setProductInfoValid(false);
    }
  };
  //CS-1451 START
  useEffect(() => {
    const isEnableProducts = !!getValues("providerInformation.provider");
    if (isPracticeIndividual) {
      // const isEnableProducts = !!getValues("treatmentInformation.dateOfService") && !!getValues("providerInformation.provider");
      // if (isEnableProducts && dayjs(getValues("treatmentInformation.dateOfService"), "MM/DD/YYYY", true).isValid()) {
      if (isEnableProducts) {
        if (practiceID !== "") {
          // handleFetchPracticeProducts(getValues("treatmentInformation.dateOfService"), parseInt(practiceID), parseInt(getValues("providerInformation.provider")));
          handleFetchPracticeProducts(parseInt(practiceID), parseInt(getValues("providerInformation.provider")));
        }
        setDisableProductField(false);
      } else {
        setDisableProductField(true);
      }
    } else {
      // if (practiceID !== "" && getValues("treatmentInformation.dateOfService") !== undefined && dayjs(getValues("treatmentInformation.dateOfService"), "MM/DD/YYYY", true).isValid()) {
      if (isEnableProducts) {
        if (practiceID !== "") {
          handleFetchPracticeProducts(parseInt(practiceID));
          setDisableProductField(false);
        }
      } else {
        setDisableProductField(true);
      }
    }
  }, [getValues("providerInformation.provider"), isPracticeIndividual])
  //CS-1451 END

  const checkPatientInfoValidity = (data: any, initialChange?: boolean) => {
    const { patientInfo } = data;
    if (patientInfo) {
      const {
        patientId,
        patientFirstName,
        patientMiddleName,
        patientLastName,
        patientDOB,
        gender,
        patientStreetAddress,
        patientUnitNumber,
        patientCity,
        patientState,
        patientZipcode,
        faceSheet,
      } = patientInfo;
      const isValid =
        !!patientFirstName &&
        !!patientLastName &&
        !!patientDOB &&
        !!gender &&
        !!patientStreetAddress &&
        !!patientCity &&
        !!patientState &&
        !!patientZipcode &&
        (Array.isArray(faceSheet) ? faceSheet.length > 0 ? true : getValues("patientInfo.isFaceSheetSkipped") : !!faceSheet);
      setPatientInfoValid(isValid);

      // Check if patient data fields have been edited
      if (patientCompleteData != undefined) {
        const isPatientDataEdited =
          patientFirstName !== patientCompleteData?.firstName ||
          patientMiddleName !== patientCompleteData?.middleName ||
          patientLastName !== patientCompleteData?.lastName ||
          patientDOB !== patientCompleteData?.birthDate ||
          gender !== patientCompleteData?.gender;

        setIsPatientEdited(isPatientDataEdited);
      }

      const addressInfo = patientCompleteData?.patientInfo?.find(
        (info) => info.infoType === PATIENT_IVR_INFO_TYPES.ADDRESS && info.inactiveDate === null
      );

      // Check if patient info data fields have been edited
      // if (addressInfo != undefined) {
      //   const isPatientInfoEdited =
      //     patientStreetAddress !==
      //     addressInfo?.infoTypeData?.patientStreetAddress ||
      //     patientUnitNumber !==
      //     addressInfo?.infoTypeData.patientUnitNumber ||
      //     patientCity !== addressInfo?.infoTypeData.patientCity ||
      //     patientState !== addressInfo?.infoTypeData.patientState ||
      //     patientZipcode !== addressInfo?.infoTypeData.patientZip;

      //   setIsPatientInfoEdited(initialChange ? false : isPatientInfoEdited);
      // }

      const faceSheetInfo = patientCompleteData?.patientInfo?.find(
        (info) => info.infoType === PATIENT_IVR_INFO_TYPES.FACE_SHEET && info.inactiveDate === null
      );

      // Check if faceSheet has been edited
      if (faceSheetInfo != undefined) {
        const isFaceSheetEdited =
          JSON.stringify(faceSheet) !==
          JSON.stringify(faceSheetInfo?.patientinfoData?.documentIds);
        setIsFaceSheetEdited(initialChange ? false : isFaceSheetEdited);
      }
    } else {
      setPatientInfoValid(false);
    }
  };

  const checkInsuranceInfoValidity = (data: any, initialChange?: boolean) => {
    const { patientInfo } = data;
    const { insuranceInfo } = data;
    let patientID = undefined;
    if (insuranceInfo) {
      const {
        insuranceName,
        policy,
        isPolicyUnderDifferentName,
        policyholderFirstName,
        policyholderMiddleName,
        policyholderLastName,
        policyHolderDOB,
        insuranceType,
        insuranceCards,
        secondaryInsuranceName,
        secondaryPolicy,
        isSecondaryPolicyUnderDifferentName,
        secondaryPolicyHolderFirstName,
        secondaryPolicyHolderMiddleName,
        secondaryPolicyHolderLastName,
        secondaryPolicyHolderDOB,
        secondaryInsuranceType,
        secondaryInsuranceCards,
      } = insuranceInfo;
      let isValid = false;
      if (isPolicyUnderDifferentName === "yes") {
        isValid =
          !!insuranceName &&
          !!policy &&
          !!isPolicyUnderDifferentName &&
          !!policyholderFirstName &&
          !!policyholderLastName &&
          !!policyHolderDOB &&
          (Array.isArray(insuranceCards)
            ? insuranceCards.length > 0 ? true : getValues("insuranceInfo.isInsuranceCardsSkipped")
            : !!insuranceCards);
      } else {
        isValid =
          !!insuranceName &&
          !!policy &&
          !!isPolicyUnderDifferentName &&
          (Array.isArray(insuranceCards)
            ? insuranceCards.length > 0 ? true : getValues("insuranceInfo.isInsuranceCardsSkipped")
            : !!insuranceCards);
      }
      setInsuranceInfoValid(isValid);

      if (patientInfo) {
        const { patientId } = patientInfo;
        patientID = patientId;
      }

      const primaryInsuranceInfo = patientCompleteData?.patientInfo?.find(
        (info) => info.infoType === PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE && info.inactiveDate === null
      );

      const normalizeValue = (value: any, defaultValue = "") => {
        return value !== undefined && value !== null ? value : defaultValue;
      };
      const normalizeBoolean = (value: any) => {
        return value === true;
      };
      const normalizeArray = (arr: any) => {
        return Array.isArray(arr) ? arr : [];
      };

      // Check if any of the primary insurance fields have been edited
      if (primaryInsuranceInfo != undefined) {
        const isPrimaryInsuranceInfoEdited =
          normalizeValue(insuranceName) !== normalizeValue(primaryInsuranceInfo?.patientinfoData?.insuranceName) ||
          normalizeValue(policy) !== normalizeValue(primaryInsuranceInfo?.patientinfoData.policy) ||
          normalizeBoolean(isPolicyUnderDifferentName) !== normalizeBoolean(primaryInsuranceInfo?.patientinfoData.isPolicyUnderDifferentName) ||
          normalizeValue(policyholderFirstName) !== normalizeValue(primaryInsuranceInfo?.patientinfoData.policyHolderFirstName) ||
          normalizeValue(policyholderMiddleName) !== normalizeValue(primaryInsuranceInfo?.patientinfoData.policyHolderMiddleName) ||
          normalizeValue(policyholderLastName) !== normalizeValue(primaryInsuranceInfo?.patientinfoData.policyHolderLastName) ||
          normalizeValue(policyHolderDOB) !== normalizeValue(primaryInsuranceInfo?.patientinfoData.policyHolderDOB) ||
          normalizeValue(insuranceType) !== normalizeValue(primaryInsuranceInfo?.patientinfoData.insuranceType) ||
          JSON.stringify(normalizeArray(insuranceCards)) !== JSON.stringify(normalizeArray(primaryInsuranceInfo?.patientinfoData.documentIds));

        setIsPrimaryInsuranceInfoEdited(initialChange ? false : isPrimaryInsuranceInfoEdited);
      }

      const secondaryInsuranceInfo = patientCompleteData?.patientInfo?.find(
        (info) => info.infoType === PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE && info.inactiveDate === null
      );

      // Check if any of the secondary insurance fields have been edited
      if (secondaryInsuranceInfo != undefined) {
        const isSecondaryInsuranceInfoEdited =
        normalizeValue(secondaryInsuranceName) !== normalizeValue(secondaryInsuranceInfo?.patientinfoData?.insuranceName) ||
        normalizeValue(secondaryPolicy) !== normalizeValue(secondaryInsuranceInfo?.patientinfoData?.policy) ||
        normalizeBoolean(isSecondaryPolicyUnderDifferentName) !== normalizeBoolean(secondaryInsuranceInfo?.patientinfoData?.isPolicyUnderDifferentName) ||
        normalizeValue(secondaryPolicyHolderFirstName) !== normalizeValue(secondaryInsuranceInfo?.patientinfoData?.policyHolderFirstName) ||
        normalizeValue(secondaryPolicyHolderMiddleName) !== normalizeValue(secondaryInsuranceInfo?.patientinfoData?.policyHolderMiddleName) ||
        normalizeValue(secondaryPolicyHolderLastName) !== normalizeValue(secondaryInsuranceInfo?.patientinfoData?.policyHolderLastName) ||
        normalizeValue(secondaryPolicyHolderDOB) !== normalizeValue(secondaryInsuranceInfo?.patientinfoData?.policyHolderDOB) ||
        // normalizeValue(secondaryInsuranceType) !== normalizeValue(secondaryInsuranceInfo?.patientinfoData?.secondaryInsuranceType) ||
        JSON.stringify(normalizeArray(secondaryInsuranceCards)) !== JSON.stringify(normalizeArray(secondaryInsuranceInfo?.patientinfoData?.documentIds));
        
        setIsSecondaryInsuranceInfoEdited(initialChange ? false : isSecondaryInsuranceInfoEdited);
      }
    } else {
      setInsuranceInfoValid(false);
    }
  };

  const checkSupportingDocumentationValidity = (data: any, initialChange?: boolean) => {
    const { patientInfo } = data;
    const { supportingDocumentation } = data;
    let patientID = undefined;
    if (supportingDocumentation) {
      const { supportingDocuments, imageOfWounds } = supportingDocumentation;
      const isValid =
        (Array.isArray(supportingDocuments)
          ? supportingDocuments.length > 0 ? true : getValues("supportingDocumentation.isSupportingDocumentsSkipped")
          : !!supportingDocuments) &&
        (Array.isArray(imageOfWounds)
          ? imageOfWounds.length > 0 ? true : getValues("supportingDocumentation.isImageOfWoundsSkipped")
          : !!imageOfWounds);
      setSupportingDocumentationValid(isValid);

      if (patientInfo) {
        const { patientId } = patientInfo;
        patientID = patientId;
      }

      const supportingDocumentsInfo = patientCompleteData?.patientInfo?.find(
        (info) => info.infoType === PATIENT_IVR_INFO_TYPES.MEDICAL_NOTES
      );

      // Check if supporting docs has been edited
      if (supportingDocumentsInfo != undefined) {
        const IsSupportingDocumentsEdited = (JSON.stringify(supportingDocuments) !== JSON.stringify(supportingDocumentsInfo?.patientinfoData?.documentIds)) || supportingDocsDeleted;
        setIsSupportingDocumentsEdited(initialChange ? false : IsSupportingDocumentsEdited);
      }

      const imagesOfWoundsInfo = patientCompleteData?.patientInfo?.find(
        (info) => info.infoType === PATIENT_IVR_INFO_TYPES.IMAGE_OF_WOUNDS
      );

      // Check if image of wounds has been edited
      if (imagesOfWoundsInfo != undefined) {
        const IsImageOfWoundsEdited = (JSON.stringify(imageOfWounds) !== JSON.stringify(imagesOfWoundsInfo?.patientinfoData?.documentIds)) || imagesOfWoundsDeleted;
        setIsImageOfWoundsEdited(initialChange ? false : IsImageOfWoundsEdited);
      }
    } else {
      setSupportingDocumentationValid(false);
    }
  };

  //   const checkTreatmentInfoValidity = (data: any) => {
  //   const { treatmentInformation } = data;
  //   if (treatmentInformation) {
  //     const {
  //       currentlyInNursingFacility,
  //       daysAdmittedToFacility,
  //       currentlyUnderSurgicalGlobalPeriod,
  //       surgicalProcedureDate,
  //       surgicalProcedureCodes,
  //     } = treatmentInformation;
  //     let isValid = false
  //     if (currentlyInNursingFacility === "true") {
  //       if (currentlyUnderSurgicalGlobalPeriod === "true") {
  //         isValid =
  //           !!currentlyInNursingFacility &&
  //           !!daysAdmittedToFacility &&
  //           !!currentlyUnderSurgicalGlobalPeriod &&
  //           !!surgicalProcedureDate &&
  //           !!surgicalProcedureCodes;
  //       } else {
  //         isValid =
  //           !!currentlyInNursingFacility &&
  //           !!daysAdmittedToFacility &&
  //           !!currentlyUnderSurgicalGlobalPeriod;
  //       }
  //     } else {
  //       if (currentlyUnderSurgicalGlobalPeriod === "true") {
  //         isValid =
  //           !!currentlyInNursingFacility?.toString() &&
  //           !!currentlyUnderSurgicalGlobalPeriod &&
  //           !!surgicalProcedureDate &&
  //           !!surgicalProcedureCodes;
  //       } else {
  //         isValid =
  //           !!currentlyInNursingFacility?.toString() &&
  //           !!currentlyUnderSurgicalGlobalPeriod;
  //       }
  //     }
  //     setTreatmentInfoValid(isValid);
  //   } else {
  //     setTreatmentInfoValid(false);
  //   }
  // };

  //CS-1519
  const checkSafeguardQuestionsValidity = (data: any) => {
    const { treatmentInformation } = data;

    // CS-1728 - Replacing static label to dynamic constant
    if (selectedProductCategory === PRODUCT_CATEGORY.CONSERVATIVE &&
      selectedProducts &&
      selectedProducts.length > 0 &&
      selectedProducts[0].productSizes &&
      selectedProducts[0].productSizes.length > 0) {

      if (treatmentInformation && treatmentInformation?.homeHealth) {
        setSafeguardQuestionsValid(true);
      } else {
        setSafeguardQuestionsValid(false);
      }
      return;
    }

    //CS-1519 START
    if (productQuestions?.length > 0) {
      const productQuestionsData = getValues('productQuestions');
      const isProductQuestionsValid = validateQuestions(productQuestions, productQuestionsData, 'productQuestions');

      // If we also have safeguard questions, check both
      if (safeguardQuestions?.length > 0) {
        const safeguardQuestionsData = getValues('safeguardQuestions');
        const isSafeguardQuestionsValid = validateQuestions(safeguardQuestions, safeguardQuestionsData, 'safeguardQuestions');
        setSafeguardQuestionsValid(isProductQuestionsValid && isSafeguardQuestionsValid);
      } else {
        setSafeguardQuestionsValid(isProductQuestionsValid);
      }
      return;
    }

    // Check only safeguard questions validity
    if (safeguardQuestions?.length > 0) {
      const safeguardQuestionsData = getValues('safeguardQuestions');
      const isSafeguardQuestionsValid = validateQuestions(safeguardQuestions, safeguardQuestionsData, 'safeguardQuestions');
      setSafeguardQuestionsValid(isSafeguardQuestionsValid);
      return;
    }

    // No questions to validate
    setSafeguardQuestionsValid(true);
  };

  const validateQuestions = (questions: any[], questionsData: any, prefix: string) => {
    if (!questions || questions.length === 0) return true;
    if (!questionsData) return false;

    for (const question of questions) {
      const questionInfo = question.questionInfo?.question;
      if (!questionInfo || !questionInfo.answer_required) continue;

      const questionCode = question.questionCode;
      const questionType = questionInfo.questionType;

      // Handle WOUND_INFO type questions
      if (questionType === "WOUND_INFO") {
        const woundsData = questionsData.WOUNDS;
        if (!woundsData) return false;

        for (const woundKey of selectedWoundList) {
          const woundData = woundsData[woundKey];
          if (!woundData || !woundData[questionCode]) {
            return false;
          }

          // Check nested questions if they exist
          if (questionInfo.answers?.answer) {
            for (const answer of questionInfo.answers.answer) {
              if (answer.question && woundData[questionCode] === answer.key) {
                const nestedValid = validateNestedQuestions(answer.question, woundData, questionCode);
                if (!nestedValid) return false;
              }
            }
          }
        }
      } else {
        // Handle regular questions
        const questionValue = questionsData[questionCode];
        if (!questionValue) return false;

        // Check nested questions if they exist
        if (questionInfo.answers?.answer) {
          for (const answer of questionInfo.answers.answer) {
            if (answer.question && (questionValue === answer.key || (Array.isArray(questionValue) && questionValue.includes(answer.key)))) {
              const nestedValid = validateNestedQuestions(answer.question, questionsData, questionCode);
              if (!nestedValid) return false;
            }
          }
        }
      }
    }

    return true;
  };

  const validateNestedQuestions = (nestedQuestion: any, data: any, parentKey: string) => {
    if (Array.isArray(nestedQuestion)) {
      return nestedQuestion.every(nq => validateSingleNestedQuestion(nq, data, parentKey));
    }
    return validateSingleNestedQuestion(nestedQuestion, data, parentKey);
  };

  const validateSingleNestedQuestion = (question: any, data: any, parentKey: string) => {
    if (!question.answer_required) return true;

    const nestedValue = data[`${parentKey}_${question.questionCode}`] || data[question.questionCode];
    return !!nestedValue;
  };
  //CS-1519 END

  const checkWoundInfoValidity = (data: any, initialChange?: boolean) => {
    const { woundInfo } = data;
    if (woundInfo) {
      let totalSizeOfAllWounds = woundInfo.totalSizeOfAllWounds;

      // If totalSizeOfAllWounds is empty, calculate total volume from selected wound rows
      if (!totalSizeOfAllWounds && selectedWoundList.length > 0) {
        totalSizeOfAllWounds = woundInfoRows
          .filter((wound) => selectedWoundList.includes(wound.woundInfoKey || ""))
          .reduce((total: number, wound) => {
            const volume = getWoundVolume(wound);
            return total + (isNaN(volume) ? 0 : volume);
          }, 0)
          .toString();
      }
        
      const isValid =
        !!totalSizeOfAllWounds &&
        Array.isArray(woundInfoRows) &&
        woundInfoRows.length > 0;
      setWoundInfoValid(isValid);
    } else {
      setWoundInfoValid(false);
    }

    const woundInformation = patientCompleteData?.patientInfo?.find(
      (info) => info.infoType === PATIENT_IVR_INFO_TYPES.WOUND_INFO
    );

    if (woundInformation) {
      //@ts-ignore
      const IsImageOfWoundsEdited = woundInfoRows.length !== woundInformation?.patientinfoData?.woundInfo?.woundData.length
      setIsWoundInfoEdited(initialChange ? false : IsImageOfWoundsEdited)
    }
  };

  // const onSubmit = async (data: IVRInfo) => {
  //   const updatedObject = mapIVRInfoToIVRObjectInfo(data);

  //   if (submitAction === "saveAction") {
  //     const response = await dispatch(saveIVRData({ dataObj: updatedObject, interceptorOption: { skipErrorPopup: true } }));
  //     if (response.payload && response.payload.message === "SUCCESS") {
  //       // cs-347 (13/9/2024) -Display Order Number or IVR Number in Success Messages
  //       const ivrNumber = response.payload?.data?.ivrNumber;
  //       let successObj: SingleAlertInfo = {
  //         message: "IVR " + ivrNumber + " Saved Successfully",
  //         alertType: "success",
  //       };
  //       //
  //       dispatch(setSingleAlertObj(successObj));
  //       navigate("/ivr_list", {state: {withSearchHistory: true}});
  //     } else if (response.payload !== undefined && response.payload.message) {
  //       let errorObj: SingleAlertInfo = {
  //         message: response.payload.message,
  //         alertType: "error",
  //       };
  //      return dispatch(setSingleAlertObj(errorObj));
  //     } else {
  //       let errorObj: SingleAlertInfo = {
  //         message: response.payload.message||"An error occurred while saving the IVR.",
  //         alertType: "error",
  //       };
  //       dispatch(setSingleAlertObj(errorObj));
  //     }
  //   } else if (submitAction === "submitAction") {
  //     const response = await dispatch(submitIVR(updatedObject));
  //     if (response.payload && response.payload.message === "SUCCESS") {
  //       // cs-347 (13/9/2024) - Display Order Number or IVR Number in Success Messages
  //       // (Here if we are creating multiple IVR also onFinalSubmit, we get only one IVRNumber in response!)
  //       const ivrNumber = response.payload?.data?.ivrNumber;
  //       let successObj: SingleAlertInfo = {
  //         message: "IVR " + ivrNumber + " Saved Successfully",
  //         alertType: "success",
  //       };
  //       //
  //       dispatch(setSingleAlertObj(successObj));
  //       navigate("/ivr_list", {state: {withSearchHistory: true}});
  //     } else if (response.payload !== undefined && response.payload.message) {
  //       let errorObj: SingleAlertInfo = {
  //         message: response.payload.message,
  //         alertType: "error",
  //       };
  //      return dispatch(setSingleAlertObj(errorObj));
  //     } else {
  //       let errorObj: SingleAlertInfo = {
  //         message: "IVR Submission Failed.",
  //         alertType: "error",
  //       };
  //       dispatch(setSingleAlertObj(errorObj));
  //     }
  //   }

  //   setSubmitAction(null);
  //   setIvrId(0);
  //   setIvrNumber("");
  // };

  const handleErrorResponse = (response: any, defaultMessage: string) => {
    if (response?.payload?.errors) {
      const combinedErrorMessage = response.payload.errors
        .map((err: any) => err.errorMessage || defaultMessage)
      // .join();

      let errorObj: SingleAlertInfo = {
        message: combinedErrorMessage,
        alertType: "error",
      };
      return dispatch(setSingleAlertObj(errorObj));
    }
  };

  const onSubmit = async (data: IVRInfo) => {
    if (submitAction === "saveAction") {
      const updatedObject = mapIVRInfoToIVRObjectInfo(data);
      const response = await dispatch(saveIVRData(updatedObject));
      // const response = await dispatch(saveIVRData({ dataObj: updatedObject, interceptorOption: { skipErrorPopup: true } }));

      if (response.payload && response.payload.message === "SUCCESS") {
        // cs-347 (13/9/2024) -Display Order Number or IVR Number in Success Messages
        const ivrNumber = response.payload?.data?.ivrNumber;
        let successObj: SingleAlertInfo = {
          message: "IVR " + ivrNumber + " Saved Successfully",
          alertType: "success",
        };
        dispatch(setSingleAlertObj(successObj));
        navigate("/ivr_list", { state: { withSearchHistory: true } });
      } else {
        return handleErrorResponse(response, "An error occurred while saving the IVR.");
      }
      setSubmitAction(null);
      setIvrId(0);
      setIvrNumber("");
    } else if (submitAction === "submitAction") {
      setShowSignatureSubmitPopup(true);
    }
  };

  const handleSignatureData = async (data: any) => {
    setValue("providerInformation.signature", data.providerInformation.signature);
    setValue("providerInformation.name", data.providerInformation.typedText);

    // Wait for React Hook Form to update state
    await trigger();

    // Get the updated form values
    const updatedData = getValues();

    const updatedObject = mapIVRInfoToIVRObjectInfo(updatedData);
    updatedObject.ivrId = ivrIdRef.current; //CS-1343
    updatedObject.ivrNumber = ivrNumberRef.current; //CS-1343
    submitIVRAfterSign(updatedObject);
  }

  const submitIVRAfterSign = async (updatedObject: any) => {
    const response = await dispatch(submitIVR(updatedObject));
    if (response.payload && response.payload.message === "SUCCESS") {
      // cs-347 (13/9/2024) - Display Order Number or IVR Number in Success Messages
      // (Here if we are creating multiple IVR also onFinalSubmit, we get only one IVRNumber in response!)
      const ivrNumber = response.payload?.data?.ivrNumber;
      let successObj: SingleAlertInfo = {
        message: "IVR " + ivrNumber + " Saved Successfully",
        alertType: "success",
      };
      dispatch(setSingleAlertObj(successObj));
      navigate("/ivr_list", { state: { withSearchHistory: true } });
    } else {
      return handleErrorResponse(response, "IVR Submission Failed.");
    }
  }

  const hasNestedErrors = (obj: any) => {
    for (const key in obj) {
      if (obj[key] && typeof obj[key] === 'object') {
        if (hasNestedErrors(obj[key])) {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  };

  const onError = (_errors: any, e: any) => {
    if (submitAction === "saveAction") {
      clearErrors();
      let hasError = false;

      if (!getValues("treatmentInformation.products") || getValues("treatmentInformation.products")?.length === 0) {
        setError("treatmentInformation.products", { type: "required", message: "At least one product should be selected." });
        hasError = true;
      } else {
        for (let product of getValues("treatmentInformation.products")) {
          if (product.productSizes.length === 0) {
            setError("treatmentInformation.products", { type: "required", message: "At least one product item should be selected." });
            hasError = true;
          }
        }
      }
    // if(selectedProductCategory === "Advanced CTP" && selectedProducts && selectedProducts.length > 0){
    //   if (!getValues("treatmentInformation.dateOfService")) {
    //     setError("treatmentInformation.dateOfService", { type: "required", message: "Date of Service is required." });
    //     hasError = true;
    //   } else if (!dayjs(getValues("treatmentInformation.dateOfService"), "MM/DD/YYYY", true).isValid()) {
    //     setError("treatmentInformation.dateOfService", { type: "required", message: "Invalid Date." });
    //     hasError = true;
    //   }
    // }

      if (!getValues("patientInfo.patientFirstName")) {
        setError("patientInfo.patientFirstName", { type: "required", message: "Patient First Name is required." });
        hasError = true;
      }

      if (!getValues("patientInfo.patientLastName")) {
        setError("patientInfo.patientLastName", { type: "required", message: "Patient Last Name is required." });
        hasError = true;
      }

      if (isPracticeIndividual) {
        if (!getValues("providerInformation.provider")) {
          setError("providerInformation.provider", { type: "required", message: "Provider is required." });
          hasError = true;
        }
      }

      if (!hasError) {
        onSubmit(getValues());
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      return;
    } else if (submitAction === "submitAction") {
      let hasError = true;
      setErrorOccured(hasError)
      let faceSheetUploaded = false;
      let supportingDocsUploaded = false;
      let imageOfWoundsUploaded = false;
      let insuranceCardsUploaded = false;
      let secondatyInsuranceCardsUploaded = false;

      if (getValues("patientInfo.faceSheet").length !== 0) {
        faceSheetUploaded = true;
        clearErrors("patientInfo.faceSheet");
      }

      if (getValues("supportingDocumentation.imageOfWounds").length !== 0) {
        imageOfWoundsUploaded = true;
        clearErrors("supportingDocumentation.imageOfWounds");
      }

      if (getValues("supportingDocumentation.supportingDocuments").length !== 0) {
        supportingDocsUploaded = true;
        clearErrors("supportingDocumentation.supportingDocuments");
      }

      if (getValues("insuranceInfo.insuranceCards").length !== 0) {
        insuranceCardsUploaded = true;
        clearErrors("insuranceInfo.insuranceCards");
      }

      if (getValues("insuranceInfo.secondaryInsuranceCards") && getValues("insuranceInfo.secondaryInsuranceCards").length !== 0) {
        secondatyInsuranceCardsUploaded = true;
        clearErrors("insuranceInfo.secondaryInsuranceCards");
      }

      if (getValues("patientInfo.isFaceSheetSkipped")) {
        clearErrors("patientInfo.faceSheet");
      }

      if (getValues("supportingDocumentation.isSupportingDocumentsSkipped")) {
        clearErrors("supportingDocumentation.supportingDocuments");
      }

      if (getValues("supportingDocumentation.isImageOfWoundsSkipped")) {
        clearErrors("supportingDocumentation.imageOfWounds");
      }

      if (getValues("insuranceInfo.isInsuranceCardsSkipped")) {
        clearErrors("insuranceInfo.insuranceCards");
      }

      if (getValues("insuranceInfo.isSecondaryInsuranceCardsSkipped")) {
        clearErrors("insuranceInfo.secondaryInsuranceCards");
      }

      if (hasNestedErrors(_errors)) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        return;
      }

      if ((faceSheetUploaded || getValues("patientInfo.isFaceSheetSkipped")) && (supportingDocsUploaded || getValues("supportingDocumentation.isSupportingDocumentsSkipped")) && (imageOfWoundsUploaded || getValues("supportingDocumentation.isImageOfWoundsSkipped")) && (insuranceCardsUploaded || getValues("insuranceInfo.isInsuranceCardsSkipped"))) {
        hasError = false;
      } else {
        hasError = true;
      }

      // CS-1605 START
      if (!selectedWoundList || selectedWoundList.length === 0) {
        setError("woundInfo.woundData", { type: "required", message: "Please select at least one wound before submitting." });
        hasError = true;
      } else {
        clearErrors("woundInfo.woundData");
      }
      // CS-1605 END

      if (!hasError) {
        onSubmit(getValues());
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      return;
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const insuranceVerificationRequestRef = useRef<HTMLDivElement>(null);
  const productInformationRef = useRef<HTMLDivElement>(null);
  const patientInformationRef = useRef<HTMLDivElement>(null);
  const insuranceInformationRef = useRef<HTMLDivElement>(null);
  const supportingDocumentationRef = useRef<HTMLDivElement>(null);
  const safeguardQuestionsRef = useRef<HTMLDivElement>(null);
  // const patientConsentInformationRef = useRef<HTMLDivElement>(null);
  const treatmentInformationRef = useRef<HTMLDivElement>(null);
  const woundDataRef = useRef<HTMLDivElement>(null);

  const [activeStep, setActiveStep] = useState<number>(0);
  const [firstLoad, setFirstLoad] = useState(true);
  //CS-1519
  const steps = useMemo(() => {
    const baseSteps = [
      { stepName: "Insurance Verification Request", isCompleted: ivRequestValid },
      { stepName: "Product Information", isCompleted: productInfoValid },
      { stepName: "Patient/Insurance Information", isCompleted: patientInfoValid },
      { stepName: "Supporting Documentation", isCompleted: supportingDocumentationValid },
      { stepName: "Data", isCompleted: woundInfoValid },
    ];

    // Add Safeguard Questions step conditionally for Collagen products
    // CS-1728 - Replacing static label to dynamic constant
    if ((selectedProductCategory === PRODUCT_CATEGORY.CONSERVATIVE &&
      selectedProducts &&
      selectedProducts.length > 0 &&
      selectedProducts[0].productSizes &&
      selectedProducts[0].productSizes.length > 0) || (productQuestions?.length > 0) || (safeguardQuestions?.length > 0)) {
      baseSteps.push({ stepName: "Safeguard Questions", isCompleted: safeguardQuestionsValid });
    }
    return baseSteps;
  }, [ivRequestValid, productInfoValid, patientInfoValid, supportingDocumentationValid, safeguardQuestionsValid, woundInfoValid, selectedProductCategory, selectedProducts]);

  useEffect(() => {
    if (!firstLoad) {
      const scrollToElement = (elementRef: any) => {
        if (elementRef && elementRef.current) {
          elementRef.current.scrollIntoView({ behavior: "smooth" });
        }
      };

      // Dynamic step mapping based on current steps array
      const stepNames = steps.map(step => step.stepName);
      const currentStepName = stepNames[activeStep];

      switch (currentStepName) {
        case "Insurance Verification Request":
          scrollToElement(insuranceVerificationRequestRef);
          break;
        case "Product Information":
          scrollToElement(productInformationRef);
          break;
        case "Patient/Insurance Information":
          scrollToElement(patientInformationRef);
          break;
        case "Supporting Documentation":
          scrollToElement(supportingDocumentationRef);
          break;
        case "Data":
          scrollToElement(woundDataRef);
          break;
        case "Safeguard Questions":
          scrollToElement(safeguardQuestionsRef);
          break;
        default:
          break;
      }
    } else if (firstLoad) {
      setFirstLoad(false);
    }
  }, [activeStep]);

  // Helper function to convert document content to ExtendedFile
  const convertDocumentContentToExtendedFile = (
    documentData: any,
    doc: string
  ): ExtendedFile => {
    const byteCharacters = atob(documentData.content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: documentData.fileType });

    const extendedFile: ExtendedFile = new File(
      [blob],
      documentData.documentName,
      {
        type: documentData.fileType,
      }
    );
    extendedFile.documentId = doc;
    return extendedFile;
  };

  // Helper function to fetch and process documents
  const fetchAndProcessDocuments = async (
    documentIds: string[],
    dispatch: any
  ): Promise<ExtendedFile[]> => {
    const documentList: ExtendedFile[] = [];
    for (const doc of documentIds) {
      if (doc !== null) {
        try {
          const actionResult = await dispatch(fetchDocumentById(doc));
          const documentData = actionResult.payload;
          if (documentData && documentData.content) {
            const extendedFile = convertDocumentContentToExtendedFile(
              documentData,
              doc
            );
            documentList.push(extendedFile);
          }
        } catch (error) {
          console.error(`Failed to fetch document with ID ${doc}`, error);
        }
      }
    }
    return documentList;
  };

  // Main function to handle different types of documents
  /* istanbul ignore next */
  const handleDocuments = async (
    type: string,
    dataKey: any,
    stateSetter: (files: ExtendedFile[]) => void,
    dispatch: any,
    data: any
  ) => {
    const docInfo = data.patientInfo.find(
      (info: { infoType: string }) => info.infoType === type
    );
    if (docInfo) {
      setValue(dataKey, docInfo?.patientinfoData.documentIds);
      if (docInfo?.patientinfoData.documentIds.length > 0) {
        const documentList = await fetchAndProcessDocuments(
          docInfo?.patientinfoData.documentIds,
          dispatch
        );
        stateSetter(documentList);
      }
    }
  };


  const handlePatientChange = async (initialChange: boolean) => {
    dispatch(showHideLoadingDialog(true));
    setPatientSelected(true);
    const patientId = getValues(`patientInfo.${"patientId"}`);
    if (patientId) {
      const response = await dispatch(
        getPatient({ patientId: patientId.toString() })
      );
      if (response.payload.message === "SUCCESS") {
        const data = response.payload.data;
        setPatientCompleteData(data);
        setValue("patientInfo.patientFirstName", data.firstName);
        setValue(
          "patientInfo.patientMiddleName",
          data.middleName ? data.middleName : ""
        );
        setValue("patientInfo.patientLastName", data.lastName);
        setValue("patientInfo.patientDOB", data.birthDate);
        setValue("patientInfo.gender", data.gender);

        if(!viewOnly){

        // Find the address object
        const addressInfo = data.patientInfo.find(
          (info: { infoType: string ,inactiveDate: string  }) => info.infoType === PATIENT_IVR_INFO_TYPES.ADDRESS && info.inactiveDate === null   // CS-1189
        );

        // If address information exists, set the address values
        if (addressInfo) {
          const addressData = addressInfo?.patientinfoData;
          setValue(
            "patientInfo.patientStreetAddress",
            addressData.patientStreetAddress
          );
          setValue(
            "patientInfo.patientUnitNumber",
            addressData.patientUnitNumber
          );
          setValue("patientInfo.patientCity", addressData.patientCity);
          setValue("patientInfo.patientState", addressData.patientState);
          setValue("patientInfo.patientZipcode", addressData.patientZip);
          setPatientInfoIdAddress(addressInfo.patientinfoId);
        }

        // Find the Insurance object
        const primaryInsuranceInfo = data.patientInfo.find(
          (info: { infoType: string, inactiveDate: string }) => info.infoType === PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE && info.inactiveDate === null
        );

        if (primaryInsuranceInfo) {
          const InsuranceData = primaryInsuranceInfo?.patientinfoData;
          setValue("insuranceInfo.insuranceName",InsuranceData?.insuranceCategory === "Commercial" && InsuranceData?.primaryCommercialInsuranceName ? "Other" : InsuranceData?.insuranceName);
          setValue("insuranceInfo.insuranceCategory", InsuranceData.insuranceCategory);
          setValue("insuranceInfo.primaryCommercialInsuranceName", InsuranceData.primaryCommercialInsuranceName);
          setValue("insuranceInfo.insurancePayerCode", InsuranceData?.insuranceCategory === "Commercial" && InsuranceData?.primaryCommercialInsuranceName ?"0": InsuranceData?.insurancePayerCode);
          setValue("insuranceInfo.policy", InsuranceData.policy);
          setValue(
            "insuranceInfo.isPolicyUnderDifferentName",
            InsuranceData.isPolicyUnderDifferentName
          );
          if (InsuranceData.isPolicyUnderDifferentName === "yes") {
            setIsPolicyUnderDifferentNameCheck(true);
            setValue(
              "insuranceInfo.policyholderFirstName",
              InsuranceData.policyHolderFirstName
            );
            setValue(
              "insuranceInfo.policyholderMiddleName",
              InsuranceData.policyHolderMiddleName
            );
            setValue(
              "insuranceInfo.policyholderLastName",
              InsuranceData.policyHolderLastName
            );
            setValue(
              "insuranceInfo.policyHolderDOB",
              InsuranceData.policyHolderDOB
            );
          }
          setValue("insuranceInfo.insuranceType", InsuranceData.insuranceType);

          if (InsuranceData?.documentIds) {
            setValue("insuranceInfo.insuranceCards", InsuranceData?.documentIds)
          }
          setValue('insuranceInfo.insuranceNameNotListed',InsuranceData?.insuranceNameNotListed)
          setInsuranceNameNotListed(InsuranceData?.insuranceNameNotListed === true ? true : false)
          setPatientInfoIdPrimaryInsurance(primaryInsuranceInfo.patientinfoId);
          if (primaryInsuranceInfo?.patientinfoData.isSkipped === true) {
            setValue("insuranceInfo.isInsuranceCardsSkipped", true)
          } else {
            insuranceCardsDocumentIdsRef.current =
              primaryInsuranceInfo?.patientinfoData.documentIds?.map(
                (doc: any) => doc
              ) || []
          }
        }

        // Find the Insurance object
        const secondaryInsuranceInfo = data.patientInfo.find(
          (info: { infoType: string, inactiveDate: string }) =>
            info.infoType === PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE && info.inactiveDate === null
        );
        setPatientInfoIdSecondaryInsurance(secondaryInsuranceInfo?.patientinfoId);
        if (
          secondaryInsuranceInfo &&
          secondaryInsuranceInfo?.patientinfoData.insuranceName !== undefined && secondaryInsuranceInfo?.patientinfoData.insuranceName !== ""
        ) {
          const SecondaryInsuranceData = secondaryInsuranceInfo?.patientinfoData;
          setValue("insuranceInfo.secondaryInsuranceCategory", SecondaryInsuranceData.insuranceCategory);
          setValue("insuranceInfo.secondaryCommercialInsuranceName", SecondaryInsuranceData.secondaryCommercialInsuranceName);
          
          setValue(
            "insuranceInfo.secondaryInsuranceName",
            SecondaryInsuranceData?.insuranceCategory === "Commercial" && SecondaryInsuranceData?.secondaryCommercialInsuranceName ? "Other" : SecondaryInsuranceData?.insuranceName
          );
          setValue(
            "insuranceInfo.secondaryInsurancePayerCode",
            SecondaryInsuranceData?.insuranceCategory === "Commercial" && SecondaryInsuranceData?.secondaryCommercialInsuranceName ?"0": SecondaryInsuranceData?.insurancePayerCode
          );
          setValue(
            "insuranceInfo.secondaryPolicy",
            SecondaryInsuranceData.policy
          );
          setValue(
            "insuranceInfo.isSecondaryPolicyUnderDifferentName",
            SecondaryInsuranceData.isPolicyUnderDifferentName
          );
          setValue('insuranceInfo.secondaryInsuranceNameNotListed',SecondaryInsuranceData?.secondaryInsuranceNameNotListed)
        setSecondaryInsuranceNameNotListed(SecondaryInsuranceData?.secondaryInsuranceNameNotListed === true ? true : false)
          if (SecondaryInsuranceData.isPolicyUnderDifferentName === "yes") {
            setIsPolicyUnderDifferentNameCheckSecondary(true);
            setValue(
              "insuranceInfo.secondarypolicyholderFirstName",
              SecondaryInsuranceData.policyHolderFirstName
            );
            setValue(
              "insuranceInfo.secondarypolicyholderMiddleName",
              SecondaryInsuranceData.policyHolderMiddleName
            );
            setValue(
              "insuranceInfo.secondarypolicyholderLastName",
              SecondaryInsuranceData.policyHolderLastName
            );
            setValue(
              "insuranceInfo.secondaryPolicyHolderDOB",
              SecondaryInsuranceData.policyHolderDOB
            );
          }
          setValue(
            "insuranceInfo.secondaryInsuranceType",
            SecondaryInsuranceData.insuranceType
          );
          setValue(
            "insuranceInfo.secondaryInsuranceCards",
            SecondaryInsuranceData.insuranceCards
          );
          setValue("insuranceInfo.isSecondaryInsurance", true);
          setIsSecondaryInsurance(true);
          if (SecondaryInsuranceData?.documentIds) {
            setValue("insuranceInfo.secondaryInsuranceCards", SecondaryInsuranceData?.documentIds)
          }
          if (secondaryInsuranceInfo?.patientinfoData.isSkipped === true) {
            setValue("insuranceInfo.isSecondaryInsuranceCardsSkipped", true)
          } else {
            secondaryInsuranceCardsDocumentIdsRef.current =
              secondaryInsuranceInfo?.patientinfoData.documentIds?.map(
                (doc: any) => doc
              ) || []
          }
        }

        const faceSheetInfo = data.patientInfo.find(
          (info: { infoType: string, inactiveDate: string }) => info.infoType === PATIENT_IVR_INFO_TYPES.FACE_SHEET && info.inactiveDate=== null
        );
        if (faceSheetInfo) {
          if (faceSheetInfo?.patientinfoData?.documentIds) {
            setValue("patientInfo.faceSheet", faceSheetInfo?.patientinfoData?.documentIds)
          }
          setPatientInfoIdFaceSheet(faceSheetInfo.patientinfoId);
          if (faceSheetInfo?.patientinfoData.isSkipped === true) {
            setValue("patientInfo.isFaceSheetSkipped", true)
          } else {
            faceSheetDocumentIdsRef.current =
              faceSheetInfo?.patientinfoData.documentIds?.map(
                (doc: any) => doc
              ) || []
          }
        }

        const supportingDocsInfo = data.patientInfo.find(
          (info: { infoType: string, inactiveDate: string }) => info.infoType === PATIENT_IVR_INFO_TYPES.MEDICAL_NOTES && info.inactiveDate === null
        );

        if (supportingDocsInfo) {
          if (supportingDocsInfo?.patientinfoData?.documentIds) {
            setValue("supportingDocumentation.supportingDocuments", supportingDocsInfo?.patientinfoData?.documentIds)
          }
          setPatientInfoIdSupportingDocs(supportingDocsInfo.patientinfoId);
          if (supportingDocsInfo?.patientinfoData.isSkipped === true) {
            setValue("supportingDocumentation.isSupportingDocumentsSkipped", true)
          } else {
            supportingDocsDocumentIdsRef.current =
              supportingDocsInfo?.patientinfoData.documentIds?.map(
                (doc: any) => doc
              ) || []
          }
        }

        const woundImagesInfo = data.patientInfo.find(
          (info: { infoType: string, inactiveDate: string }) => info.infoType === PATIENT_IVR_INFO_TYPES.IMAGE_OF_WOUNDS && info.inactiveDate === null
        );

        if (woundImagesInfo) {
          if (woundImagesInfo?.patientinfoData?.documentIds) {
            setValue("supportingDocumentation.imageOfWounds", woundImagesInfo?.patientinfoData?.documentIds)
          }
          setPatientInfoIdWoundImages(woundImagesInfo.patientinfoId);
          if (woundImagesInfo?.patientinfoData.isSkipped === true) {
            setValue("supportingDocumentation.isImageOfWoundsSkipped", true)
          } else {
            imageOfWoundsDocumentIdsRef.current =
              woundImagesInfo?.patientinfoData.documentIds?.map(
                (doc: any) => doc
              ) || []
          }
        }
      }

        const isOnViewOnly = location?.state?.viewOnly;
        const ivrId = location?.state?.ivrId;
        const savedWoundInfoKeys: string[] = [];

        const woundInfo = data.patientInfo.find(
          (info: { infoType: string, inactiveDate: string }) => info.infoType === PATIENT_IVR_INFO_TYPES.WOUND_INFO && info.inactiveDate === null
        );

        if (woundInfo) {
          const woundDataList = woundInfo?.patientinfoData?.woundInfo?.woundData;
          if (!isOnViewOnly) {
            let processedWoundData = setProcessedWoundData(woundDataList);
            setIsAddIncisionButtonDisabled(woundInfo?.patientinfoData?.woundInfo?.isLoadedFromProviderTemplate)
            setWoundInfoRows(processedWoundData || []);
            if (!ivrId) {
              woundDataList?.forEach((wound: { woundInfoKey: any; }) => {
                savedWoundInfoKeys.push(wound.woundInfoKey)
              });
              setSelectedWoundList(savedWoundInfoKeys);
            }
          }
        }
        setPatientWoundInfo(woundInfo?.patientinfoId);
        if (woundInfo?.patientinfoData?.woundInfo?.maxWoundId) {
          setMaxWoundIdFromMount(woundInfo?.patientinfoData?.woundInfo?.maxWoundId);
          setMaxWoundRowIndex(woundInfo?.patientinfoData?.woundInfo?.maxWoundId);
        }

        checkPatientInfoValidity(getValues(), initialChange);
        checkInsuranceInfoValidity(getValues(), initialChange);
        checkSupportingDocumentationValidity(getValues(), initialChange);
        checkWoundInfoValidity(getValues(), initialChange);

        const emailInfo = data.patientInfo.find(
          (info: { infoType: string, inactiveDate: string }) => info.infoType === PATIENT_IVR_INFO_TYPES.EMAIL && info.inactiveDate === null
        );

        if (emailInfo) {
          setPatientEmail(emailInfo.patientinfoId);
          setPatientEmailAddress(emailInfo?.patientinfoData?.patientEmail)
        }
      }
    } else {
      clearPatientData();
    }
    dispatch(showHideLoadingDialog(false));
  };

  useEffect(() => {
    if (insuranceNameNotListed) {
      setValue('insuranceInfo.insuranceCategory', "Commercial")
      setValue('insuranceInfo.insurancePayerCode', "0")
      setValue('insuranceInfo.insuranceName', "Other")
    }
  }, [insuranceNameNotListed])
  useEffect(() => {
    if (secondaryInsuranceNameNotListed) {
      setValue('insuranceInfo.secondaryInsuranceCategory', "Commercial")
      setValue('insuranceInfo.secondaryInsurancePayerCode', "0")
      setValue('insuranceInfo.secondaryInsuranceName', "Other")
    }
  }, [secondaryInsuranceNameNotListed])


  const clearPatientData = () => {
    setIsPatientInfoDisabled(false);
    setValue("patientInfo.patientFirstName", "");
    setValue("patientInfo.patientMiddleName", "");
    setValue("patientInfo.patientLastName", "");
    setValue("patientInfo.patientDOB", "");
    setValue("patientInfo.gender", "");
    setValue("patientInfo.patientStreetAddress", "");
    setValue("patientInfo.patientUnitNumber", "");
    setValue("patientInfo.patientCity", "");
    setValue("patientInfo.patientState", "");
    setValue("patientInfo.patientZipcode", "");
    setValue("patientInfo.faceSheet", []);
    setUploadedFacesheetFilesMetaData([]);

    setValue("insuranceInfo.insuranceName", "");
    setValue("insuranceInfo.policy", "");
    setValue("insuranceInfo.isPolicyUnderDifferentName", false);
    setValue("insuranceInfo.policyholderFirstName", "");
    setValue("insuranceInfo.policyholderMiddleName", "");
    setValue("insuranceInfo.policyholderLastName", "");
    setValue("insuranceInfo.policyHolderDOB", "");
    setValue("insuranceInfo.insuranceType", "");
    setValue("insuranceInfo.insuranceCards", []);
    setUploadedPrimaryInsuranceFilesMetaData([]);
    setValue("insuranceInfo.isSecondaryInsurance", false);
    setValue("insuranceInfo.secondaryInsuranceName", "");
    setValue("insuranceInfo.secondaryPolicy", "");
    setValue("insuranceInfo.isSecondaryPolicyUnderDifferentName", false);
    setValue("insuranceInfo.secondarypolicyholderFirstName", "");
    setValue("insuranceInfo.secondarypolicyholderMiddleName", "");
    setValue("insuranceInfo.secondarypolicyholderLastName", "");
    setValue("insuranceInfo.secondaryPolicyHolderDOB", "");
    setValue("insuranceInfo.secondaryInsuranceType", "");
    setValue("insuranceInfo.secondaryInsuranceCards", []);
    setUploadedSecondaryInsuranceFilesMetaData([]);

    setValue("supportingDocumentation.supportingDocuments", []);
    setUploadedSupportingDocumentFilesMetaData([]);
    setValue("supportingDocumentation.imageOfWounds", []);
    setUploadedWoundImageFilesMetaData([]);
    setValue("supportingDocumentation.isImageOfWoundsSkipped", false);
    setValue("supportingDocumentation.isSupportingDocumentsSkipped", false);
    setValue("insuranceInfo.isInsuranceCardsSkipped", false);
    setValue("patientInfo.isFaceSheetSkipped", false);

    checkPatientInfoValidity(getValues());
    checkInsuranceInfoValidity(getValues());
    checkSupportingDocumentationValidity(getValues());
  }

  // const fetchProductItems = (event : any) => {
  //   const practiceProductId = getValues(`treatmentInformation.${"practiceProductId"}`);
  //   if (practiceProductId) {
  //     setValue('providerInformation.macId', event.macId);
  //     setValue('treatmentInformation.product', event.productId);
  //     const onlyActiveRecords = true;
  //     dispatch(fetchProductItemsByProductId({ productId: event.productId, onlyActiveRecords }));
  //   } else {
  //     dispatch(resetProductItems());
  //   }
  // };

  const mapIVRInfoToIVRObjectInfo = (ivrInfo: IVRInfo): IVRObjectInfo => {
    const patientInfo = ivrInfo.patientInfo;
    const insuranceInformation = ivrInfo.insuranceInfo;
    const supportingDocs = ivrInfo.supportingDocumentation;

    // const woundData = woundInfoRows.map((row) => ({
    //   woundType: row.woundType,
    //   procedureLocation: row.procedureLocation,
    //   cpt: row.cpt,
    //   cptIds: row.cptIds,
    //   lCode: row.lCode,
    //   lCodeIds: row.lCodeIds,
    //   eCode: row.eCode,
    //   eCodeIds: row.eCodeIds,
    //   iCode: row.iCode,
    //   iCodeIds: row.iCodeIds,
    //   otherDxCodes: row.otherDxCodes,
    //   noOfApplications: row.noOfApplications,
    //   length: row.length,
    //   width: row.width,
    //   depth: row.depth,
    //   totalSize: row.totalSize.toString(),
    //   woundInfoKey: row.woundInfoKey
    // }));
    // const woundInfo = {
    //   woundData: woundData,
    //   totalSizeOfAllWounds: patientWoundTotalSize,
    // };

    const mappedPatientInfo = {
      patientCode: patientInfo.patientCode,
      patientId: patientInfo.patientId,
      isPatientEdited: isPatientEdited,
      firstName: patientInfo.patientFirstName,
      middleName: patientInfo.patientMiddleName,
      lastName: patientInfo.patientLastName,
      birthDate: patientInfo.patientDOB
        ? moment(patientInfo.patientDOB?.toString())?.format("MM/DD/YYYY")
        : "",
      gender: patientInfo.gender,
      dateOfSurgery: (practiceObject?.specialization === PRACTICE_TYPE.SURGICAL || practiceObject?.specialization === PRACTICE_TYPE.WOUND_CARE_AND_SURGICAL) && 
        getValues("treatmentInformation.dateOfService") ? moment(getValues("treatmentInformation.dateOfService")?.toString())?.format("MM/DD/YYYY") :patientCompleteData?.dateOfSurgery,
      providerId:  getValues("providerInformation.provider"),
      providerTemplateId: providerTemplateId,
      patientInfo: [
        {
          infoType: PATIENT_IVR_INFO_TYPES.ADDRESS,
          isEdited: false,
          patientinfoId: patientInfoIdAddress,
          infoTypeData: {
            patientStreetAddress: patientInfo.patientStreetAddress,
            patientUnitNumber: patientInfo.patientUnitNumber,
            patientCity: patientInfo.patientCity,
            patientState: patientInfo.patientState,
            patientZip: patientInfo.patientZipcode,
          },
        },
        {
          infoType: PATIENT_IVR_INFO_TYPES.FACE_SHEET,
          isEdited: isFaceSheetEdited,
          patientinfoId: patientInfoIdFaceSheet,
          infoTypeData: {
            documentIds: patientInfo.faceSheet,
            isSkipped: patientInfo.isFaceSheetSkipped,
          },
        },
        {
          infoType: PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE,
          isEdited: isPrimaryInsuranceInfoEdited,
          patientinfoId: patientInfoIdPrimaryInsurance,
          infoTypeData: {
            insuranceName: insuranceInformation.insuranceCategory==="Commercial" && insuranceInformation.primaryCommercialInsuranceName ? insuranceInformation.primaryCommercialInsuranceName : insuranceInformation.insuranceName,
            insurancePayerCode: insuranceInformation.insuranceCategory==="Commercial" && insuranceInformation.primaryCommercialInsuranceName? "":insuranceInformation.insurancePayerCode,
            insuranceCategory: insuranceInformation.insuranceCategory,
            insuranceNameNotListed: insuranceInformation.insuranceNameNotListed||false,
            primaryCommercialInsuranceName: insuranceInformation.primaryCommercialInsuranceName,
            policy: insuranceInformation.policy.toUpperCase(),
            isPolicyUnderDifferentName:
              insuranceInformation.isPolicyUnderDifferentName,
            policyHolderFirstName: insuranceInformation.policyholderFirstName,
            policyHolderMiddleName: insuranceInformation.policyholderMiddleName,
            policyHolderLastName: insuranceInformation.policyholderLastName,
            policyHolderDOB: insuranceInformation.policyHolderDOB
              ? moment(insuranceInformation.policyHolderDOB?.toString())?.format(
                "MM/DD/YYYY"
              )
              : "",
            insuranceType: insuranceInformation.insuranceType,
            documentIds: insuranceInformation.insuranceCards,
            isSkipped: insuranceInformation.isInsuranceCardsSkipped,
          },
        },
        ...(isSecondaryInsurance
        ? [
          {
            infoType: PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE,
            isEdited: isSecondaryInsuranceInfoEdited,
            patientinfoId: patientInfoIdSecondaryInsurance,
            infoTypeData: {
              insuranceName:insuranceInformation.secondaryInsuranceCategory==="Commercial" && insuranceInformation.secondaryCommercialInsuranceName ? insuranceInformation.secondaryCommercialInsuranceName : insuranceInformation.secondaryInsuranceName,
              insurancePayerCode:insuranceInformation.secondaryInsuranceCategory==="Commercial" && insuranceInformation.secondaryCommercialInsuranceName ? "":insuranceInformation.secondaryInsurancePayerCode,
              insuranceCategory: insuranceInformation.secondaryInsuranceCategory,
              secondaryInsuranceNameNotListed: insuranceInformation.secondaryInsuranceNameNotListed||false,
              secondaryCommercialInsuranceName: insuranceInformation.secondaryCommercialInsuranceName,
              policy: insuranceInformation.secondaryPolicy.toUpperCase(),
              isPolicyUnderDifferentName:
              insuranceInformation.isSecondaryPolicyUnderDifferentName,
              policyHolderFirstName: insuranceInformation.secondarypolicyholderFirstName,
              policyHolderMiddleName:
              insuranceInformation.secondarypolicyholderMiddleName,
              policyHolderLastName: insuranceInformation.secondarypolicyholderLastName,
              policyHolderDOB: insuranceInformation.secondaryPolicyHolderDOB
                ? moment(
                  insuranceInformation.secondaryPolicyHolderDOB?.toString()
                )?.format("MM/DD/YYYY")
                : "",
              insuranceType: insuranceInformation.secondaryInsuranceType,
              documentIds: insuranceInformation.secondaryInsuranceCards,
              isSkipped: insuranceInformation.isSecondaryInsuranceCardsSkipped,
            },
          },
          ]
        : []),
        {
          infoType: PATIENT_IVR_INFO_TYPES.MEDICAL_NOTES,
          isEdited: isSupportingDocumentsEdited,
          patientinfoId: patientInfoIdSupportingDocs,
          infoTypeData: {
            documentIds: supportingDocs.supportingDocuments,
            isSkipped: supportingDocs.isSupportingDocumentsSkipped,
          },
        },
        {
          infoType: PATIENT_IVR_INFO_TYPES.IMAGE_OF_WOUNDS,
          isEdited: isImageOfWoundsEdited,
          patientinfoId: patientInfoIdWoundImages,
          infoTypeData: {
            documentIds: supportingDocs.imageOfWounds,
            isSkipped: supportingDocs.isImageOfWoundsSkipped,
          },
        },
        // ...(!ivrId || duplicateIvr
        //   ? [
        //       {
        //         infoType: "WOUND_INFO",
        //         isEdited: isWoundInfoEdited,
        //         patientinfoId: patientWoundInfo,
        //         infoTypeData: {
        //           woundInfo: woundInfo,
        //         },
        //       },
        //     ]
        //   : []),
        {
          infoType: PATIENT_IVR_INFO_TYPES.EMAIL,
          isEdited: false,
          patientinfoId: patientEmail,
          infoTypeData: {
            patientEmail: patientEmailAddress
          },
        }
      ],
    };

    const updatedProducts = selectedProducts.map(product => ({
      ...product,
      providerId: parseInt(getValues("providerInformation.provider")),
    }));
    setSelectedProducts(updatedProducts);

    const treatmentInfo = ivrInfo.treatmentInformation;
    const productRealatedQuestions = ivrInfo.productQuestions;
    const safeguardRelatedQuestions = ivrInfo.safeguardQuestions;
    const mappedTreatmentInfo = {
      treatmentInfo: {
        // currentlyInNursingFacility: treatmentInfo.currentlyInNursingFacility,
        // daysAdmittedToFacility: treatmentInfo.daysAdmittedToFacility,
        // currentlyUnderSurgicalGlobalPeriod:
        //   treatmentInfo.currentlyUnderSurgicalGlobalPeriod,
        // surgicalProcedureDate: treatmentInfo.surgicalProcedureDate
        //   ? moment(treatmentInfo.surgicalProcedureDate?.toString())?.format(
        //     "MM/DD/YYYY"
        //   )
        //   : "",
        // surgicalProcedureCodes: treatmentInfo.surgicalProcedureCodes,
        placesOfService: [treatmentInfo.placesOfService],
        products: isPracticeIndividual ? selectedProducts : updatedProducts,
        currentlyCoveredUnderPartAStay: treatmentInfo.currentlyCoveredUnderPartAStay,
        productQuestions: productRealatedQuestions,
        safeguardQuestions: safeguardRelatedQuestions,
        homeHealth: treatmentInfo?.homeHealth
      },
    };

    const providerInfo = {
      practiceId: parseInt(getValues("providerInformation.practice")),
      practiceName:
        practiceObject != undefined
          ? practiceObject.practiceName
          : "",
      date: ivrInfo.providerInformation.providerSignedDate
        ? moment(
          ivrInfo.providerInformation.providerSignedDate?.toString()
        )?.format("MM/DD/YYYY")
        : "",
      signature: ivrInfo.providerInformation.signature,
      name: ivrInfo.providerInformation.name,
      provider: {
        providerName: selectedProviderData[0]?.providerName,
        npi: selectedProviderData[0]?.npi,
        ptan: selectedProviderData[0]?.ptan,
        taxId: selectedProviderData[0]?.taxId,
      },
    };

    // const patientConsentInfo = {
    //   isPatientConsentSigned: ivrInfo.patientConsentInfomation.isPatientConsentSigned,
    //   patientSignDate: ivrInfo.patientConsentInfomation.patientSignDate ? moment(ivrInfo.patientConsentInfomation.patientSignDate?.toString())?.format("MM/DD/YYYY") : "",
    // }

    const additionalNotes = {
      xrefTable: "IVR",
      xrefId: ivrId,
      noteType: "IVR_ADDITIONAL_NOTE",
      content: ivrInfo.comments,
      isFlag: location?.state?.ivrEmailNotification ? location?.state?.ivrEmailNotification : "true"
    }

    // const checkedWoundInfo: any[] = [];
    // selectedWoundList?.forEach(woundKey => {
    //   const foundWound = woundInfo?.woundData?.find(wound => wound.woundInfoKey === woundKey);
    //   if (foundWound) {
    //     checkedWoundInfo.push(foundWound);
    //   }
    // });
    const woundInfoIVR = {
      woundData: checkedWoundData,
      totalSizeOfAllWounds: parseFloat(getValues('woundInfo.totalSizeOfAllWounds') ?? '0'),
    };

    const mappedData: IVRObjectInfo = {
      ivrId: ivrId,
      ivrNumber: ivrNumber,
      practiceId: providerInfo.practiceId,
      productId: treatmentInfo.product,
      practiceProductId: treatmentInfo.practiceProductId,
      providerId: parseInt(getValues("providerInformation.provider")),
      locationId: parseInt(getValues("providerInformation.practiceLocation")),
      macId: parseInt(ivrInfo.providerInformation.macId),
      dateOfService: getValues("treatmentInformation.dateOfService")
        ? moment(
          getValues("treatmentInformation.dateOfService")?.toString()
        )?.format("MM/DD/YYYY")
        : "",
      productCategory: selectedProductCategory,
      benefitVerificationType: ivrInfo.typeOfIVR,
      patient: mappedPatientInfo,
      ivrInfo: {
        // patientConsentInfo: patientConsentInfo,
        treatmentInfo: mappedTreatmentInfo.treatmentInfo,
        woundInfo: woundInfoIVR,
        providerInfo: providerInfo,
        additionalNotes: additionalNotes,
      },
    };

    return mappedData;
  };

  const onPoliceUnderDifferentNameChanage = (e: any) => {
    if (e.target.value === "yes") {
      setIsPolicyUnderDifferentNameCheck(true);
      if (getValues(`patientInfo.${"patientId"}`)) {
        setValue(
          "insuranceInfo.policyholderFirstName",
          patientInfoObject.firstName
        );
        setValue(
          "insuranceInfo.policyholderMiddleName",
          patientInfoObject.middleName
        );
        setValue(
          "insuranceInfo.policyholderLastName",
          patientInfoObject.lastName
        );
        setValue("insuranceInfo.policyHolderDOB", patientInfoObject.birthDate);
      }
    } else {
      setIsPolicyUnderDifferentNameCheck(false);
      setValue("insuranceInfo.policyholderFirstName", "");
      setValue("insuranceInfo.policyholderMiddleName", "");
      setValue("insuranceInfo.policyholderLastName", "");
      setValue("insuranceInfo.policyHolderDOB", "");
    }
  };

  const onPoliceUnderDifferentNameChanageSecondary = (e: any) => {
    if (e.target.value === "yes") {
      setIsPolicyUnderDifferentNameCheckSecondary(true);
      if (getValues(`patientInfo.${"patientId"}`)) {
        setValue(
          "insuranceInfo.secondarypolicyholderFirstName",
          patientInfoObject.firstName
        );
        setValue(
          "insuranceInfo.secondarypolicyholderMiddleName",
          patientInfoObject.middleName
        );
        setValue(
          "insuranceInfo.secondarypolicyholderLastName",
          patientInfoObject.lastName
        );
        setValue(
          "insuranceInfo.secondaryPolicyHolderDOB",
          patientInfoObject.birthDate
        );
      }
    } else {
      setIsPolicyUnderDifferentNameCheckSecondary(false);
      setValue("insuranceInfo.secondarypolicyholderFirstName", "");
      setValue("insuranceInfo.secondarypolicyholderMiddleName", "");
      setValue("insuranceInfo.secondarypolicyholderLastName", "");
      setValue("insuranceInfo.secondaryPolicyHolderDOB", "");
    }
  };

  // const onSurgicalOrGlobalPeriodChange = (e: any) => {
  //   if (e.target.value === "true") {
  //     setIsUnderSurgicalGlobalPeriod(true);
  //   } else {
  //     setIsUnderSurgicalGlobalPeriod(false);
  //     setValue("treatmentInformation.surgicalProcedureDate", "")
  //     setValue("treatmentInformation.surgicalProcedureCodes", "")
  //   }
  // }

  const signaturePadValidations = {
    name: {
      required: "Name is required.",
    },
    signature: {
      required: "Signature is required.",
    },
  };

  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      const target = event.target as HTMLElement;
      if (!target.getAttribute('data-allow-submit')) {
        event.preventDefault();
      }
    }
  };

  // const handleFetchPracticeProducts = async (date: string, practiceId: number, providerId?: number) => {
  const handleFetchPracticeProducts = async (practiceId: number, providerId?: number) => {
    dispatch(showHideLoadingDialog(true));
    try {
      let securityTokensRes;
      let practiceProductsList;
      //CS-1612
      if(typeof getValues("providerInformation.provider") === "string"){
        return;
      }
      if (getValues("providerInformation.provider")) {
        securityTokensRes = await dispatch(fetchSecurityTokens({
          userId: parseInt(getValues("providerInformation.provider")),
          roleId: providerRoleId,
          tokenName: "canAccessProviderProducts"
        }));
      }

      setLoadingProdcuts(true);
      // const formattedDate = moment(date?.toString()).format("MM/DD/YYYY");
      const formattedDate = moment().format("MM/DD/YYYY");

      if (moment(formattedDate, "MM/DD/YYYY", true).isValid()) {
        let data: FetchPracticeProductsParams;
        if (isPracticeIndividual) {
          data = {
            practiceId: practiceId,
            dateOfService: formattedDate,
            providerId: providerId,
            moduleName:"CREATE_IVR"
          };
        } else {
          data = {
            practiceId: practiceId,
            dateOfService: formattedDate,
            providerId: 0,
            moduleName:"CREATE_IVR"
          };
        }

        const response = await dispatch(fetchPracticeProductsDataUsingDateOfServiceAndProvider(data));
        if (response) {

          if (securityTokensRes === undefined || securityTokensRes?.payload.length <= 0) {
            practiceProductsList = response.payload.data
          } else {

            const allowedProductIds = securityTokensRes?.payload
              .filter((token: any) => token.tokenValue)
              .flatMap((token: any) =>
                token.tokenValue.split(',').map((value: string) => parseInt(value))
              )
              .filter(Number.isInteger);

            const filteredData = response.payload.data.filter((product: any) =>
              allowedProductIds.includes(product.productId)
            );
            practiceProductsList = filteredData;
          }

          const productPromises = practiceProductsList.map(async (product: any) => {
            const productItems = await dispatch(fetchProductItemsByProductId({ productId: product.productId, onlyActiveRecords: true }));
            const macName = product.macId && product.macName ? " - " + product.macName : '';
            const providerName = product.billingType === "INDIVIDUAL" ? ` (${product.providerName}) ` : ""
            return {
              productId: product.productId,
              macId: product.macId,
              practiceProductId: product.practiceProductId,
              providerId: product.practiceProviderId,
              label: `${product.productName}${macName}`,
              productCategory: product.productCategory,
              isKit: product.isKit,
              sizes: productItems?.payload?.map((item: any) => item),
            };
          });

          const products: ProductListWithItems[] = await Promise.all(productPromises);
          const sortedProducts = products.sort((a, b) => a.label.localeCompare(b.label));
          setProductListWithItems(sortedProducts);
          setLoadingProdcuts(false);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingProdcuts(false);
      dispatch(showHideLoadingDialog(false));
    }
  }

  // const onNursingFacilityChange = (e: any) => {
  //   if (e.target.value === "true") {
  //     setIsPatientCurrentlyInNursingFacility(true);
  //   } else {
  //     setIsPatientCurrentlyInNursingFacility(false);
  //     setValue("treatmentInformation.daysAdmittedToFacility", "");
  //     setValue("treatmentInformation.currentlyCoveredUnderPartAStay", "");
  //   }
  // }

  const handleProductChange = (product: any, isProductChange: boolean, sizeObj: any) => {
    if (product.productId !== undefined && isProductChange) {
      setAutoSelectSafeguard(true);
      setValue('productQuestions', null);
      setValue('safeguardQuestions', null);
      dispatch(getProductQuestions(product.productId));
      dispatch(getSafeguardQuestions(product.productId));

      // CS-1728 - Replacing static label to dynamic constant
      if (product.productCategory === PRODUCT_CATEGORY.CONSERVATIVE) {
        if (product.isKit === true) {
          setMutiSelectProductItems(false);
        } else {
          setMutiSelectProductItems(true);
        }
        setProductKitOptions([]);
        setShowProductItemSelectPopup(true);
      }
    }

    if (isProductChange) {
      const newProduct = {
        productId: product.productId,
        macId: product.macId,
        practiceProductId: product.practiceProductId,
        providerId: product.providerId,
        productSizes: [],
        productName: product.label,
        productCategory: product.productCategory,
        isKit: product.isKit,
        productKitItemId: undefined
      };

      setSelectedProducts([newProduct]);
      setValue("treatmentInformation.products", [newProduct]);
    } else {
      setSelectedProducts(prevProducts => {
        const currentProduct = prevProducts[0];
        if (!currentProduct) return prevProducts;

        // CS-1728 - Replacing static label to dynamic constant
        const identifier = product.productCategory === PRODUCT_CATEGORY.CONSERVATIVE
          ? product.isKit === true ? `${sizeObj.productItemHcpcsCode} - ${sizeObj.size} - ${sizeObj.productItemDescription}` : `${sizeObj.hcpcsCode} - ${sizeObj.size} - ${sizeObj.productItemDescription}`
          : sizeObj.size;

        const updatedSizes = currentProduct.productSizes.includes(identifier)
          ? currentProduct.productSizes.filter(s => s !== identifier)
          : [...currentProduct.productSizes, identifier];

        const updatedProduct = {
          ...currentProduct,
          productSizes: updatedSizes,
        };

        const updatedProducts = [updatedProduct];
        setValue("treatmentInformation.products", updatedProducts);
        return updatedProducts;
      });
    }
  };

  const isSizeSelected = (product: ProductListWithItems, size: any) => {
    const selectedProduct = selectedProducts[0];
    if (!selectedProduct) return false;

    // For Collagen, use combined hcpcsCode, size and description, otherwise use size.size
    // CS-1728 - Replacing static label to dynamic constant
    const identifier = product.productCategory === PRODUCT_CATEGORY.CONSERVATIVE
      ? product.isKit === true ? `${size.productItemHcpcsCode} - ${size.size} - ${size.productItemDescription}`
        : `${size.hcpcsCode} - ${size.size} - ${size.productItemDescription}`
      : size.size;
    return selectedProduct.productSizes.includes(identifier);
  };

  const confirmOptionPopup = () => {
    setIsPatientInfoDisabled(false);
    setOptionPopupShow({ message: "", show: false });

    if (!getValues("patientInfo.isFaceSheetSkipped"))
      setValue("patientInfo.isFaceSheetSkipped", false)

    if (!getValues("insuranceInfo.isInsuranceCardsSkipped"))
      setValue("insuranceInfo.isInsuranceCardsSkipped", false)

    if (!getValues("supportingDocumentation.isSupportingDocumentsSkipped"))
      setValue("supportingDocumentation.isSupportingDocumentsSkipped", false)

    if (!getValues("supportingDocumentation.isImageOfWoundsSkipped"))
      setValue("supportingDocumentation.isImageOfWoundsSkipped", false)
  };

  const cancelOptionPopup = () => {
    setOptionPopupShow({ message: `Do you want to change the information of ${fullName("", getValues("patientInfo.patientFirstName"), getValues("patientInfo.patientMiddleName"), getValues("patientInfo.patientLastName"))} ? `, show: false });
  };

  useEffect(() => {
    if (patientData && (patientData.from === CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT || patientData.from === CAN_ACCESS_APPLICATION.IVR_MANAGEMENT)
      && patientData.patientId && patientsOptions?.length > 0) {
      const patient = patientsOptions.find(opt => opt.value == (patientData.patientId).toString());
      if (patient) {
        setValue('patientInfo.patientId', patientData.patientId)
        handlePatientChange(true);
      }
    }
  }, [patientData, patientsOptions])

  useEffect(() => {
    const productOptionsReady = productListWithItems && productListWithItems.length > 0;
    const currentProductId = getValues("treatmentInformation.practiceProductId");
  
    if (productOptionsReady && currentProductId) {
      const match = productListWithItems.find(p => p.practiceProductId === currentProductId);
      if (match) {
        setValue("treatmentInformation.practiceProductId", currentProductId);
        dispatch(getProductQuestions(match.productId));
        dispatch(getSafeguardQuestions(match.productId));
        const timer = setTimeout(() => {
          setAutoSelectSafeguard(true);
        }, 5000);
      }
    }
  }, [productListWithItems]);
  
  const selectedProductId = watch("treatmentInformation.practiceProductId");

  const selectedProduct = productListWithItems?.find(
    (product) => product.practiceProductId === selectedProductId
  );

  const modifiedSelectedProduct = useMemo(() => {
  if (!selectedProduct) return null;
  
    // CS-1728 - Replacing static label to dynamic constant
    if (selectedProduct.productCategory === PRODUCT_CATEGORY.CONSERVATIVE) {
      return {
        ...selectedProduct,
        sizes: kitItemData || []
      };
    }
  
  return selectedProduct;
}, [selectedProduct, kitItemData]);

  useEffect(() => {
    // CS-1728 - Replacing static label to dynamic constant
    if (modifiedSelectedProduct && modifiedSelectedProduct.productCategory !== PRODUCT_CATEGORY.ADVANCED && modifiedSelectedProduct.sizes && modifiedSelectedProduct.sizes.length > 0) {
      const allSizes = modifiedSelectedProduct.sizes.map((size, index) => {
        if (modifiedSelectedProduct.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && modifiedSelectedProduct.isKit === false) {
          return `${size.hcpcsCode} - ${size.size} - ${size.description}`;
        } else if (modifiedSelectedProduct.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && modifiedSelectedProduct.isKit === true) {
          return `${size.productItemDescription} ${size.size} (${size.productItemHcpcsCode})`;
        } else {
          return size.size;
        }
      });

      setSelectedProducts(prevProducts => {
        if (prevProducts.length === 0) return prevProducts;

        const updatedProduct = {
          ...prevProducts[0],
          productSizes: allSizes,
        };

        const updatedProducts = [updatedProduct];
        setValue("treatmentInformation.products", updatedProducts);
        checkProductInfoValidity({ ...watch() });
        return updatedProducts;
      });
    }
  }, [modifiedSelectedProduct, setValue]);

  useEffect(() => {
    // CS-1728 - Replacing static label to dynamic constant
    if (selectedProduct?.productCategory === PRODUCT_CATEGORY.CONSERVATIVE) {
      const productKitItems = selectedProduct.sizes.map((size) => ({
        id: size.productItemId,
        hcpcsCode: size.hcpcsCode,
        size: size.size,
        description: size.productItemDescription,
        noOfDays: size.noOfDays, 
        ...(selectedProduct.isKit && { productKitSubItems: size.productKitSubItems })
      }));
      setProductKitOptions(productKitItems);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (
    // CS-1728 - Replacing static label to dynamic constant
    selectedProductCategory !== PRODUCT_CATEGORY.ADVANCED &&
    getValues("treatmentInformation.dateOfService") !== null
  ) {
    setValue("treatmentInformation.dateOfService", null);
  }
}, [selectedProductCategory, selectedProducts]);

  const clickShowIncisionInfoPopup = () => {
    setShowIncisionInfoPopup(true);
  };

  const shouldSelectSafeguard = () => {
  if (location?.state?.duplicateIVR) {
    return true;
  }
  if (surgicalTemplate && !location?.state?.ivrId) {
    return true;
  }
  return autoSelectSafeguard;
};
  //CS-1451 START
// const homeHealthValue = watch("treatmentInformation.homeHealth");
  // const discardedHome = watch("treatmentInformation.discardedHome");
  
  const shouldShowWarning = hasHardStop;

  const handleSafeguard = (field: string, value: string) => {
    setValue(field as any, value);

    // if (field === "treatmentInformation.discardedHome") {
      // setValue("treatmentInformation.homeHealth", "");
      // setHasHardStop(false);
    // }
  
    if (field === "treatmentInformation.homeHealth" && value === "No") {
        setHasHardStop(false);
    }

    //CS-1519
    setTimeout(() => {
      checkSafeguardQuestionsValidity({ ...watch() });
    }, 0);
  
    if (
      (field === "treatmentInformation.homeHealth" && value === "Yes")
    ) {
      setShowOptionsPopup({
        show: true,
        variant: "error",
        message: (
          <>
            <strong>IVR Request Blocked:</strong> The patient does not meet criteria.  
            <br />
            Please check discharge and home health status before proceeding.
          </>
        ),
        buttons: [
          {
            name: "OK",
            color: "error",
            onClick: () => {
              setShowOptionsPopup({ show: false, message: "" });
              setHasHardStop(true);
            },
          },
        ],
      });
    }
  };
  //CS-1451 END

  return (
    <>
      {showWoundInfoPopup &&
        <IVRFormWoundInfoPopup
          open={showWoundInfoPopup}
          onClose={() => {
            setShowWoundInfoPopup(false);
            setCurrentWoundInfo(null);
          }}
          currentWoundInfo={currentWoundInfo}
          onAddWoundInfo={handleAddWoundInfo}
          from={CAN_ACCESS_APPLICATION.IVR_MANAGEMENT}
          ivrId={ivrId}
        />}
      {showIncisionInfoPopup &&
        <IVRFormIncisionInfoPopup
          open={showIncisionInfoPopup}
          onClose={() => {
            setShowIncisionInfoPopup(false);
            setCurrentWoundInfo(null);
          }}
          currentIncisionInfo={currentWoundInfo}
          onAddIncisionInfo={handleAddWoundInfo}
          from={CAN_ACCESS_APPLICATION.IVR_MANAGEMENT}
          ivrId={ivrId}
        />
      }
      
      <Box sx={{
        margin: {
          xs: "20px 10px",
          sm: "20px",
        },
      }}>
        <Box mb={2} display="flex" alignItems="flex-start" gap={1.5}>
        <PageBackButton tooltip={null} />
        <Box>
          <Typography
            sx={{
              fontSize: "0.7rem",
              fontWeight: 700,
              color: mTokens.textSecondary,
              textTransform: "uppercase",
              letterSpacing: "0.12em",
              mb: 0.3,
            }}
          >
            Operations / Insurance Verification
          </Typography>
          <Typography
            component="h1"
            sx={{
              fontSize: "1.6rem",
              fontWeight: 800,
              color: mTokens.textPrimary,
              lineHeight: 1.1,
            }}
          >
            Insurance Verification Request
          </Typography>
        </Box>
      </Box>
        <Box sx={{ mb: 2 }} data-testid="card">
            <StickTopStepper
              activeStep={activeStep}
              setActiveStep={setActiveStep}
              steps={steps}
              isViewMobile={false}
              content={
                (
                  <Box display="flex" alignItems="center" gap={2} mt={1} flexWrap="wrap">
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      sx={{
                        px: 1.2,
                        py: 0.6,
                        borderRadius: "999px",
                        border: `1px solid ${mTokens.accent}33`,
                        backgroundColor: `${mTokens.accent}14`,
                      }}
                    >
                      <PersonOutlineOutlined sx={{ color: mTokens.accent, fontSize: "1.05rem" }} />
                      <Typography sx={{ color: mTokens.accent, fontWeight: 700, fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.08em" }}>
                        Patient
                      </Typography>
                      <Typography sx={{ color: mTokens.textPrimary, fontWeight: 700, fontSize: "0.9rem" }}>
                        {fullName("", getValues("patientInfo.patientFirstName"), getValues("patientInfo.patientMiddleName"), getValues("patientInfo.patientLastName"))}
                      </Typography>
                    </Box>
                  </Box>
                )
              }
            />
        </Box>
          <form onSubmit={handleSubmit(onSubmit, onError)} onKeyDown={handleKeyPress}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>

              <Box ref={insuranceVerificationRequestRef} sx={cardSx} data-testid="bordered-section">
                <Box data-testid="header">
                  <SectionHeader
                    icon={<AssignmentTurnedInOutlined fontSize="small" />}
                    title="Insurance Verification Request"
                  />
                </Box>
                <Box sx={sectionBodySx}>
                  <FieldLabel label="Request Type" required />
                  <FormControl>
                    <CustomRadioButton
                      control={control}
                      options={typeOfIVROptions}
                      controllerName="typeOfIVR"
                      onChange={(e) => {
                        checkIVRequestValidity({ ...watch() });
                      }}
                      rules={{ required: "IVR type is required." }}
                      isDisabled={disableAllFields}
                    />
                  </FormControl>
                </Box>
              </Box>

              <Box ref={productInformationRef} sx={cardSx} data-testid="bordered-section">
                <SectionHeader
                  icon={<DescriptionOutlined fontSize="small" />}
                  title="Product Information"
                  action={
                    <CustomHelpMessage
                      title="Help"
                      message={
                        <Typography fontWeight="bold">
                          Please select the "Provider" to choose the product.
                        </Typography>
                      }
                    />
                  }
                />
                <Box sx={sectionBodySx}>
                  <Grid container spacing={2}>
                    {/* CS-1530 - Point 4 */}
                    <Grid item md={4} xs={12}>
                      <FieldLabel label="Provider" required />
                      <Box sx={dropdownFieldWrapSx(!!errors?.providerInformation?.provider)}>
                        <CustomDropdownField
                          name={`providerInformation.${"provider"}`}
                          control={control}
                          options={practiceProvidersOptions}
                          label=""
                          size="small"
                          rules={{ required: "Provider is required." }}
                          onChangeSelect={(e) => {
                            setValue("treatmentInformation.practiceProductId", 0)
                            setValue("treatmentInformation.productSizes", [])
                            setSelectedProducts([]);
                            dispatch(resetProductItems());
                            handleProviderChange();
                            checkProductInfoValidity({ ...watch() });
                          }}
                          disabled={disableAllFields}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Controller
                    name={`treatmentInformation.products`}
                    control={control}
                    rules={{
                      validate: (value: any) => {
                        if (value !== undefined) {
                          if (value.length === 0) {
                            return "At least one product should be selected.";
                          }
                          for (let product of value) {
                            if (product.productSizes.length === 0) {
                              return "At least one product item should be selected.";
                            }
                          }
                        } else {
                          return "At least one product should be selected.";
                        }
                        return true;
                      }
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <>
                          {!disableProductField ?
                            <>
                              <Typography sx={{ mt: 2, fontSize: "0.92rem", fontWeight: 700, color: mTokens.textPrimary }}>Products</Typography>

                              {productListWithItems && productListWithItems.length > 0 ? (
                              <Box sx={{display: 'flex', flexWrap: 'wrap', gap: '8px', mt: 1, alignItems: 'flex-end'}}>
                                <Box minWidth={250}>
                                  <FieldLabel label="Select Product" required />
                                  <Box sx={dropdownFieldWrapSx(!!errors?.treatmentInformation?.practiceProductId)}>
                                  <CustomDropdownField
                                    control={control}
                                    name={`treatmentInformation.${"practiceProductId"}`}
                                    label=""
                                    size="small"
                                    options={
                                      (productListWithItems ?? []).map((product) => ({
                                        label: product.label,
                                        value: product.practiceProductId,
                                      }))
                                    }
                                    rules={{ required: "Product is required." }}
                                    disabled={disableAllFields}
                                    onChangeSelect={(e: any, value: any) => {
                                      setValue("treatmentInformation.productSizes", []); // Clear selected sizes
                                      setKitItemData([])

                                      if(value === undefined){
                                        setValue("treatmentInformation.products", []);
                                        setSelectedProductCategory("");
                                        checkProductInfoValidity({ ...watch() });
                                      }

                                      const selected = productListWithItems?.find(
                                        (p) => p.practiceProductId === value
                                      );
                                      if (selected) {
                                        handleProductChange(selected, true, "");
                                        setSelectedProductCategory(selected.productCategory);
                                      }
                                    }}
                                  />
                                  </Box>
                                  </Box>

                                  {modifiedSelectedProduct && modifiedSelectedProduct.sizes && modifiedSelectedProduct.sizes.length > 0 && (
                                    <Box
                                      sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', minHeight: '42px' }}
                                      key={`${modifiedSelectedProduct.practiceProductId}-${modifiedSelectedProduct.productCategory}-${modifiedSelectedProduct.isKit}`}
                                    >
                                      {modifiedSelectedProduct.sizes
                                        .slice()
                                        .sort((a:any, b:any) => a.units - b.units)
                                        .map((size:any, index:any) => {
                                          // CS-1728 - Replacing static label to dynamic constant
                                          const sizeLabel = modifiedSelectedProduct.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && modifiedSelectedProduct.isKit === false
                                            ? `${size.hcpcsCode} - ${size.size} - ${size.description}`
                                            : modifiedSelectedProduct.productCategory === PRODUCT_CATEGORY.CONSERVATIVE && modifiedSelectedProduct.isKit === true
                                              ? `${size.productItemDescription} ${size.size} (${size.productItemHcpcsCode})`
                                              : size.size;

                                          // Render CustomCheckbox only for Advanced CTP, otherwise render as label
                                          return modifiedSelectedProduct.productCategory === PRODUCT_CATEGORY.ADVANCED ? (
                                            <CustomCheckbox
                                              key={`${modifiedSelectedProduct.practiceProductId}-${modifiedSelectedProduct.productCategory}-${modifiedSelectedProduct.isKit}-${size.size}`}
                                              control={control}
                                              label={sizeLabel}
                                              name="treatmentInformation.productSizes"
                                              id={`${modifiedSelectedProduct.practiceProductId}-${modifiedSelectedProduct.productCategory}-${modifiedSelectedProduct.isKit}-${size.size}-${size.hcpcsCode || ''}-${index}`}
                                              checked={isSizeSelected(modifiedSelectedProduct, size)}
                                              onChange={() => {
                                                handleProductChange(modifiedSelectedProduct, false, size);
                                                checkProductInfoValidity({ ...watch() });
                                              }}
                                              isDisabled={disableAllFields || (!modifiedSelectedProduct.isKit ? !size.isSizeActive : false)}
                                              strikeThrough={!modifiedSelectedProduct.isKit ? !size.isSizeActive : false}
                                            />
                                          ) : (
                                           
                                            <Box>
                                              <Chip
                                                key={`${modifiedSelectedProduct.practiceProductId}-${modifiedSelectedProduct.productCategory}-${modifiedSelectedProduct.isKit}-${size.size}`}
                                                label={sizeLabel}
                                                size="small"
                                                sx={{
                                                  backgroundColor:
                                                    theme.palette.mode === "dark"
                                                      ? "#2C3E50"
                                                      : colors.grey[700],
                                                  padding: "1px 10px",
                                                  fontWeight: "bold",
                                                  border: "1px solid ",
                                                  borderColor:
                                                    theme.palette.mode === "dark"
                                                      ? "#34495E"
                                                      : colors.grey[700],
                                                }}
                                              />
                                            </Box>
                                          );
                                        })}
                                    </Box>
                                  )}
                                </Box>)
                              : (
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    {
                                      loadingProdcuts ?
                                        <Typography>Loading...</Typography> :
                                        <Typography sx={{ color: 'red' }}>Couldn't find any products for the selected date of service and provider</Typography>
                                    }
                                  </Grid>
                                </Grid>
                              )}

                              {/* <Typography mb={2}>Please Note: Each product you select will generate a separate IVR submission. ie. Selecting “Product X” and “Product Y” will result in two IVR submissions: one IVR for “Product X” and one IVR for “Product Y”</Typography> */}
                              {fieldState.error && (
                                <Typography
                                  color="error"
                                  variant="body2"
                                  style={{ marginTop: "2px" }}
                                >
                                  {fieldState && fieldState?.error?.message}
                                </Typography>
                              )}

                              {/* {productListWithItems && productListWithItems.length > 0 ? (
                                productListWithItems.map(product => (
                                  <Grid container key={product.practiceProductId} alignItems="center" justifyContent="flex-start" spacing={2}>
                                    <Grid item xs={12} md sm>
                                      <CustomRadioButton
                                        control={control}
                                        // label={product.label}
                                        name={`treatmentInformation.${"practiceProductId"}`}
                                        // id={product.practiceProductId.toString()}
                                        options={[{ value: product.practiceProductId, label: product.label }]}
                                        value={selectedProducts?.find(p => p.practiceProductId === product.practiceProductId)?.practiceProductId.toString()}
                                        onChange={() => {
                                          handleProductChange(product, true, '');
                                          checkProductInfoValidity({ ...watch() });

                                          // trigger("treatmentInformation.products")
                                        }}
                                        rules={{ required: "Product is required." }}
                                        isDisabled={disableAllFields}
                                      />
                                    </Grid>
                                    {selectedProducts?.some(p => p.practiceProductId === product.practiceProductId) && (
                                      <Grid xs={6} md={9}>
                                        <Box sx={{ pl: isMobile ? 5 : 0 }}>
                                          {product.sizes
                                            .slice()
                                            .sort((a, b) => a.units - b.units)
                                            .map(size => (
                                              <CustomCheckbox
                                                control={control}
                                                label={size.size}
                                                name={`treatmentInformation.${"productSizes"}`}
                                                id={`${product.practiceProductId}-${size.size}`}
                                                checked={isSizeSelected(product, size.size)}
                                                onChange={() => {
                                                  handleProductChange(product, false, size.size);
                                                  checkProductInfoValidity({ ...watch() });
                                                  // trigger("treatmentInformation.products")
                                                }}
                                                isDisabled={!selectedProducts?.find(p => p.practiceProductId === product.practiceProductId) || disableAllFields || !size.isSizeActive}
                                                strikeThrough={!size.isSizeActive}
                                              />
                                            ))}
                                        </Box>
                                      </Grid>
                                    )}
                                  </Grid>
                                ))
                              ) : (
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    {
                                      loadingProdcuts ?
                                        <Typography>Loading...</Typography> :
                                        <Typography sx={{ color: 'red' }}>Couldn't find any products for the selected date of service and provider</Typography>
                                    }
                                  </Grid>
                                </Grid>
                              )}
                               */}
                            </>
                            : ""
                          }
                        </>
                      );
                    }}
                  />
                <Grid container spacing={2} mt={1}>
                    {/* CS-1530 - Point 4 */}
                  <Grid item md={2} xs={12}>
                      <FieldLabel label="POS" required />
                      <Box sx={dropdownFieldWrapSx(!!errors?.treatmentInformation?.placesOfService)}>
                        <CustomDropdownField
                          control={control}
                          name={`treatmentInformation.${"placesOfService"}`}
                          options={placesOfService}
                          label=""
                          size="small"
                          rules={{ required: "Place(s) of Service is required." }}
                          onChangeSelect={(e) => {
                            checkProductInfoValidity({ ...watch() });
                          }}
                          disabled={disableAllFields}
                          sortOptions={false}
                        />
                      </Box>
                    </Grid>
                    {/* CS-1728 - Replacing static label to dynamic constant */}
                    {selectedProductCategory === PRODUCT_CATEGORY.ADVANCED &&
                    selectedProducts &&
                    selectedProducts.length > 0 &&
                    selectedProducts[0].productSizes &&
                    selectedProducts[0].productSizes.length > 0 ? (
                        <Grid item md={2} xs={12}>
                        <FieldLabel label="Date Of Service" required />
                        <Box sx={dateFieldWrapSx(!!errors?.treatmentInformation?.dateOfService)}>
                          <CustomDatePicker
                            controllerName={`treatmentInformation.${"dateOfService"}`}
                            control={control}
                            label=""
                            size="small"
                            rules={{
                              required: "Date of Service is required."
                            }}
                            disabled={disableAllFields}
                            onChange={() => {
                              checkProductInfoValidity({ ...watch() });
                            }}
                          />
                        </Box>
                      </Grid>
                    ) : null}
                    </Grid>
                </Box>
              </Box>

              <Box ref={patientInformationRef} sx={cardSx} data-testid="bordered-section">
                <SectionHeader
                  icon={<HealthAndSafetyOutlined fontSize="small" />}
                  title="Patient/Insurance Information"
                  onHeaderClick={errorOccured ? undefined : () => setPatientInfoExpanded(!patientInfoExpanded)}
                  action={
                    errorOccured ? undefined : (
                      <IconButton
                        size="small"
                        aria-label={patientInfoExpanded ? "Collapse section" : "Expand section"}
                        onClick={(e) => { e.stopPropagation(); setPatientInfoExpanded(!patientInfoExpanded); }}
                        sx={collapseToggleSx}
                      >
                        {patientInfoExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                      </IconButton>
                    )
                  }
                />
                <Collapse in={errorOccured || patientInfoExpanded}>
                <Box sx={sectionBodySx}>
                  <Grid container spacing={2} display="flex" justifyContent="space-between">
                    <Grid item md={3} xs={12} mb={1}>
                      <FieldLabel label="FaceSheet" required />
                      <Dropzone
                        control={control}
                        rules={{ required: "FaceSheet is required." }}
                        name={`patientInfo.${"faceSheet"}`}
                        onFileChange={handleFaceSheetChange}
                        label=""
                        isDisabled={isPatientInfoDisabled || disableAllFields}
                        onDeleteFile={handleDeleteFacesheetDocument}
                        // initialFiles={faceSheetInitialFiles}
                        initialFilesMetaData={uploadedFacesheetFilesMetaData}
                        holdOnChange={true}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    {getValues("patientInfo.faceSheet") && getValues("patientInfo.faceSheet").length === 0 ?
                      <Grid item md={5} xs={12}>
                        <CustomCheckbox
                          control={control}
                          label="I acknowledge the information is on file, and not available for upload at this time."
                          controllerName={`patientInfo.${"isFaceSheetSkipped"}`}
                          onChange={(e) => {
                            if (e.target.checked === true) {
                              clearErrors('patientInfo.faceSheet');
                              const faceSheetDocumentIds = getValues("patientInfo.faceSheet");
                              const removePromises = faceSheetDocumentIds.map((id) =>
                                dispatch(removeIVRDocument(id.toString()))
                              );
                              setValue("patientInfo.faceSheet", []);
                              setUploadedFacesheetFilesMetaData([]);
                            } else {
                              trigger('patientInfo.faceSheet');
                            }
                            checkPatientInfoValidity({ ...watch() });
                          }}
                          isDisabled={isPatientInfoDisabled || disableAllFields}
                        />
                      </Grid>
                      : ""}
                  </Grid>
                  <Grid item md={12} xs={12} mt={2}>
                    <Divider
                      orientation="horizontal"
                      variant="middle"
                      flexItem
                      sx={{ padding: 0, margin: 0 }}
                    />
                  </Grid>

                  <Box mt={1} ref={insuranceInformationRef}>
                    <Grid container spacing={2}>
                      <Grid item md={12} xs={12}>
                        <Typography sx={{ fontSize: "0.92rem", fontWeight: 700, color: mTokens.textPrimary }}>Primary Insurance</Typography>
                      </Grid>
                      <Grid
                        item md={3} xs={12}
                      >
                        <FieldLabel label="Category" required />
                        <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.insuranceCategory)}>
                        <CustomDropdownField
                          control={control}
                          name={`insuranceInfo.${"insuranceCategory"}`}
                          options={insuranceCategory}
                          label=""
                          size="small"
                          sortOptions={false}
                          onChangeSelect={(data) => {
                            if (data) {
                              setValue("insuranceInfo.insuranceName", '')
                              setValue("insuranceInfo.insurancePayerCode", '')
                              setValue("insuranceInfo.primaryCommercialInsuranceName", '')
                            }
                          }}
                          rules={{ required: "Category is required." }}
                          disabled={disableAllFields||isPatientInfoDisabled||insuranceNameNotListed || getValues('insuranceInfo.insuranceNameNotListed')}
                        />
                        </Box>
                      </Grid>
                      <Grid item md={3} xs={12}>
                        <FieldLabel label="Plan" required />
                        <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.insurancePayerCode)}>
                        <CustomDropdownField
                          control={control}
                          name={`insuranceInfo.${"insurancePayerCode"}`}
                          label=""
                          size="small"
                          sortOptions={false}
                          options={primaryPayersOptions}
                          onChangeSelect={(data) => {
                            if (getValues('insuranceInfo.insuranceName')) {

                                setValue("insuranceInfo.insuranceName", data?.label);
                                setValue("insuranceInfo.insurancePayerCode", data?.value);
                                if (getValues("insuranceInfo.insuranceCategory") === "Commercial" && data?.label === "Other") {

                                    setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                    checkInsuranceInfoValidity({ ...watch() });
                                } else if (getValues("insuranceInfo.insuranceCategory") !== "Commercial" && data?.label) {

                                    setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                    setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                } else {

                                    setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                    setValue(`insuranceInfo.${"primaryCommercialInsuranceName"}`, '');
                                    setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                }
                            } else {

                                if (getValues("insuranceInfo.insuranceCategory") === "Commercial" && data?.label === "Other") {

                                    setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                    checkInsuranceInfoValidity({ ...watch() });
                                } else if (getValues("insuranceInfo.insuranceCategory") !== "Commercial" && data?.label) {
                                    setValue(`insuranceInfo.${"insuranceName"}`, data?.label);

                                    setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                } else {

                                    setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                    setValue(`insuranceInfo.${"primaryCommercialInsuranceName"}`, '');
                                    setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                }
                            }


                        }}
                        rules={{ required:submitAction === "submitAction" && !getValues("insuranceInfo.insuranceName")? "Plan is required.":"" }}

                        disabled={!watch('insuranceInfo.insuranceCategory')||disableAllFields||isPatientInfoDisabled||primaryPayersOptions?.length === 1||insuranceNameNotListed ||getValues('insuranceInfo.insuranceNameNotListed')}
                        />
                        </Box>
                      </Grid>

                      <Grid item md={3} xs={12}>
                        <FieldLabel label="Policy #" required />
                        <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.policy)}>
                        <CustomTextField
                          controllerName={`insuranceInfo.${"policy"}`}
                          control={control}
                          label=""
                          size="small"
                          inputProps={{ maxLength:watch('insuranceInfo.insuranceCategory')==="Medicare" && 11, style: { textTransform: 'uppercase' } }}
                          rules={{
                            required: "Policy # is required.",
                            validate: (value: any) => {
                              if (!value) {
                                return "Policy # is required.";
                              } else if (watch('insuranceInfo.insuranceCategory') === "Medicare") {
                                return isValidMedicareMbi(value) ? true : INVALID_MBI_MESSAGE;
                              } else if (value.includes('-')) {
                                return "Enter an 11-digit number without dashes";
                              }
                              return true;
                            }
                          }}
                          onChange={(e) => {
                            checkInsuranceInfoValidity({ ...watch() });
                          }}
                          disabled={isPatientInfoDisabled || disableAllFields}
                        />
                        </Box>
                      </Grid>
                      {getValues("insuranceInfo.insuranceCategory") === "Commercial" && watch("insuranceInfo.insuranceName") === "Other" && (
                        <Grid item md={3} xs={12}>
                          <FieldLabel label="Plan" />
                          <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.primaryCommercialInsuranceName)}>
                            <CustomTextField
                              controllerName={`insuranceInfo.${"primaryCommercialInsuranceName"}`}
                              control={control}
                              label=""
                              size="small"
                              rules={{
                                validate: (value: any) => {
                                  if (submitAction === "submitAction" && !value) {
                                    return "Plan is required.";
                                  }
                                  return true;
                                }
                              }}
                              disabled={isPatientInfoDisabled || disableAllFields}
                              onChange={() => { checkInsuranceInfoValidity({ ...watch() }); }}
                            />
                          </Box>
                        </Grid>
                      )}
                      <Grid
                        item
                        md={12}
                        xs={12}
                        sx={{
                          display: {
                            xs: "block",
                            md: "flex",
                          },
                          alignItems: {
                            md: "center",
                          },
                        }}
                      >
                        <Typography sx={inlineLabelSx}>Plan is NOT listed</Typography>
                        <CustomCheckbox
                          control={control}
                          label="Yes"
                          name="insuranceNameNotListed"
                          id="insuranceNameNotListed"
                          controllerName={`insuranceInfo.${"insuranceNameNotListed"}`}
                          checked={insuranceNameNotListed}
                          onChange={() => { handleClick() }}
                          isDisabled={isPatientInfoDisabled || disableAllFields}
                        />
                      </Grid>
                      <Grid
                        item
                        md={12}
                        xs={12}
                        sx={{
                          display: {
                            xs: "block",
                            md: "flex",
                          },
                          alignItems: {
                            md: "center",
                          },
                        }}
                      >
                        <Typography sx={inlineLabelSx}>
                          Is the policy under a different name?
                        </Typography>
                        <CustomRadioButton
                          control={control}
                          options={policyOptions}
                          controllerName={`insuranceInfo.${"isPolicyUnderDifferentName"}`}
                          onChange={(e) => {
                            onPoliceUnderDifferentNameChanage(e);
                            checkInsuranceInfoValidity({ ...watch() });
                          }}
                          rules={{
                            required:
                              "Is the policy under a different name is required.",
                          }}
                          isDisabled={isPatientInfoDisabled || disableAllFields}
                        />
                      </Grid>
                      {isPolicyUnderDifferentNameCheck ? (
                        <>
                          <Grid item md={12} xs={12}>
                            <FieldLabel label="Policy Holder" required />
                            <Box sx={textFieldWrapSx(!!(errors?.insuranceInfo?.policyholderFirstName || errors?.insuranceInfo?.policyholderLastName))}>
                              <CustomNametField
                                control={control}
                                name="insuranceInfo"
                                context="policyHolder"
                                label="Policy Holder"
                                size="small"
                                usePlaceholder={true}
                                isRequired={true}
                                onChange={(e) => {
                                  checkInsuranceInfoValidity({ ...watch() });
                                }}
                                isDisabled={isPatientInfoDisabled || disableAllFields}
                              />
                            </Box>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <FieldLabel label="Policy Holder DOB" required />
                            <Box sx={dateFieldWrapSx(!!errors?.insuranceInfo?.policyHolderDOB)}>
                              <CustomDatePicker
                                control={control}
                                controllerName={`insuranceInfo.${"policyHolderDOB"}`}
                                label=""
                                size="small"
                                rules={{
                                  required: "Policy Holder DOB is required.",
                                }}
                                onChange={(e) => {
                                  checkInsuranceInfoValidity({ ...watch() });
                                }}
                                disabled={isPatientInfoDisabled || disableAllFields}
                              />
                            </Box>
                          </Grid>
                        </>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid container spacing={2} mt={1}>
                      <Grid item md={3} xs={12} mb={2}>
                        <FieldLabel label="Insurance Cards" required />
                        <Dropzone
                          control={control}
                          rules={{ required: "Insurance Cards are required." }}
                          name={`insuranceInfo.${"insuranceCards"}`}
                          onFileChange={handleInsuranceCardChange}
                          label=""
                          isDisabled={isPatientInfoDisabled || disableAllFields}
                          onDeleteFile={handleDeleteInsuranceDocument}
                          // initialFiles={primaryInsCardsInitialFiles}
                          initialFilesMetaData={uploadedPrimaryInsuranceFilesMetaData}
                          holdOnChange={true}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      {getValues("insuranceInfo.insuranceCards") && getValues("insuranceInfo.insuranceCards").length === 0 ?
                        <Grid item md={5} xs={12}>
                          <CustomCheckbox
                            control={control}
                            label="I acknowledge the information is on file, and not available for upload at this time."
                            controllerName={`insuranceInfo.${"isInsuranceCardsSkipped"}`}
                            onChange={(e) => {
                              if (e.target.checked === true) {
                                clearErrors('insuranceInfo.insuranceCards');
                                const insuranceCardsIds = getValues("insuranceInfo.insuranceCards");
                                const removePromises = insuranceCardsIds.map((id) =>
                                  dispatch(removeIVRDocument(id.toString()))
                                );
                                setValue("insuranceInfo.insuranceCards", []);
                                setUploadedPrimaryInsuranceFilesMetaData([]);
                              } else {
                                trigger('insuranceInfo.insuranceCards');
                              }
                              checkInsuranceInfoValidity({ ...watch() });
                            }}
                            isDisabled={isPatientInfoDisabled || disableAllFields}
                          />
                        </Grid>
                        : ""}
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={12}
                        md
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography sx={{ ...inlineLabelSx, fontSize: "0.92rem", fontWeight: 700, color: mTokens.textPrimary }}>Secondary Insurance</Typography>
                        <CustomCheckbox
                          control={control}
                          label="Yes"
                          name="secondaryInsurance"
                          id="secondaryInsurance"
                          controllerName={`insuranceInfo.${"isSecondaryInsurance"}`}
                          checked={isSecondaryInsurance}
                          onChange={() => {
                            setIsSecondaryInsurance(!isSecondaryInsurance);
                            setUploadedSecondaryInsuranceFilesMetaData([])
                            setValue("insuranceInfo.secondaryInsuranceCards", []);

                          }}
                          isDisabled={isPatientInfoDisabled || disableAllFields}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      {isSecondaryInsurance && (
                        <>
                          <Grid
                            item md={3} xs={12}
                          >
                            <FieldLabel label="Category" required />
                            <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.secondaryInsuranceCategory)}>
                            <CustomDropdownField
                              control={control}
                              name={`insuranceInfo.${"secondaryInsuranceCategory"}`}
                              options={insuranceCategory}
                              label=""
                              size="small"
                              sortOptions={false}
                              onChangeSelect={(data) => {
                                if (data) {
                                  setValue("insuranceInfo.secondaryInsuranceName", '')
                                  setValue("insuranceInfo.secondaryInsurancePayerCode", '')
                                  setValue("insuranceInfo.secondaryCommercialInsuranceName", '')
                                }
                              }}
                              rules={{ required: "Category is required." }}
                              disabled={isPatientInfoDisabled || disableAllFields||secondaryInsuranceNameNotListed || getValues('insuranceInfo.secondaryInsuranceNameNotListed')}
                            />
                            </Box>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <FieldLabel label="Plan" required />
                            <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.secondaryInsurancePayerCode)}>
                            <CustomDropdownField
                              control={control}
                              name={`insuranceInfo.${"secondaryInsurancePayerCode"}`}
                              label=""
                              size="small"
                              options={secondaryPayersOptions}
                              sortOptions={false}
                              onChangeSelect={(data) => {
                                if (getValues('insuranceInfo.secondaryInsuranceName')) {

                                  setValue("insuranceInfo.secondaryInsuranceName", data?.label);
                                  setValue("insuranceInfo.secondaryInsurancePayerCode", data?.value);
                                  if (getValues("insuranceInfo.secondaryInsuranceCategory") === "Commercial" && data?.label === "Other") {

                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                    checkInsuranceInfoValidity({ ...watch() });
                                  } else if (getValues("insuranceInfo.secondaryInsuranceCategory") !== "Commercial" && data?.label) {

                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                  } else {

                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                    setValue(`insuranceInfo.${"secondaryCommercialInsuranceName"}`, '');
                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                  }
                                } else {

                                  if (getValues("insuranceInfo.secondaryInsuranceCategory") === "Commercial" && data?.label === "Other") {

                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                    checkInsuranceInfoValidity({ ...watch() });
                                  } else if (getValues("insuranceInfo.secondaryInsuranceCategory") !== "Commercial" && data?.label) {
                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);

                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                  } else {

                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                    setValue(`insuranceInfo.${"secondaryCommercialInsuranceName"}`, '');
                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                    checkInsuranceInfoValidity({ ...watch() });
                                  }
                                }
                              }}
                              rules={{
                                validate: (value: any) => {
                                  if (submitAction === "submitAction" && !getValues("insuranceInfo.secondaryInsuranceName")) {
                                    return "Plan is required.";
                                  }
                                  return true;
                                }
                              }}
                              disabled={!watch('insuranceInfo.secondaryInsuranceCategory')||disableAllFields||isPatientInfoDisabled||secondaryPayersOptions.length ===1||secondaryPayersOptions?.length === 1||secondaryInsuranceNameNotListed||getValues('insuranceInfo.secondaryInsuranceNameNotListed')}
                            />
                            </Box>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <FieldLabel label="Policy #" required />
                            <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.secondaryPolicy)}>
                            <CustomTextField
                              controllerName={`insuranceInfo.${"secondaryPolicy"}`}
                              control={control}
                              label=""
                              size="small"
                              inputProps={{maxLength:watch('insuranceInfo.secondaryInsuranceCategory')==="Medicare" && 11, style: { textTransform: 'uppercase' } }}
                              rules={{ required: "Policy # is required." ,  
                                validate: (value: any) => {
                                  if(!value){
                                    return "Policy # is required.";
                                  }else if (watch('insuranceInfo.secondaryInsuranceCategory') === "Medicare") {
                                    return isValidMedicareMbi(value) ? true : INVALID_MBI_MESSAGE;
                                  }else if(value.includes('-')){
                                      return "Enter an 11-digit number without dashes";
                                  }
                                return true;
                              }}}
                              onChange={(e) => {
                                checkInsuranceInfoValidity({ ...watch() });
                              }}
                              isDisabled={isPatientInfoDisabled || disableAllFields}
                            />
                            </Box>
                          </Grid>
                          {getValues("insuranceInfo.secondaryInsuranceCategory") === "Commercial" && watch("insuranceInfo.secondaryInsuranceName") === "Other" && (
                            <Grid item md={3} xs={12}>
                              <FieldLabel label="Plan" />
                              <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.secondaryCommercialInsuranceName)}>
                                <CustomTextField
                                  controllerName={`insuranceInfo.${"secondaryCommercialInsuranceName"}`}
                                  control={control}
                                  label=""
                                  size="small"
                                  rules={{
                                    validate: (value: any) => {
                                      if (submitAction === "submitAction" && !value) {
                                        return "Plan is required.";
                                      }
                                      return true;
                                    }
                                  }}
                                  onChange={() => { checkInsuranceInfoValidity({ ...watch() }); }}
                                  disabled={isPatientInfoDisabled || disableAllFields}
                                />
                              </Box>
                            </Grid>
                          )}
                          <Grid
                            item
                            md={12}
                            xs={12}
                            sx={{
                              display: {
                                xs: "block",
                                md: "flex",
                              },
                              alignItems: {
                                md: "center",
                              },
                            }}
                          >
                            <Typography sx={inlineLabelSx}>Plan is NOT listed</Typography>
                            <CustomCheckbox
                              control={control}
                              label="Yes"
                              name="secondaryInsuranceNameNotListed"
                              id="secondaryInsuranceNameNotListed"
                              controllerName={`insuranceInfo.${"secondaryInsuranceNameNotListed"}`}
                              checked={secondaryInsuranceNameNotListed}
                              onChange={() => { handleSecondaryInsuranceClick() }}
                              isDisabled={isPatientInfoDisabled || disableAllFields}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Typography sx={inlineLabelSx}>
                              Is the policy under a different name?
                            </Typography>
                            <CustomRadioButton
                              control={control}
                              options={policyOptions}
                              controllerName={`insuranceInfo.${"isSecondaryPolicyUnderDifferentName"}`}
                              onChange={(e) => {
                                onPoliceUnderDifferentNameChanageSecondary(e);
                                checkInsuranceInfoValidity({ ...watch() });
                              }}
                              isDisabled={isPatientInfoDisabled || disableAllFields}
                            />
                          </Grid>
                          {isPolicyUnderDifferentNameCheckSecondary ? (
                            <>
                              <Grid item md={12} xs={12}>
                                <FieldLabel label="Policy Holder" required />
                                <Box sx={textFieldWrapSx(!!(errors?.insuranceInfo?.secondarypolicyholderFirstName || errors?.insuranceInfo?.secondarypolicyholderLastName))}>
                                  <CustomNametField
                                    control={control}
                                    context="secondaryPolicyHolder"
                                    label="Policy Holder"
                                    name="insuranceInfo"
                                    size="small"
                                    usePlaceholder={true}
                                    isRequired={true}
                                    onChange={(e) => {
                                      checkInsuranceInfoValidity({ ...watch() });
                                    }}
                                    isDisabled={isPatientInfoDisabled || disableAllFields}
                                  />
                                </Box>
                              </Grid>

                              <Grid item md={3} xs={12}>
                                <FieldLabel label="Policy Holder DOB" required />
                                <Box sx={dateFieldWrapSx(!!errors?.insuranceInfo?.secondaryPolicyHolderDOB)}>
                                  <CustomDatePicker
                                    control={control}
                                    controllerName={`insuranceInfo.${"secondaryPolicyHolderDOB"}`}
                                    label=""
                                    size="small"
                                    rules={{
                                      required: "Policy Holder DOB is required.",
                                    }}
                                    onChange={(e) => {
                                      checkInsuranceInfoValidity({ ...watch() });
                                    }}
                                    disabled={isPatientInfoDisabled || disableAllFields}
                                  />
                                </Box>
                              </Grid>
                              <Grid item md={12} xs={12}></Grid>
                            </>
                          ) : (
                            ""
                          )}
                          <Grid item md={12} xs={12}>
                            <Grid item md={3} xs={12}>
                              <FieldLabel label="Insurance Cards" required />
                              <Dropzone
                                control={control}
                                name={`insuranceInfo.${"secondaryInsuranceCards"}`}
                                onFileChange={handleSecondaryInsuranceCardChange}
                                label=""
                                onDeleteFile={
                                  handleDeleteSecondaryInsuranceDocument
                                }
                                // initialFiles={secondaryInsCardsInitialFiles}
                                initialFilesMetaData={uploadedSecondaryInsuranceFilesMetaData}
                                isDisabled={isPatientInfoDisabled || disableAllFields}
                                holdOnChange={true}
                                rules={{ required: "Secondary Insurance Cards are required." }}
                              />
                            </Grid>
                            {getValues("insuranceInfo.secondaryInsuranceCards") === undefined || (getValues("insuranceInfo.secondaryInsuranceCards") && getValues("insuranceInfo.secondaryInsuranceCards")?.length === 0) ?
                              <Grid item md={5} xs={12}>
                                <CustomCheckbox
                                  control={control}
                                  label="I acknowledge the information is on file, and not available for upload at this time."
                                  controllerName={`insuranceInfo.${"isSecondaryInsuranceCardsSkipped"}`}
                                  onChange={(e) => {
                                    if (e.target.checked === true) {
                                      clearErrors('insuranceInfo.secondaryInsuranceCards');
                                      const insuranceCardsIds = getValues("insuranceInfo.secondaryInsuranceCards");
                                      const removePromises = insuranceCardsIds.map((id) =>
                                        dispatch(removeIVRDocument(id.toString()))
                                      );
                                      setValue("insuranceInfo.secondaryInsuranceCards", []);
                                      setUploadedSecondaryInsuranceFilesMetaData([]);
                                    } else {
                                      trigger('insuranceInfo.secondaryInsuranceCards');
                                    }
                                    checkInsuranceInfoValidity({ ...watch() });
                                  }}
                                  isDisabled={isPatientInfoDisabled || disableAllFields}
                                />
                              </Grid>
                              : ""}
                          </Grid>
                        </>
                      )}


                    </Grid>
                  </Box>
                </Box>
                </Collapse>
              </Box>

              <Box ref={supportingDocumentationRef} sx={cardSx} data-testid="bordered-section">
                <SectionHeader
                  icon={<AttachFileOutlined fontSize="small" />}
                  title="Supporting Documentation"
                  onHeaderClick={errorOccured ? undefined : () => setSupportingDocsExpanded(!supportingDocsExpanded)}
                  action={
                    errorOccured ? undefined : (
                      <IconButton
                        size="small"
                        aria-label={supportingDocsExpanded ? "Collapse section" : "Expand section"}
                        onClick={(e) => { e.stopPropagation(); setSupportingDocsExpanded(!supportingDocsExpanded); }}
                        sx={collapseToggleSx}
                      >
                        {supportingDocsExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                      </IconButton>
                    )
                  }
                />
                <Collapse in={errorOccured || supportingDocsExpanded}>
                <Box sx={sectionBodySx}>
                  <Grid container spacing={2} alignItems="flex-start">
                    <Grid item md={6} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                          <FieldLabel label="Medical Notes" required />
                          <Dropzone
                            control={control}
                            name={`supportingDocumentation.${"supportingDocuments"}`}
                            rules={{
                              required: "Supporting Documents are required.",
                            }}
                            onFileChange={handleSupportingDocsChange}
                            label=""
                            onDeleteFile={handleDeleteSupportingDocument}
                            // initialFiles={supportingDocsInitialFiles}
                            initialFilesMetaData={uploadedSupportingDocumentFilesMetaData}
                            holdOnChange={true}
                            isDisabled={disableAllFields}
                          />
                        </Grid>
                        <Grid item md={12} xs={12}>
                          {getValues("supportingDocumentation.supportingDocuments") && getValues("supportingDocumentation.supportingDocuments").length === 0 ?
                            <CustomCheckbox
                              control={control}
                              label="I acknowledge the information is on file, and not available for upload at this time."
                              controllerName={`supportingDocumentation.${"isSupportingDocumentsSkipped"}`}
                              onChange={(e) => {
                                if (e.target.checked === true) {
                                  clearErrors("supportingDocumentation.supportingDocuments");
                                  const supportingDocsIds = getValues("supportingDocumentation.supportingDocuments");
                                  const removePromises = supportingDocsIds.map((id) =>
                                    dispatch(removeIVRDocument(id.toString()))
                                  );
                                  setValue("supportingDocumentation.supportingDocuments", []);
                                  setUploadedSupportingDocumentFilesMetaData([]);
                                } else {
                                  trigger("supportingDocumentation.supportingDocuments");
                                }
                                checkSupportingDocumentationValidity({ ...watch() });
                              }}
                              isDisabled={disableAllFields}
                            />
                            : ""}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                          <FieldLabel label="Images of Wounds" required />
                          <Dropzone
                            control={control}
                            name={`supportingDocumentation.${"imageOfWounds"}`}
                            rules={{ required: "Image of Wounds are required." }}
                            onFileChange={handleImageOfWoundsChange}
                            label=""
                            onDeleteFile={handleDeleteImageOfWoundsDocument}
                            // initialFiles={imagesOfWoundsInitialFiles}
                            initialFilesMetaData={uploadedWoundImageFilesMetaData}
                            holdOnChange={true}
                            isDisabled={disableAllFields}
                          />
                        </Grid>
                        <Grid item md={12} xs={12}>
                          {getValues("supportingDocumentation.imageOfWounds") && getValues("supportingDocumentation.imageOfWounds").length === 0 ?
                            <CustomCheckbox
                              control={control}
                              label="I acknowledge the information is on file, and not available for upload at this time."
                              controllerName={`supportingDocumentation.${"isImageOfWoundsSkipped"}`}
                              onChange={(e) => {
                                if (e.target.checked === true) {
                                  clearErrors("supportingDocumentation.imageOfWounds");
                                  const imageOfWoundsIds = getValues("supportingDocumentation.imageOfWounds");
                                  const removePromises = imageOfWoundsIds.map((id) =>
                                    dispatch(removeIVRDocument(id.toString()))
                                  );
                                  setValue("supportingDocumentation.imageOfWounds", []);
                                  setUploadedWoundImageFilesMetaData([]);
                                } else {
                                  trigger("supportingDocumentation.imageOfWounds");
                                }
                                checkSupportingDocumentationValidity({ ...watch() });
                              }}
                              isDisabled={disableAllFields}
                            />
                            : ""}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
                </Collapse>
              </Box>

              <Box ref={woundDataRef} sx={cardSx} data-testid="bordered-section">
                <SectionHeader
                  icon={<ContentPasteOutlined fontSize="small" />}
                  title="Data"
                  action={
                    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                      {practiceObject?.specialization !== PRACTICE_TYPE.SURGICAL && (
                        <Button
                          variant="outlined"
                          removeUpperCase
                          startIcon={<AddCircleOutlineOutlined />}
                          onClick={() => clickShowWoundInfoPopup()}
                          disabled={disableAllFields}
                          sx={sectionActionBtnSx(!!errors?.woundInfo?.woundData && !((getValues("woundInfo.woundData")?.length ?? 0) > 0))}
                        >
                          Add Wound
                        </Button>
                      )}
                      {(practiceObject?.specialization === PRACTICE_TYPE.SURGICAL || practiceObject?.specialization === PRACTICE_TYPE.WOUND_CARE_AND_SURGICAL) && (
                        <Button
                          variant="outlined"
                          removeUpperCase
                          startIcon={<AddCircleOutlineOutlined />}
                          onClick={() => clickShowIncisionInfoPopup()}
                          disabled={disableAllFields}
                          sx={sectionActionBtnSx(!!errors?.woundInfo?.woundData && !((getValues("woundInfo.woundData")?.length ?? 0) > 0))}
                        >
                          Add Incision
                        </Button>
                      )}
                    </Box>
                  }
                />
                <Box sx={sectionBodySx}>
                  <Grid container spacing={2}>
                    <Controller
                      name={`woundInfo.woundData`}
                      control={control}
                      rules={{
                        validate: (value: any) => {
                          if (submitAction === "submitAction" && value.length === 0) {
                            return "At least 1 wound information is required.";
                          }
                          return true;
                        }
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <>
                            {fieldState.error && (
                              <Typography
                                color="error"
                                variant="body2"
                                style={{ marginTop: "1px", marginLeft: "15px" }}
                              >
                                {fieldState.error.message}
                              </Typography>
                            )}

                            <Grid item md={12} xs={12} key={selectedWoundList.join(',')}>
                              {/* <LegacyToolBar items={legacyItems}/> */}
                              <CustomTable
                                columns={woundInfoTableColumns}
                                rows={woundInfoTableRows}
                                actionComponent={(row: any, rowIndex: number) =>
                                  woundInfoActionComponent(row, rowIndex)
                                }
                                disablePagination={true}
                                showMenu={true}
                                sx={woundTableWrapSx}
                              />
                            </Grid>
                          </>
                        );
                      }}
                    />
                    <Grid item md={2} xs={12}>
                      <FieldLabel label="Total Volume of All Wounds (cm³)" required />
                      <Box sx={textFieldWrapSx(!!errors?.woundInfo?.totalSizeOfAllWounds)}>
                        <CustomTextField
                          controllerName={`woundInfo.${"totalSizeOfAllWounds"}`}
                          control={control}
                          label=""
                          size="small"
                          isNumberOnly={true}
                          rules={{
                            required: "Total Volume of all wounds is required.",
                            min: { value: 0.01, message: "Total Volume of all wounds must be greater than 0." },
                          }}
                          onChange={(e) => {
                            checkWoundInfoValidity({ ...watch() });
                          }}
                          isDisabled={disableAllFields}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              {/* Product Questions Component */}
              {productQuestions?.length > 0 && (
                <Box sx={cardSx} data-testid="bordered-section">
                  <SectionHeader
                    icon={<QuizOutlined fontSize="small" />}
                    title={`Question(s) - ${selectedProducts[0]?.productName || ""}`}
                  />
                  <Box sx={sectionBodySx}>
                    <QuestionComponent
                      key={checkedWoundData?.length}
                      namePrefix="productQuestions"
                      productName={selectedProducts[0]?.productName || ""}
                      woundData={checkedWoundData}
                      productQuestions={productQuestions}
                      control={control}
                      getValues={getValues}
                      setValue={setValue}
                      watch={watch}
                      isDisabled={disableAllFields}
                      autoSelectSafeguard={shouldSelectSafeguard()}
                    />
                  </Box>
                </Box>
              )}
              {/* Safeguard Questions Component */}
              {safeguardQuestions?.length > 0 && (
                <Box sx={cardSx} data-testid="bordered-section">
                  <SectionHeader
                    icon={<HelpOutlineOutlined fontSize="small" />}
                    title={`Safeguard Question(s) - ${selectedProducts[0]?.productName || ""}`}
                  />
                  <Box sx={sectionBodySx}>
                    <QuestionComponent
                      key={watch('safeguardQuestions')}
                      namePrefix="safeguardQuestions"
                      productName={selectedProducts[0]?.productName || ""}
                      productQuestions={safeguardQuestions}
                      control={control}
                      getValues={getValues}
                      setValue={setValue}
                      watch={watch}
                      isDisabled={disableAllFields}
                      autoSelectSafeguard={shouldSelectSafeguard()}
                    />
                  </Box>
                </Box>
              )}
              {/* CS-1728 - Replacing static label to dynamic constant */}
              {!(safeguardQuestions?.length > 0) && selectedProductCategory === PRODUCT_CATEGORY.CONSERVATIVE &&
              selectedProducts &&
              selectedProducts.length > 0 &&
              selectedProducts[0].productSizes &&
              selectedProducts[0].productSizes.length > 0  &&(
              <Box ref={safeguardQuestionsRef} sx={cardSx} data-testid="bordered-section">
              <SectionHeader
                icon={<HelpOutlineOutlined fontSize="small" />}
                title={`Safeguard Questions - ${selectedProducts[0]?.productName}`}
              />
              <Box sx={sectionBodySx}>
              <Grid
                item
                xs={12}
                sx={{
                  display: { xs: "block", md: "flex" },
                  alignItems: "center",
                }}
              >
                <Typography sx={{ ...inlineLabelSx, display: "flex", alignItems: "center", gap: 0.4 }}>
                  Is this patient currently receiving home health?
                  <Box component="span" sx={{ color: mTokens.accent }}>*</Box>
                </Typography>
                <CustomRadioButton
                  control={control}
                  controllerName="treatmentInformation.homeHealth"
                  options={[
                    { value: "Yes", label: "Yes" },
                    { value: "No", label: "No" },
                  ]}
                  rules={{ required: "Please select the option" }}
                  onChange={(e) =>
                    handleSafeguard(
                      "treatmentInformation.homeHealth",
                      e.target.value
                    )
                  }
                  isDisabled={disableAllFields}
                />
              </Grid>
              {shouldShowWarning && ( 
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: { xs: "block", md: "flex" },
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ mr: 2.5, color: mTokens.error, fontWeight: 700, fontSize: "0.85rem" }}>
                    🚫 STOP: The patient does not meet the required criteria for Home (12).
                  </Typography>
                </Grid>
              )}
              </Box>
              </Box>
              )}
              <Box sx={cardSx} data-testid="bordered-section">
                <SectionHeader icon={<StickyNote2Outlined fontSize="small" />} title="Additional Notes" />
                <Box sx={sectionBodySx}>
                  <Grid container spacing={2}>
                    <Grid item md={12} xs={12}>
                      <FieldLabel label="Additional notes/comments" />
                      <Box sx={textFieldWrapSx(!!errors?.comments)}>
                        <CustomTextField
                          controllerName="comments"
                          control={control}
                          label=""
                          fullWidth
                          multiline
                          rows={4}
                          maxRows={4}
                          isDisabled={disableAllFields}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                gap={1.2}
                justifyContent="flex-end"
                mt={0.5} mb={2}
              >
                <Button
                  startIcon={<SaveOutlined />}
                  type="submit"
                  variant="outlined"
                  removeUpperCase
                  onClick={() => setSubmitAction("saveAction")}
                  disabled={disableAllFields}
                  data-allow-submit="true"
                  fullWidth
                  sx={{
                    ...cancelBtnSx,
                    color: mTokens.accent,
                    borderColor: `${mTokens.accent}8c`,
                    backgroundColor: isDarkModal ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
                    minWidth: { sm: 160 },
                    width: { xs: "100%", sm: "auto" },
                    "&:hover": {
                      color: "#fff",
                      borderColor: mTokens.accent,
                      backgroundColor: mTokens.accent,
                      boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
                    },
                    "& .MuiTypography-root": { color: "inherit", fontWeight: 700 },
                    "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
                  }}
                >
                  Save As Draft
                </Button>
                <Button
                  type="submit"
                  removeUpperCase
                  onClick={() => setSubmitAction("submitAction")}
                  startIcon={<ExitToApp />}
                  disabled={disableAllFields || shouldShowWarning}
                  data-allow-submit="true"
                  fullWidth
                  sx={{
                    ...primaryBtnSx,
                    minWidth: { sm: 160 },
                    width: { xs: "100%", sm: "auto" },
                    "& .MuiTypography-root": { color: "#fff", fontWeight: 700 },
                    "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "#fff" },
                  }}
                >
                  Submit
                </Button>
                <Button
                  variant="outlined"
                  removeUpperCase
                  onClick={onCancelClick}
                  startIcon={<ArrowBack />}
                  fullWidth
                  sx={{
                    ...backBtnSx,
                    minWidth: { sm: 140 },
                    width: { xs: "100%", sm: "auto" },
                    "& .MuiTypography-root": { color: "inherit", fontWeight: 700 },
                    "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
                  }}
                >
                  Back
                </Button>
              </Box>
            </Box>
          </form>
      </Box>
      <CustomAlert
        open={showErrorAlert}
        onClose={() => setShowErrorAlert(false)}
        severity="info"
        message="Feature currently under development. Stay tuned for updates!"
      />
      <OptionsPopup
        open={optionPopupShow.show}
        onClose={() => setOptionPopupShow({ message: "", show: false })}
        variant="confirm"
        message={<>{optionPopupShow.message}</>}
        buttons={[
          { name: "Confirm", color: "primary", onClick: confirmOptionPopup },
          { name: "Cancel", color: "secondary", onClick: cancelOptionPopup },
        ]}
      />
      {showSignatureSubmitPopup && <SigantureSubmitPopup
        open={showSignatureSubmitPopup}
        onClose={() => { setShowSignatureSubmitPopup(false); }}
        addProductItem={() => { }}
        productItemDetails={{}}
        isEdit={false}
        practiceName={practiceObject?.practiceName}
        selectedProviderData={selectedProviderData}
        addSignature={handleSignatureData}
        from="IVR"
      />}
      {showOptionPopup.show &&
        <OptionsPopup
          open={showOptionPopup.show}
          onClose={() => {
            setShowOptionsPopup({ message: "", show: false })
             if(showOptionPopup.variant==="error"){
              setHasHardStop(true)
            }
            }
          }
          variant={showOptionPopup.variant}
          message={<>{showOptionPopup.message}</>}
          buttons={showOptionPopup.buttons}
          title={showOptionPopup.title}
          obj={showOptionPopup.obj}
        />
      }
      {showProductItemSelectPopup && (
        <ProductItemSelectPopup
          open={showProductItemSelectPopup}
          onClose={() => {
            setProductKitOptions([]);
            setValue("treatmentInformation.practiceProductId", 0);
            setShowProductItemSelectPopup(false);
          }}
          productOptions={productKitOptions}
          onSelectItem={async (selectedItem) => {
            setShowProductItemSelectPopup(false);
            setProductKitOptions([]);

            if (Array.isArray(selectedItem)) {
              setKitItemData(selectedItem);
            } else {
              setSelectedProducts(prevProducts => {
                const currentProduct = prevProducts[0];
                if (!currentProduct) return prevProducts;

                const updatedProduct = {
                  ...currentProduct,
                  productKitItemId: selectedItem.id,
                };

                const updatedProducts = [updatedProduct];
                setValue("treatmentInformation.products", updatedProducts);
                return updatedProducts;
              });

              const response = await dispatch(getProductItemkitItem({ productItemId: selectedItem.id, skipLoader: false }));
              setKitItemData(response.payload.data);
            }
          }}
          multiSelect={mutiSelectProductItems}
        />
      )}
    </>
  );
};

export default IVRForm;
